var zn = Object.defineProperty;
var Hn = (e, t, l) => t in e ? zn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: l }) : e[t] = l;
var Fe = (e, t, l) => (Hn(e, typeof t != "symbol" ? t + "" : t, l), l);
import { unref as g, computed as C, ref as M, shallowRef as Pa, watch as se, getCurrentScope as Xl, onScopeDispose as Kl, shallowReadonly as St, watchEffect as Ot, readonly as He, effectScope as Jl, isRef as La, toRef as P, customRef as Rn, getCurrentInstance as Ft, onMounted as Ye, nextTick as Te, reactive as It, defineComponent as R, h as ye, Teleport as sa, toValue as nt, onActivated as xn, onBeforeUnmount as Ia, openBlock as p, createElementBlock as E, Fragment as fe, createElementVNode as Z, renderSlot as A, createVNode as be, withCtx as D, mergeProps as ae, normalizeClass as H, normalizeStyle as Re, createTextVNode as re, toDisplayString as J, createCommentVNode as K, createApp as Mn, provide as We, createBlock as x, resolveDynamicComponent as oe, inject as Pe, Transition as Dn, normalizeProps as _e, guardReactiveProps as Ee, useSlots as Oe, useAttrs as Yl, renderList as he, TransitionGroup as jn, withDirectives as ft, vShow as ra, withModifiers as za, vModelCheckbox as qn, vModelRadio as Gn, vModelSelect as Wn, createSlots as Ha } from "vue";
const Zl = (e) => typeof e == "boolean" || e === "" || e === "true" || e === "false", ia = (e) => typeof e == "boolean" ? e : e === "" || e === "true";
class at {
  constructor(t, l = {}) {
    Fe(this, "cancelable", !0);
    Fe(this, "componentId", null);
    Fe(this, "_defaultPrevented", !1);
    Fe(this, "eventType", "");
    Fe(this, "nativeEvent", null);
    Fe(this, "_preventDefault");
    Fe(this, "relatedTarget", null);
    Fe(this, "target", null);
    if (!t)
      throw new TypeError(
        `Failed to construct '${this.constructor.name}'. 1 argument required, ${arguments.length} given.`
      );
    Object.assign(this, at.Defaults, l, { eventType: t }), this._preventDefault = function() {
      this.cancelable && (this.defaultPrevented = !0);
    };
  }
  // Readable by everyone,
  // But only overwritten by inherrited constructors
  get defaultPrevented() {
    return this._defaultPrevented;
  }
  set defaultPrevented(t) {
    this._defaultPrevented = t;
  }
  // I think this is right
  // We want to be able to have it callable to everyone,
  // But only overwritten by inherrited constructors
  get preventDefault() {
    return this._preventDefault;
  }
  // This may not be correct, because it doesn't get correct type inferences in children
  // Ex overwrite this.preventDefault = () => true is valid. Could be a TS issue
  set preventDefault(t) {
    this._preventDefault = t;
  }
  static get Defaults() {
    return {
      cancelable: !0,
      componentId: null,
      eventType: "",
      nativeEvent: null,
      relatedTarget: null,
      target: null
    };
  }
}
class Et extends at {
  constructor(l, a = {}) {
    super(l, a);
    Fe(this, "trigger", null);
    Object.assign(this, at.Defaults, a, { eventType: l });
  }
  static get Defaults() {
    return {
      ...super.Defaults,
      trigger: null
    };
  }
}
class Ql extends at {
  constructor(l, a) {
    super(l, a);
    Fe(this, "from");
    Fe(this, "to");
    Fe(this, "direction");
    Object.assign(this, at.Defaults, a, { eventType: l });
    const { from: o, direction: n, to: s } = a;
    this.from = o, this.to = s, this.direction = n;
  }
  static get Defaults() {
    return {
      ...super.Defaults
    };
  }
}
const Sa = (e) => e !== null && typeof e == "object", Un = (e) => /^[0-9]*\.?[0-9]+$/.test(String(e)), Xn = (e) => Object.prototype.toString.call(e) === "[object Object]", eo = /_/g, to = /([a-z])([A-Z])/g, Kn = /(\s|^)(\w)/g, Jn = /(\s|^)(\w)/, Xt = /\s+/, Yn = /^#/, Zn = /^#[A-Za-z]+[\w\-:.]*$/, Qn = /-u-.+/, es = /[-/\\^$*+?.()|[\]{}]/g, ts = /[\s\uFEFF\xA0]+/g, Yt = (e, t = 2) => typeof e == "string" ? e : e == null ? "" : Array.isArray(e) || Xn(e) && e.toString === Object.prototype.toString ? JSON.stringify(e, null, t) : String(e), rl = (e) => e.replace(eo, " ").replace(to, (t, l, a) => `${l} ${a}`).replace(Jn, (t, l, a) => l + a.toUpperCase()), il = (e) => e.replace(eo, " ").replace(to, (t, l, a) => `${l} ${a}`).replace(Kn, (t, l, a) => l + a.toUpperCase()), as = (e) => {
  const t = e.trim();
  return t.charAt(0).toUpperCase() + t.slice(1);
}, ls = (e) => e.replace(es, "\\$&"), os = (e) => ls(e).replace(ts, "\\s"), ya = (e) => `\\${e}`, ns = (e) => {
  const t = Yt(e), { length: l } = t, a = t.charCodeAt(0);
  return t.split("").reduce((o, n, s) => {
    const r = t.charCodeAt(s);
    return r === 0 ? `${o}�` : (
      // ... is U+007F OR
      r === 127 || // ... is in the range [\1-\1F] (U+0001 to U+001F) OR ...
      r >= 1 && r <= 31 || // ... is the first character and is in the range [0-9] (U+0030 to U+0039) OR ...
      s === 0 && r >= 48 && r <= 57 || // ... is the second character and is in the range [0-9] (U+0030 to U+0039)
      // and the first character is a `-` (U+002D) ...
      s === 1 && r >= 48 && r <= 57 && a === 45 ? o + ya(`${r.toString(16)} `) : (
        // ... is the first character AND ...
        s === 0 && // ... is a `-` (U+002D) AND ...
        r === 45 && // ... there is no second character ...
        l === 1 ? o + ya(n) : (
          // ... is greater than or equal to U+0080 OR ...
          r >= 128 || // ... is `-` (U+002D) OR ...
          r === 45 || // ... is `_` (U+005F) OR ...
          r === 95 || // ... is in the range [0-9] (U+0030 to U+0039) OR ...
          r >= 48 && r <= 57 || // ... is in the range [A-Z] (U+0041 to U+005A) OR ...
          r >= 65 && r <= 90 || // ... is in the range [a-z] (U+0061 to U+007A) ...
          r >= 97 && r <= 122 ? o + n : o + ya(n)
        )
      )
    );
  }, "");
}, ao = typeof window < "u", lo = typeof document < "u", ss = typeof Element < "u", rs = typeof navigator < "u", is = ao && lo && rs, ul = ao ? window : {}, Ra = lo ? document : {};
(() => {
  let e = !1;
  if (is)
    try {
      const t = {
        // This function will be called when the browser
        // attempts to access the passive property
        get passive() {
          return e = !0, e;
        }
      };
      ul.addEventListener("test", t, t), ul.removeEventListener("test", t, t);
    } catch {
      e = !1;
    }
  return e;
})();
const oo = typeof window < "u", us = typeof document < "u", ds = typeof navigator < "u", xa = oo && us && ds, dl = oo ? window : {}, cs = (() => {
  let e = !1;
  if (xa)
    try {
      const t = {
        // This function will be called when the browser
        // attempts to access the passive property
        get passive() {
          e = !0;
        }
      };
      dl.addEventListener("test", t, t), dl.removeEventListener("test", t, t);
    } catch {
      e = !1;
    }
  return e;
})(), Ie = ss ? Element.prototype : void 0, fs = (Ie == null ? void 0 : Ie.matches) || (Ie == null ? void 0 : Ie.msMatchesSelector) || (Ie == null ? void 0 : Ie.webkitMatchesSelector), Ze = (e) => !!(e && e.nodeType === Node.ELEMENT_NODE), vs = (e) => Ze(e) ? e.getBoundingClientRect() : null, ps = (e = []) => {
  const { activeElement: t } = document;
  return t && !e.some((l) => l === t) ? t : null;
}, ms = (e) => Ze(e) && e === ps(), gs = (e, t = {}) => {
  try {
    e.focus(t);
  } catch (l) {
    console.error(l);
  }
  return ms(e);
}, ys = (e, t) => t && Ze(e) && e.getAttribute(t) || null, bs = (e) => {
  if (ys(e, "display") === "none")
    return !1;
  const t = vs(e);
  return !!(t && t.height > 0 && t.width > 0);
}, Ve = (e) => ((e == null ? void 0 : e()) ?? []).length === 0, no = (e, t) => (Ze(t) ? t : Ra).querySelector(e) || null, hs = (e, t) => Array.from([(Ze(t) ? t : Ra).querySelectorAll(e)]), Ma = (e, t) => t && Ze(e) ? e.getAttribute(t) : null, Bs = (e) => Ra.getElementById(/^#/.test(e) ? e.slice(1) : e) || null, Ss = (e, t, l) => {
  t && Ze(e) && e.setAttribute(t, l);
}, ws = (e, t) => {
  t && Ze(e) && e.removeAttribute(t);
}, Cs = (e, t) => Yt(e).toLowerCase() === Yt(t).toLowerCase(), so = (e, t) => Ze(e) ? fs.call(e, t) : !1, ks = (Ie == null ? void 0 : Ie.closest) || function(e) {
  let t = this;
  if (!t)
    return null;
  do {
    if (so(t, e))
      return t;
    t = t.parentElement || t.parentNode;
  } while (t !== null && t.nodeType === Node.ELEMENT_NODE);
  return null;
}, cl = (e, t, l = !1) => {
  if (!Ze(t))
    return null;
  const a = ks.call(t, e);
  return l ? a : a === t ? null : a;
}, wa = (e) => {
  const t = window.getComputedStyle(e), l = t.transitionDelay.split(",")[0] || "", a = t.transitionDuration.split(",")[0] || "", o = Number(l.slice(0, -1)) * 1e3, n = Number(a.slice(0, -1)) * 1e3;
  return o + n;
}, ua = (e, t, l) => t.concat(["sm", "md", "lg", "xl", "xxl"]).reduce((a, o) => (a[e ? `${e}${o.charAt(0).toUpperCase() + o.slice(1)}` : o] = l, a), /* @__PURE__ */ Object.create(null)), ro = (e, t, l, a = l) => Object.keys(t).reduce((o, n) => (e[n] && o.push(
  [a, n.replace(l, ""), e[n]].filter((s) => s && typeof s != "boolean").join("-").toLowerCase()
), o), []), pt = (e = "") => `__BVID__${Math.random().toString().slice(2, 8)}___BV_${e}__`, $s = (e) => !!(e.href || e.to), et = (e, t = {}, l = {}) => {
  const a = [e];
  let o;
  for (let n = 0; n < a.length && !o; n++) {
    const s = a[n];
    o = l[s];
  }
  return o && typeof o == "function" ? o(t) : o;
}, mt = (e, t = NaN) => Number.isInteger(e) ? e : t, _s = (e, t = NaN) => {
  const l = Number.parseInt(e, 10);
  return Number.isNaN(l) ? t : l;
}, Kt = (e, t = NaN) => {
  const l = Number.parseFloat(e.toString());
  return Number.isNaN(l) ? t : l;
}, io = (e, t) => Object.keys(e).filter((l) => !t.map((a) => a.toString()).includes(l)).reduce((l, a) => ({ ...l, [a]: e[a] }), {}), Da = (e, t) => [...t].reduce(
  (l, a) => (l[a] = e[a], l),
  {}
), fl = (e, t, l) => {
  const a = t.split(/[.[\]]/g);
  let o = e;
  for (const n of a) {
    if (o === null || o === void 0)
      return l;
    n.trim() !== "" && (o = o[n]);
  }
  return o === void 0 ? l : o;
}, vl = (e, t) => t + (e ? as(e) : ""), da = (e, t) => e === !0 || e === "true" || e === "" ? "true" : e === "grammar" || e === "spelling" ? e : t === !1 ? "true" : e === !1 || e === "false" ? "false" : void 0, uo = Symbol("carousel"), co = Symbol("tabs"), fo = Symbol("progress"), vo = Symbol("listGroup"), po = Symbol("avatarGroup"), mo = Symbol("accordion"), go = Symbol("checkboxGroup"), yo = Symbol("radioGroup"), ja = Symbol("collapse"), bo = Symbol("collapse"), qa = Symbol("navbar"), Ca = (e, t) => ((e == null ? void 0 : e()) ?? []).reduce((l, a) => (typeof a.type == "symbol" ? l = l.concat(a.children) : l.push(a), l), []).filter((l) => {
  var a;
  return ((a = l.type) == null ? void 0 : a.__name) === t;
}), ho = ["top", "right", "bottom", "left"], pl = ["start", "end"], ml = /* @__PURE__ */ ho.reduce((e, t) => e.concat(t, t + "-" + pl[0], t + "-" + pl[1]), []), lt = Math.min, Xe = Math.max, Zt = Math.round, jt = Math.floor, ut = (e) => ({
  x: e,
  y: e
}), Ts = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Vs = {
  start: "end",
  end: "start"
};
function ka(e, t, l) {
  return Xe(e, lt(t, l));
}
function vt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function qe(e) {
  return e.split("-")[0];
}
function Ke(e) {
  return e.split("-")[1];
}
function Bo(e) {
  return e === "x" ? "y" : "x";
}
function Ga(e) {
  return e === "y" ? "height" : "width";
}
function Rt(e) {
  return ["top", "bottom"].includes(qe(e)) ? "y" : "x";
}
function Wa(e) {
  return Bo(Rt(e));
}
function So(e, t, l) {
  l === void 0 && (l = !1);
  const a = Ke(e), o = Wa(e), n = Ga(o);
  let s = o === "x" ? a === (l ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return t.reference[n] > t.floating[n] && (s = ea(s)), [s, ea(s)];
}
function As(e) {
  const t = ea(e);
  return [Qt(e), t, Qt(t)];
}
function Qt(e) {
  return e.replace(/start|end/g, (t) => Vs[t]);
}
function Os(e, t, l) {
  const a = ["left", "right"], o = ["right", "left"], n = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return l ? t ? o : a : t ? a : o;
    case "left":
    case "right":
      return t ? n : s;
    default:
      return [];
  }
}
function Fs(e, t, l, a) {
  const o = Ke(e);
  let n = Os(qe(e), l === "start", a);
  return o && (n = n.map((s) => s + "-" + o), t && (n = n.concat(n.map(Qt)))), n;
}
function ea(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Ts[t]);
}
function Es(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Ua(e) {
  return typeof e != "number" ? Es(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Tt(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function gl(e, t, l) {
  let {
    reference: a,
    floating: o
  } = e;
  const n = Rt(t), s = Wa(t), r = Ga(s), i = qe(t), d = n === "y", y = a.x + a.width / 2 - o.width / 2, b = a.y + a.height / 2 - o.height / 2, c = a[r] / 2 - o[r] / 2;
  let h;
  switch (i) {
    case "top":
      h = {
        x: y,
        y: a.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: y,
        y: a.y + a.height
      };
      break;
    case "right":
      h = {
        x: a.x + a.width,
        y: b
      };
      break;
    case "left":
      h = {
        x: a.x - o.width,
        y: b
      };
      break;
    default:
      h = {
        x: a.x,
        y: a.y
      };
  }
  switch (Ke(t)) {
    case "start":
      h[s] -= c * (l && d ? -1 : 1);
      break;
    case "end":
      h[s] += c * (l && d ? -1 : 1);
      break;
  }
  return h;
}
const Ns = async (e, t, l) => {
  const {
    placement: a = "bottom",
    strategy: o = "absolute",
    middleware: n = [],
    platform: s
  } = l, r = n.filter(Boolean), i = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let d = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: y,
    y: b
  } = gl(d, a, i), c = a, h = {}, S = 0;
  for (let B = 0; B < r.length; B++) {
    const {
      name: F,
      fn: w
    } = r[B], {
      x: V,
      y: T,
      data: $,
      reset: m
    } = await w({
      x: y,
      y: b,
      initialPlacement: a,
      placement: c,
      strategy: o,
      middlewareData: h,
      rects: d,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (y = V ?? y, b = T ?? b, h = {
      ...h,
      [F]: {
        ...h[F],
        ...$
      }
    }, m && S <= 50) {
      S++, typeof m == "object" && (m.placement && (c = m.placement), m.rects && (d = m.rects === !0 ? await s.getElementRects({
        reference: e,
        floating: t,
        strategy: o
      }) : m.rects), {
        x: y,
        y: b
      } = gl(d, c, i)), B = -1;
      continue;
    }
  }
  return {
    x: y,
    y: b,
    placement: c,
    strategy: o,
    middlewareData: h
  };
};
async function zt(e, t) {
  var l;
  t === void 0 && (t = {});
  const {
    x: a,
    y: o,
    platform: n,
    rects: s,
    elements: r,
    strategy: i
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: y = "viewport",
    elementContext: b = "floating",
    altBoundary: c = !1,
    padding: h = 0
  } = vt(t, e), S = Ua(h), F = r[c ? b === "floating" ? "reference" : "floating" : b], w = Tt(await n.getClippingRect({
    element: (l = await (n.isElement == null ? void 0 : n.isElement(F))) == null || l ? F : F.contextElement || await (n.getDocumentElement == null ? void 0 : n.getDocumentElement(r.floating)),
    boundary: d,
    rootBoundary: y,
    strategy: i
  })), V = b === "floating" ? {
    ...s.floating,
    x: a,
    y: o
  } : s.reference, T = await (n.getOffsetParent == null ? void 0 : n.getOffsetParent(r.floating)), $ = await (n.isElement == null ? void 0 : n.isElement(T)) ? await (n.getScale == null ? void 0 : n.getScale(T)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, m = Tt(n.convertOffsetParentRelativeRectToViewportRelativeRect ? await n.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: V,
    offsetParent: T,
    strategy: i
  }) : V);
  return {
    top: (w.top - m.top + S.top) / $.y,
    bottom: (m.bottom - w.bottom + S.bottom) / $.y,
    left: (w.left - m.left + S.left) / $.x,
    right: (m.right - w.right + S.right) / $.x
  };
}
const Ps = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: l,
      y: a,
      placement: o,
      rects: n,
      platform: s,
      elements: r
    } = t, {
      element: i,
      padding: d = 0
    } = vt(e, t) || {};
    if (i == null)
      return {};
    const y = Ua(d), b = {
      x: l,
      y: a
    }, c = Wa(o), h = Ga(c), S = await s.getDimensions(i), B = c === "y", F = B ? "top" : "left", w = B ? "bottom" : "right", V = B ? "clientHeight" : "clientWidth", T = n.reference[h] + n.reference[c] - b[c] - n.floating[h], $ = b[c] - n.reference[c], m = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(i));
    let k = m ? m[V] : 0;
    (!k || !await (s.isElement == null ? void 0 : s.isElement(m))) && (k = r.floating[V] || n.floating[h]);
    const f = T / 2 - $ / 2, _ = k / 2 - S[h] / 2 - 1, L = lt(y[F], _), v = lt(y[w], _), I = L, z = k - S[h] - v, O = k / 2 - S[h] / 2 + f, q = ka(I, O, z), U = Ke(o) != null && O != q && n.reference[h] / 2 - (O < I ? L : v) - S[h] / 2 < 0 ? O < I ? I - O : z - O : 0;
    return {
      [c]: b[c] - U,
      data: {
        [c]: q,
        centerOffset: O - q + U
      }
    };
  }
});
function Ls(e, t, l) {
  return (e ? [...l.filter((o) => Ke(o) === e), ...l.filter((o) => Ke(o) !== e)] : l.filter((o) => qe(o) === o)).filter((o) => e ? Ke(o) === e || (t ? Qt(o) !== o : !1) : !0);
}
const Is = function(e) {
  return e === void 0 && (e = {}), {
    name: "autoPlacement",
    options: e,
    async fn(t) {
      var l, a, o;
      const {
        rects: n,
        middlewareData: s,
        placement: r,
        platform: i,
        elements: d
      } = t, {
        crossAxis: y = !1,
        alignment: b,
        allowedPlacements: c = ml,
        autoAlignment: h = !0,
        ...S
      } = vt(e, t), B = b !== void 0 || c === ml ? Ls(b || null, h, c) : c, F = await zt(t, S), w = ((l = s.autoPlacement) == null ? void 0 : l.index) || 0, V = B[w];
      if (V == null)
        return {};
      const T = So(V, n, await (i.isRTL == null ? void 0 : i.isRTL(d.floating)));
      if (r !== V)
        return {
          reset: {
            placement: B[0]
          }
        };
      const $ = [F[qe(V)], F[T[0]], F[T[1]]], m = [...((a = s.autoPlacement) == null ? void 0 : a.overflows) || [], {
        placement: V,
        overflows: $
      }], k = B[w + 1];
      if (k)
        return {
          data: {
            index: w + 1,
            overflows: m
          },
          reset: {
            placement: k
          }
        };
      const f = m.map((v) => {
        const I = Ke(v.placement);
        return [v.placement, I && y ? (
          // Check along the mainAxis and main crossAxis side.
          v.overflows.slice(0, 2).reduce((z, O) => z + O, 0)
        ) : (
          // Check only the mainAxis.
          v.overflows[0]
        ), v.overflows];
      }).sort((v, I) => v[1] - I[1]), L = ((o = f.filter((v) => v[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        Ke(v[0]) ? 2 : 3
      ).every((I) => I <= 0))[0]) == null ? void 0 : o[0]) || f[0][0];
      return L !== r ? {
        data: {
          index: w + 1,
          overflows: m
        },
        reset: {
          placement: L
        }
      } : {};
    }
  };
}, wo = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var l;
      const {
        placement: a,
        middlewareData: o,
        rects: n,
        initialPlacement: s,
        platform: r,
        elements: i
      } = t, {
        mainAxis: d = !0,
        crossAxis: y = !0,
        fallbackPlacements: b,
        fallbackStrategy: c = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: S = !0,
        ...B
      } = vt(e, t), F = qe(a), w = qe(s) === s, V = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), T = b || (w || !S ? [ea(s)] : As(s));
      !b && h !== "none" && T.push(...Fs(s, S, h, V));
      const $ = [s, ...T], m = await zt(t, B), k = [];
      let f = ((l = o.flip) == null ? void 0 : l.overflows) || [];
      if (d && k.push(m[F]), y) {
        const I = So(a, n, V);
        k.push(m[I[0]], m[I[1]]);
      }
      if (f = [...f, {
        placement: a,
        overflows: k
      }], !k.every((I) => I <= 0)) {
        var _, L;
        const I = (((_ = o.flip) == null ? void 0 : _.index) || 0) + 1, z = $[I];
        if (z)
          return {
            data: {
              index: I,
              overflows: f
            },
            reset: {
              placement: z
            }
          };
        let O = (L = f.filter((q) => q.overflows[0] <= 0).sort((q, Y) => q.overflows[1] - Y.overflows[1])[0]) == null ? void 0 : L.placement;
        if (!O)
          switch (c) {
            case "bestFit": {
              var v;
              const q = (v = f.map((Y) => [Y.placement, Y.overflows.filter((U) => U > 0).reduce((U, ue) => U + ue, 0)]).sort((Y, U) => Y[1] - U[1])[0]) == null ? void 0 : v[0];
              q && (O = q);
              break;
            }
            case "initialPlacement":
              O = s;
              break;
          }
        if (a !== O)
          return {
            reset: {
              placement: O
            }
          };
      }
      return {};
    }
  };
};
function yl(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function bl(e) {
  return ho.some((t) => e[t] >= 0);
}
const zs = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: l
      } = t, {
        strategy: a = "referenceHidden",
        ...o
      } = vt(e, t);
      switch (a) {
        case "referenceHidden": {
          const n = await zt(t, {
            ...o,
            elementContext: "reference"
          }), s = yl(n, l.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: bl(s)
            }
          };
        }
        case "escaped": {
          const n = await zt(t, {
            ...o,
            altBoundary: !0
          }), s = yl(n, l.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: bl(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
function Co(e) {
  const t = lt(...e.map((n) => n.left)), l = lt(...e.map((n) => n.top)), a = Xe(...e.map((n) => n.right)), o = Xe(...e.map((n) => n.bottom));
  return {
    x: t,
    y: l,
    width: a - t,
    height: o - l
  };
}
function Hs(e) {
  const t = e.slice().sort((o, n) => o.y - n.y), l = [];
  let a = null;
  for (let o = 0; o < t.length; o++) {
    const n = t[o];
    !a || n.y - a.y > a.height / 2 ? l.push([n]) : l[l.length - 1].push(n), a = n;
  }
  return l.map((o) => Tt(Co(o)));
}
const Rs = function(e) {
  return e === void 0 && (e = {}), {
    name: "inline",
    options: e,
    async fn(t) {
      const {
        placement: l,
        elements: a,
        rects: o,
        platform: n,
        strategy: s
      } = t, {
        padding: r = 2,
        x: i,
        y: d
      } = vt(e, t), y = Array.from(await (n.getClientRects == null ? void 0 : n.getClientRects(a.reference)) || []), b = Hs(y), c = Tt(Co(y)), h = Ua(r);
      function S() {
        if (b.length === 2 && b[0].left > b[1].right && i != null && d != null)
          return b.find((F) => i > F.left - h.left && i < F.right + h.right && d > F.top - h.top && d < F.bottom + h.bottom) || c;
        if (b.length >= 2) {
          if (Rt(l) === "y") {
            const v = b[0], I = b[b.length - 1], z = qe(l) === "top", O = v.top, q = I.bottom, Y = z ? v.left : I.left, U = z ? v.right : I.right, ue = U - Y, ee = q - O;
            return {
              top: O,
              bottom: q,
              left: Y,
              right: U,
              width: ue,
              height: ee,
              x: Y,
              y: O
            };
          }
          const F = qe(l) === "left", w = Xe(...b.map((v) => v.right)), V = lt(...b.map((v) => v.left)), T = b.filter((v) => F ? v.left === V : v.right === w), $ = T[0].top, m = T[T.length - 1].bottom, k = V, f = w, _ = f - k, L = m - $;
          return {
            top: $,
            bottom: m,
            left: k,
            right: f,
            width: _,
            height: L,
            x: k,
            y: $
          };
        }
        return c;
      }
      const B = await n.getElementRects({
        reference: {
          getBoundingClientRect: S
        },
        floating: a.floating,
        strategy: s
      });
      return o.reference.x !== B.reference.x || o.reference.y !== B.reference.y || o.reference.width !== B.reference.width || o.reference.height !== B.reference.height ? {
        reset: {
          rects: B
        }
      } : {};
    }
  };
};
async function xs(e, t) {
  const {
    placement: l,
    platform: a,
    elements: o
  } = e, n = await (a.isRTL == null ? void 0 : a.isRTL(o.floating)), s = qe(l), r = Ke(l), i = Rt(l) === "y", d = ["left", "top"].includes(s) ? -1 : 1, y = n && i ? -1 : 1, b = vt(t, e);
  let {
    mainAxis: c,
    crossAxis: h,
    alignmentAxis: S
  } = typeof b == "number" ? {
    mainAxis: b,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...b
  };
  return r && typeof S == "number" && (h = r === "end" ? S * -1 : S), i ? {
    x: h * y,
    y: c * d
  } : {
    x: c * d,
    y: h * y
  };
}
const ko = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: l,
        y: a
      } = t, o = await xs(t, e);
      return {
        x: l + o.x,
        y: a + o.y,
        data: o
      };
    }
  };
}, $o = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: l,
        y: a,
        placement: o
      } = t, {
        mainAxis: n = !0,
        crossAxis: s = !1,
        limiter: r = {
          fn: (F) => {
            let {
              x: w,
              y: V
            } = F;
            return {
              x: w,
              y: V
            };
          }
        },
        ...i
      } = vt(e, t), d = {
        x: l,
        y: a
      }, y = await zt(t, i), b = Rt(qe(o)), c = Bo(b);
      let h = d[c], S = d[b];
      if (n) {
        const F = c === "y" ? "top" : "left", w = c === "y" ? "bottom" : "right", V = h + y[F], T = h - y[w];
        h = ka(V, h, T);
      }
      if (s) {
        const F = b === "y" ? "top" : "left", w = b === "y" ? "bottom" : "right", V = S + y[F], T = S - y[w];
        S = ka(V, S, T);
      }
      const B = r.fn({
        ...t,
        [c]: h,
        [b]: S
      });
      return {
        ...B,
        data: {
          x: B.x - l,
          y: B.y - a
        }
      };
    }
  };
};
function dt(e) {
  return _o(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Le(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function st(e) {
  var t;
  return (t = (_o(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function _o(e) {
  return e instanceof Node || e instanceof Le(e).Node;
}
function ot(e) {
  return e instanceof Element || e instanceof Le(e).Element;
}
function Je(e) {
  return e instanceof HTMLElement || e instanceof Le(e).HTMLElement;
}
function hl(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Le(e).ShadowRoot;
}
function xt(e) {
  const {
    overflow: t,
    overflowX: l,
    overflowY: a,
    display: o
  } = Me(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + a + l) && !["inline", "contents"].includes(o);
}
function Ms(e) {
  return ["table", "td", "th"].includes(dt(e));
}
function Xa(e) {
  const t = Ka(), l = Me(e);
  return l.transform !== "none" || l.perspective !== "none" || (l.containerType ? l.containerType !== "normal" : !1) || !t && (l.backdropFilter ? l.backdropFilter !== "none" : !1) || !t && (l.filter ? l.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((a) => (l.willChange || "").includes(a)) || ["paint", "layout", "strict", "content"].some((a) => (l.contain || "").includes(a));
}
function Ds(e) {
  let t = Vt(e);
  for (; Je(t) && !ca(t); ) {
    if (Xa(t))
      return t;
    t = Vt(t);
  }
  return null;
}
function Ka() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ca(e) {
  return ["html", "body", "#document"].includes(dt(e));
}
function Me(e) {
  return Le(e).getComputedStyle(e);
}
function fa(e) {
  return ot(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function Vt(e) {
  if (dt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    hl(e) && e.host || // Fallback.
    st(e)
  );
  return hl(t) ? t.host : t;
}
function To(e) {
  const t = Vt(e);
  return ca(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Je(t) && xt(t) ? t : To(t);
}
function ta(e, t) {
  var l;
  t === void 0 && (t = []);
  const a = To(e), o = a === ((l = e.ownerDocument) == null ? void 0 : l.body), n = Le(a);
  return o ? t.concat(n, n.visualViewport || [], xt(a) ? a : []) : t.concat(a, ta(a));
}
function Vo(e) {
  const t = Me(e);
  let l = parseFloat(t.width) || 0, a = parseFloat(t.height) || 0;
  const o = Je(e), n = o ? e.offsetWidth : l, s = o ? e.offsetHeight : a, r = Zt(l) !== n || Zt(a) !== s;
  return r && (l = n, a = s), {
    width: l,
    height: a,
    $: r
  };
}
function Ja(e) {
  return ot(e) ? e : e.contextElement;
}
function $t(e) {
  const t = Ja(e);
  if (!Je(t))
    return ut(1);
  const l = t.getBoundingClientRect(), {
    width: a,
    height: o,
    $: n
  } = Vo(t);
  let s = (n ? Zt(l.width) : l.width) / a, r = (n ? Zt(l.height) : l.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!r || !Number.isFinite(r)) && (r = 1), {
    x: s,
    y: r
  };
}
const js = /* @__PURE__ */ ut(0);
function Ao(e) {
  const t = Le(e);
  return !Ka() || !t.visualViewport ? js : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function qs(e, t, l) {
  return t === void 0 && (t = !1), !l || t && l !== Le(e) ? !1 : t;
}
function gt(e, t, l, a) {
  t === void 0 && (t = !1), l === void 0 && (l = !1);
  const o = e.getBoundingClientRect(), n = Ja(e);
  let s = ut(1);
  t && (a ? ot(a) && (s = $t(a)) : s = $t(e));
  const r = qs(n, l, a) ? Ao(n) : ut(0);
  let i = (o.left + r.x) / s.x, d = (o.top + r.y) / s.y, y = o.width / s.x, b = o.height / s.y;
  if (n) {
    const c = Le(n), h = a && ot(a) ? Le(a) : a;
    let S = c.frameElement;
    for (; S && a && h !== c; ) {
      const B = $t(S), F = S.getBoundingClientRect(), w = Me(S), V = F.left + (S.clientLeft + parseFloat(w.paddingLeft)) * B.x, T = F.top + (S.clientTop + parseFloat(w.paddingTop)) * B.y;
      i *= B.x, d *= B.y, y *= B.x, b *= B.y, i += V, d += T, S = Le(S).frameElement;
    }
  }
  return Tt({
    width: y,
    height: b,
    x: i,
    y: d
  });
}
function Gs(e) {
  let {
    rect: t,
    offsetParent: l,
    strategy: a
  } = e;
  const o = Je(l), n = st(l);
  if (l === n)
    return t;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, r = ut(1);
  const i = ut(0);
  if ((o || !o && a !== "fixed") && ((dt(l) !== "body" || xt(n)) && (s = fa(l)), Je(l))) {
    const d = gt(l);
    r = $t(l), i.x = d.x + l.clientLeft, i.y = d.y + l.clientTop;
  }
  return {
    width: t.width * r.x,
    height: t.height * r.y,
    x: t.x * r.x - s.scrollLeft * r.x + i.x,
    y: t.y * r.y - s.scrollTop * r.y + i.y
  };
}
function Ws(e) {
  return Array.from(e.getClientRects());
}
function Oo(e) {
  return gt(st(e)).left + fa(e).scrollLeft;
}
function Us(e) {
  const t = st(e), l = fa(e), a = e.ownerDocument.body, o = Xe(t.scrollWidth, t.clientWidth, a.scrollWidth, a.clientWidth), n = Xe(t.scrollHeight, t.clientHeight, a.scrollHeight, a.clientHeight);
  let s = -l.scrollLeft + Oo(e);
  const r = -l.scrollTop;
  return Me(a).direction === "rtl" && (s += Xe(t.clientWidth, a.clientWidth) - o), {
    width: o,
    height: n,
    x: s,
    y: r
  };
}
function Xs(e, t) {
  const l = Le(e), a = st(e), o = l.visualViewport;
  let n = a.clientWidth, s = a.clientHeight, r = 0, i = 0;
  if (o) {
    n = o.width, s = o.height;
    const d = Ka();
    (!d || d && t === "fixed") && (r = o.offsetLeft, i = o.offsetTop);
  }
  return {
    width: n,
    height: s,
    x: r,
    y: i
  };
}
function Ks(e, t) {
  const l = gt(e, !0, t === "fixed"), a = l.top + e.clientTop, o = l.left + e.clientLeft, n = Je(e) ? $t(e) : ut(1), s = e.clientWidth * n.x, r = e.clientHeight * n.y, i = o * n.x, d = a * n.y;
  return {
    width: s,
    height: r,
    x: i,
    y: d
  };
}
function Bl(e, t, l) {
  let a;
  if (t === "viewport")
    a = Xs(e, l);
  else if (t === "document")
    a = Us(st(e));
  else if (ot(t))
    a = Ks(t, l);
  else {
    const o = Ao(e);
    a = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return Tt(a);
}
function Fo(e, t) {
  const l = Vt(e);
  return l === t || !ot(l) || ca(l) ? !1 : Me(l).position === "fixed" || Fo(l, t);
}
function Js(e, t) {
  const l = t.get(e);
  if (l)
    return l;
  let a = ta(e).filter((r) => ot(r) && dt(r) !== "body"), o = null;
  const n = Me(e).position === "fixed";
  let s = n ? Vt(e) : e;
  for (; ot(s) && !ca(s); ) {
    const r = Me(s), i = Xa(s);
    !i && r.position === "fixed" && (o = null), (n ? !i && !o : !i && r.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || xt(s) && !i && Fo(e, s)) ? a = a.filter((y) => y !== s) : o = r, s = Vt(s);
  }
  return t.set(e, a), a;
}
function Ys(e) {
  let {
    element: t,
    boundary: l,
    rootBoundary: a,
    strategy: o
  } = e;
  const s = [...l === "clippingAncestors" ? Js(t, this._c) : [].concat(l), a], r = s[0], i = s.reduce((d, y) => {
    const b = Bl(t, y, o);
    return d.top = Xe(b.top, d.top), d.right = lt(b.right, d.right), d.bottom = lt(b.bottom, d.bottom), d.left = Xe(b.left, d.left), d;
  }, Bl(t, r, o));
  return {
    width: i.right - i.left,
    height: i.bottom - i.top,
    x: i.left,
    y: i.top
  };
}
function Zs(e) {
  return Vo(e);
}
function Qs(e, t, l) {
  const a = Je(t), o = st(t), n = l === "fixed", s = gt(e, !0, n, t);
  let r = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const i = ut(0);
  if (a || !a && !n)
    if ((dt(t) !== "body" || xt(o)) && (r = fa(t)), a) {
      const d = gt(t, !0, n, t);
      i.x = d.x + t.clientLeft, i.y = d.y + t.clientTop;
    } else
      o && (i.x = Oo(o));
  return {
    x: s.left + r.scrollLeft - i.x,
    y: s.top + r.scrollTop - i.y,
    width: s.width,
    height: s.height
  };
}
function Sl(e, t) {
  return !Je(e) || Me(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Eo(e, t) {
  const l = Le(e);
  if (!Je(e))
    return l;
  let a = Sl(e, t);
  for (; a && Ms(a) && Me(a).position === "static"; )
    a = Sl(a, t);
  return a && (dt(a) === "html" || dt(a) === "body" && Me(a).position === "static" && !Xa(a)) ? l : a || Ds(e) || l;
}
const er = async function(e) {
  let {
    reference: t,
    floating: l,
    strategy: a
  } = e;
  const o = this.getOffsetParent || Eo, n = this.getDimensions;
  return {
    reference: Qs(t, await o(l), a),
    floating: {
      x: 0,
      y: 0,
      ...await n(l)
    }
  };
};
function tr(e) {
  return Me(e).direction === "rtl";
}
const ar = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Gs,
  getDocumentElement: st,
  getClippingRect: Ys,
  getOffsetParent: Eo,
  getElementRects: er,
  getClientRects: Ws,
  getDimensions: Zs,
  getScale: $t,
  isElement: ot,
  isRTL: tr
};
function lr(e, t) {
  let l = null, a;
  const o = st(e);
  function n() {
    clearTimeout(a), l && l.disconnect(), l = null;
  }
  function s(r, i) {
    r === void 0 && (r = !1), i === void 0 && (i = 1), n();
    const {
      left: d,
      top: y,
      width: b,
      height: c
    } = e.getBoundingClientRect();
    if (r || t(), !b || !c)
      return;
    const h = jt(y), S = jt(o.clientWidth - (d + b)), B = jt(o.clientHeight - (y + c)), F = jt(d), V = {
      rootMargin: -h + "px " + -S + "px " + -B + "px " + -F + "px",
      threshold: Xe(0, lt(1, i)) || 1
    };
    let T = !0;
    function $(m) {
      const k = m[0].intersectionRatio;
      if (k !== i) {
        if (!T)
          return s();
        k ? s(!1, k) : a = setTimeout(() => {
          s(!1, 1e-7);
        }, 100);
      }
      T = !1;
    }
    try {
      l = new IntersectionObserver($, {
        ...V,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      l = new IntersectionObserver($, V);
    }
    l.observe(e);
  }
  return s(!0), n;
}
function No(e, t, l, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: n = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: r = typeof IntersectionObserver == "function",
    animationFrame: i = !1
  } = a, d = Ja(e), y = o || n ? [...d ? ta(d) : [], ...ta(t)] : [];
  y.forEach((w) => {
    o && w.addEventListener("scroll", l, {
      passive: !0
    }), n && w.addEventListener("resize", l);
  });
  const b = d && r ? lr(d, l) : null;
  let c = -1, h = null;
  s && (h = new ResizeObserver((w) => {
    let [V] = w;
    V && V.target === d && h && (h.unobserve(t), cancelAnimationFrame(c), c = requestAnimationFrame(() => {
      h && h.observe(t);
    })), l();
  }), d && !i && h.observe(d), h.observe(t));
  let S, B = i ? gt(e) : null;
  i && F();
  function F() {
    const w = gt(e);
    B && (w.x !== B.x || w.y !== B.y || w.width !== B.width || w.height !== B.height) && l(), B = w, S = requestAnimationFrame(F);
  }
  return l(), () => {
    y.forEach((w) => {
      o && w.removeEventListener("scroll", l), n && w.removeEventListener("resize", l);
    }), b && b(), h && h.disconnect(), h = null, i && cancelAnimationFrame(S);
  };
}
const or = (e, t, l) => {
  const a = /* @__PURE__ */ new Map(), o = {
    platform: ar,
    ...l
  }, n = {
    ...o.platform,
    _c: a
  };
  return Ns(e, t, {
    ...o,
    platform: n
  });
};
function $a(e) {
  var t;
  return (t = e == null ? void 0 : e.$el) != null ? t : e;
}
function nr(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const l = $a(g(e.element));
      return l == null ? {} : Ps({
        element: l,
        padding: e.padding
      }).fn(t);
    }
  };
}
function Po(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function wl(e, t) {
  const l = Po(e);
  return Math.round(t * l) / l;
}
function Lo(e, t, l) {
  l === void 0 && (l = {});
  const a = l.whileElementsMounted, o = C(() => {
    var f;
    return (f = g(l.open)) != null ? f : !0;
  }), n = C(() => g(l.middleware)), s = C(() => {
    var f;
    return (f = g(l.placement)) != null ? f : "bottom";
  }), r = C(() => {
    var f;
    return (f = g(l.strategy)) != null ? f : "absolute";
  }), i = C(() => {
    var f;
    return (f = g(l.transform)) != null ? f : !0;
  }), d = C(() => $a(e.value)), y = C(() => $a(t.value)), b = M(0), c = M(0), h = M(r.value), S = M(s.value), B = Pa({}), F = M(!1), w = C(() => {
    const f = {
      position: h.value,
      left: "0",
      top: "0"
    };
    if (!y.value)
      return f;
    const _ = wl(y.value, b.value), L = wl(y.value, c.value);
    return i.value ? {
      ...f,
      transform: "translate(" + _ + "px, " + L + "px)",
      ...Po(y.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: h.value,
      left: _ + "px",
      top: L + "px"
    };
  });
  let V;
  function T() {
    d.value == null || y.value == null || or(d.value, y.value, {
      middleware: n.value,
      placement: s.value,
      strategy: r.value
    }).then((f) => {
      b.value = f.x, c.value = f.y, h.value = f.strategy, S.value = f.placement, B.value = f.middlewareData, F.value = !0;
    });
  }
  function $() {
    typeof V == "function" && (V(), V = void 0);
  }
  function m() {
    if ($(), a === void 0) {
      T();
      return;
    }
    if (d.value != null && y.value != null) {
      V = a(d.value, y.value, T);
      return;
    }
  }
  function k() {
    o.value || (F.value = !1);
  }
  return se([n, s, r], T, {
    flush: "sync"
  }), se([d, y], m, {
    flush: "sync"
  }), se(o, k, {
    flush: "sync"
  }), Xl() && Kl($), {
    x: St(b),
    y: St(c),
    strategy: St(h),
    placement: St(S),
    middlewareData: St(B),
    isPositioned: St(F),
    floatingStyles: w,
    update: T
  };
}
const sr = /* @__PURE__ */ new Set([
  "background",
  "cite",
  "href",
  "itemtype",
  "longdesc",
  "poster",
  "src",
  "xlink:href"
]), rr = /^aria-[\w-]*$/i, ir = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i, ur = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i, dr = (e, t) => {
  const l = e.nodeName.toLowerCase();
  return t.includes(l) ? sr.has(l) ? !!(ir.test(e.nodeValue || "") || ur.test(e.nodeValue || "")) : !0 : t.filter((a) => a instanceof RegExp).some((a) => a.test(l));
}, Ct = {
  // Global attributes allowed on any supplied element below.
  "*": ["class", "dir", "id", "lang", "role", rr],
  a: ["target", "href", "title", "rel"],
  area: [],
  b: [],
  br: [],
  col: [],
  code: [],
  div: [],
  em: [],
  hr: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: [],
  i: [],
  img: ["src", "srcset", "alt", "title", "width", "height"],
  li: [],
  ol: [],
  p: [],
  pre: [],
  s: [],
  small: [],
  span: [],
  sub: [],
  sup: [],
  strong: [],
  u: [],
  ul: []
}, kt = (e, t, l) => {
  if (!e.length)
    return e;
  if (l && typeof l == "function")
    return l(e);
  const o = new window.DOMParser().parseFromString(e, "text/html"), n = o.body.querySelectorAll("*");
  for (const s of n) {
    const r = s.nodeName.toLowerCase();
    if (!Object.keys(t).includes(r)) {
      s.remove();
      continue;
    }
    const i = s.attributes, d = [...t["*"] || [], ...t[r] || []];
    for (const y of i)
      dr(y, d) || s.removeAttribute(y.nodeName);
  }
  return o.body.innerHTML;
};
function Io(e, t) {
  var l;
  const a = Pa();
  return Ot(() => {
    a.value = e();
  }, {
    ...t,
    flush: (l = t == null ? void 0 : t.flush) != null ? l : "sync"
  }), He(a);
}
function yt(e) {
  return Xl() ? (Kl(e), !0) : !1;
}
function zo(e) {
  let t = !1, l;
  const a = Jl(!0);
  return (...o) => (t || (l = a.run(() => e(...o)), t = !0), l);
}
function cr(e) {
  let t = 0, l, a;
  const o = () => {
    t -= 1, a && t <= 0 && (a.stop(), l = void 0, a = void 0);
  };
  return (...n) => (t += 1, l || (a = Jl(!0), l = a.run(() => e(...n))), yt(o), l);
}
function xe(e) {
  return typeof e == "function" ? e() : g(e);
}
const aa = typeof window < "u" && typeof document < "u", fr = (e) => typeof e < "u", vr = Object.prototype.toString, pr = (e) => vr.call(e) === "[object Object]", ct = () => {
}, _a = /* @__PURE__ */ mr();
function mr() {
  var e;
  return aa && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && /* @__PURE__ */ /iP(ad|hone|od)/.test(window.navigator.userAgent);
}
function Ho(e, t) {
  function l(...a) {
    return new Promise((o, n) => {
      Promise.resolve(e(() => t.apply(this, a), { fn: t, thisArg: this, args: a })).then(o).catch(n);
    });
  }
  return l;
}
const Ro = (e) => e();
function gr(e, t = {}) {
  let l, a, o = ct;
  const n = (r) => {
    clearTimeout(r), o(), o = ct;
  };
  return (r) => {
    const i = xe(e), d = xe(t.maxWait);
    return l && n(l), i <= 0 || d !== void 0 && d <= 0 ? (a && (n(a), a = null), Promise.resolve(r())) : new Promise((y, b) => {
      o = t.rejectOnCancel ? b : y, d && !a && (a = setTimeout(() => {
        l && n(l), a = null, y(r());
      }, d)), l = setTimeout(() => {
        a && n(a), a = null, y(r());
      }, i);
    });
  };
}
function yr(e = Ro) {
  const t = M(!0);
  function l() {
    t.value = !1;
  }
  function a() {
    t.value = !0;
  }
  const o = (...n) => {
    t.value && e(...n);
  };
  return { isActive: He(t), pause: l, resume: a, eventFilter: o };
}
function xo(...e) {
  if (e.length !== 1)
    return P(...e);
  const t = e[0];
  return typeof t == "function" ? He(Rn(() => ({ get: t, set: ct }))) : M(t);
}
function br(e, t = 200, l = {}) {
  return Ho(
    gr(t, l),
    e
  );
}
function hr(e, t, l = {}) {
  const {
    eventFilter: a = Ro,
    ...o
  } = l;
  return se(
    e,
    Ho(
      a,
      t
    ),
    o
  );
}
function Br(e, t, l = {}) {
  const {
    eventFilter: a,
    ...o
  } = l, { eventFilter: n, pause: s, resume: r, isActive: i } = yr(a);
  return { stop: hr(
    e,
    t,
    {
      ...o,
      eventFilter: n
    }
  ), pause: s, resume: r, isActive: i };
}
function Sr(e, t = !0) {
  Ft() ? Ye(e) : t ? e() : Te(e);
}
function Mo(e, t = 1e3, l = {}) {
  const {
    immediate: a = !0,
    immediateCallback: o = !1
  } = l;
  let n = null;
  const s = M(!1);
  function r() {
    n && (clearInterval(n), n = null);
  }
  function i() {
    s.value = !1, r();
  }
  function d() {
    const y = xe(t);
    y <= 0 || (s.value = !0, o && e(), r(), n = setInterval(e, y));
  }
  if (a && aa && d(), La(t) || typeof t == "function") {
    const y = se(t, () => {
      s.value && aa && d();
    });
    yt(y);
  }
  return yt(i), {
    isActive: s,
    pause: i,
    resume: d
  };
}
function Be(e, t = {}) {
  const {
    method: l = "parseFloat",
    radix: a,
    nanToZero: o
  } = t;
  return C(() => {
    let n = xe(e);
    return typeof n == "string" && (n = Number[l](n, a)), o && Number.isNaN(n) && (n = 0), n;
  });
}
function tt(e) {
  var t;
  const l = xe(e);
  return (t = l == null ? void 0 : l.$el) != null ? t : l;
}
const Ge = aa ? window : void 0;
function we(...e) {
  let t, l, a, o;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([l, a, o] = e, t = Ge) : [t, l, a, o] = e, !t)
    return ct;
  Array.isArray(l) || (l = [l]), Array.isArray(a) || (a = [a]);
  const n = [], s = () => {
    n.forEach((y) => y()), n.length = 0;
  }, r = (y, b, c, h) => (y.addEventListener(b, c, h), () => y.removeEventListener(b, c, h)), i = se(
    () => [tt(t), xe(o)],
    ([y, b]) => {
      if (s(), !y)
        return;
      const c = pr(b) ? { ...b } : b;
      n.push(
        ...l.flatMap((h) => a.map((S) => r(y, h, S, c)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    i(), s();
  };
  return yt(d), d;
}
let Cl = !1;
function Do(e, t, l = {}) {
  const { window: a = Ge, ignore: o = [], capture: n = !0, detectIframe: s = !1 } = l;
  if (!a)
    return;
  _a && !Cl && (Cl = !0, Array.from(a.document.body.children).forEach((c) => c.addEventListener("click", ct)), a.document.documentElement.addEventListener("click", ct));
  let r = !0;
  const i = (c) => o.some((h) => {
    if (typeof h == "string")
      return Array.from(a.document.querySelectorAll(h)).some((S) => S === c.target || c.composedPath().includes(S));
    {
      const S = tt(h);
      return S && (c.target === S || c.composedPath().includes(S));
    }
  }), y = [
    we(a, "click", (c) => {
      const h = tt(e);
      if (!(!h || h === c.target || c.composedPath().includes(h))) {
        if (c.detail === 0 && (r = !i(c)), !r) {
          r = !0;
          return;
        }
        t(c);
      }
    }, { passive: !0, capture: n }),
    we(a, "pointerdown", (c) => {
      const h = tt(e);
      h && (r = !c.composedPath().includes(h) && !i(c));
    }, { passive: !0 }),
    s && we(a, "blur", (c) => {
      setTimeout(() => {
        var h;
        const S = tt(e);
        ((h = a.document.activeElement) == null ? void 0 : h.tagName) === "IFRAME" && !(S != null && S.contains(a.document.activeElement)) && t(c);
      }, 0);
    })
  ].filter(Boolean);
  return () => y.forEach((c) => c());
}
function wr(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function At(...e) {
  let t, l, a = {};
  e.length === 3 ? (t = e[0], l = e[1], a = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, l = e[0], a = e[1]) : (t = e[0], l = e[1]) : (t = !0, l = e[0]);
  const {
    target: o = Ge,
    eventName: n = "keydown",
    passive: s = !1,
    dedupe: r = !1
  } = a, i = wr(t);
  return we(o, n, (y) => {
    y.repeat && xe(r) || i(y) && l(y);
  }, s);
}
function Cr() {
  const e = M(!1);
  return Ft() && Ye(() => {
    e.value = !0;
  }), e;
}
function kr(e) {
  const t = Cr();
  return C(() => (t.value, !!e()));
}
function $r(e, t = {}) {
  const { window: l = Ge } = t, a = kr(() => l && "matchMedia" in l && typeof l.matchMedia == "function");
  let o;
  const n = M(!1), s = (d) => {
    n.value = d.matches;
  }, r = () => {
    o && ("removeEventListener" in o ? o.removeEventListener("change", s) : o.removeListener(s));
  }, i = Ot(() => {
    a.value && (r(), o = l.matchMedia(xe(e)), "addEventListener" in o ? o.addEventListener("change", s) : o.addListener(s), n.value = o.matches);
  });
  return yt(() => {
    i(), r(), o = void 0;
  }), n;
}
function _r(e) {
  return JSON.parse(JSON.stringify(e));
}
const qt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Gt = "__vueuse_ssr_handlers__", Tr = /* @__PURE__ */ Vr();
function Vr() {
  return Gt in qt || (qt[Gt] = qt[Gt] || {}), qt[Gt];
}
function Ya(e, t) {
  return Tr[e] || t;
}
function Ar(e) {
  return e == null ? "any" : e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof Date ? "date" : typeof e == "boolean" ? "boolean" : typeof e == "string" ? "string" : typeof e == "object" ? "object" : Number.isNaN(e) ? "any" : "number";
}
const Or = {
  boolean: {
    read: (e) => e === "true",
    write: (e) => String(e)
  },
  object: {
    read: (e) => JSON.parse(e),
    write: (e) => JSON.stringify(e)
  },
  number: {
    read: (e) => Number.parseFloat(e),
    write: (e) => String(e)
  },
  any: {
    read: (e) => e,
    write: (e) => String(e)
  },
  string: {
    read: (e) => e,
    write: (e) => String(e)
  },
  map: {
    read: (e) => new Map(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e.entries()))
  },
  set: {
    read: (e) => new Set(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e))
  },
  date: {
    read: (e) => new Date(e),
    write: (e) => e.toISOString()
  }
}, kl = "vueuse-storage";
function Fr(e, t, l, a = {}) {
  var o;
  const {
    flush: n = "pre",
    deep: s = !0,
    listenToStorageChanges: r = !0,
    writeDefaults: i = !0,
    mergeDefaults: d = !1,
    shallow: y,
    window: b = Ge,
    eventFilter: c,
    onError: h = (_) => {
      console.error(_);
    }
  } = a, S = (y ? Pa : M)(t);
  if (!l)
    try {
      l = Ya("getDefaultStorage", () => {
        var _;
        return (_ = Ge) == null ? void 0 : _.localStorage;
      })();
    } catch (_) {
      h(_);
    }
  if (!l)
    return S;
  const B = xe(t), F = Ar(B), w = (o = a.serializer) != null ? o : Or[F], { pause: V, resume: T } = Br(
    S,
    () => $(S.value),
    { flush: n, deep: s, eventFilter: c }
  );
  return b && r && (we(b, "storage", f), we(b, kl, k)), f(), S;
  function $(_) {
    try {
      if (_ == null)
        l.removeItem(e);
      else {
        const L = w.write(_), v = l.getItem(e);
        v !== L && (l.setItem(e, L), b && b.dispatchEvent(new CustomEvent(kl, {
          detail: {
            key: e,
            oldValue: v,
            newValue: L,
            storageArea: l
          }
        })));
      }
    } catch (L) {
      h(L);
    }
  }
  function m(_) {
    const L = _ ? _.newValue : l.getItem(e);
    if (L == null)
      return i && B !== null && l.setItem(e, w.write(B)), B;
    if (!_ && d) {
      const v = w.read(L);
      return typeof d == "function" ? d(v, B) : F === "object" && !Array.isArray(v) ? { ...B, ...v } : v;
    } else
      return typeof L != "string" ? L : w.read(L);
  }
  function k(_) {
    f(_.detail);
  }
  function f(_) {
    if (!(_ && _.storageArea !== l)) {
      if (_ && _.key == null) {
        S.value = B;
        return;
      }
      if (!(_ && _.key !== e)) {
        V();
        try {
          (_ == null ? void 0 : _.newValue) !== w.write(S.value) && (S.value = m(_));
        } catch (L) {
          h(L);
        } finally {
          _ ? Te(T) : T();
        }
      }
    }
  }
}
function Er(e) {
  return $r("(prefers-color-scheme: dark)", e);
}
function Nr(e = {}) {
  const {
    selector: t = "html",
    attribute: l = "class",
    initialValue: a = "auto",
    window: o = Ge,
    storage: n,
    storageKey: s = "vueuse-color-scheme",
    listenToStorageChanges: r = !0,
    storageRef: i,
    emitAuto: d,
    disableTransition: y = !0
  } = e, b = {
    auto: "",
    light: "light",
    dark: "dark",
    ...e.modes || {}
  }, c = Er({ window: o }), h = C(() => c.value ? "dark" : "light"), S = i || (s == null ? xo(a) : Fr(s, a, n, { window: o, listenToStorageChanges: r })), B = C(
    () => S.value === "auto" ? h.value : S.value
  ), F = Ya(
    "updateHTMLAttrs",
    ($, m, k) => {
      const f = typeof $ == "string" ? o == null ? void 0 : o.document.querySelector($) : tt($);
      if (!f)
        return;
      let _;
      if (y) {
        _ = o.document.createElement("style");
        const L = "*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
        _.appendChild(document.createTextNode(L)), o.document.head.appendChild(_);
      }
      if (m === "class") {
        const L = k.split(/\s/g);
        Object.values(b).flatMap((v) => (v || "").split(/\s/g)).filter(Boolean).forEach((v) => {
          L.includes(v) ? f.classList.add(v) : f.classList.remove(v);
        });
      } else
        f.setAttribute(m, k);
      y && (o.getComputedStyle(_).opacity, document.head.removeChild(_));
    }
  );
  function w($) {
    var m;
    F(t, l, (m = b[$]) != null ? m : $);
  }
  function V($) {
    e.onChanged ? e.onChanged($, w) : w($);
  }
  se(B, V, { flush: "post", immediate: !0 }), Sr(() => V(B.value));
  const T = C({
    get() {
      return d ? S.value : B.value;
    },
    set($) {
      S.value = $;
    }
  });
  try {
    return Object.assign(T, { store: S, system: h, state: B });
  } catch {
    return T;
  }
}
function Za(e, t = {}) {
  const {
    delayEnter: l = 0,
    delayLeave: a = 0,
    window: o = Ge
  } = t, n = M(!1);
  let s;
  const r = (i) => {
    const d = i ? l : a;
    s && (clearTimeout(s), s = void 0), d ? s = setTimeout(() => n.value = i, d) : n.value = i;
  };
  return o && (we(e, "mouseenter", () => r(!0), { passive: !0 }), we(e, "mouseleave", () => r(!1), { passive: !0 })), n;
}
function Ne(e, t = {}) {
  const { initialValue: l = !1, focusVisible: a = !1 } = t, o = M(!1), n = C(() => tt(e));
  we(n, "focus", (r) => {
    var i, d;
    (!a || (d = (i = r.target).matches) != null && d.call(i, ":focus-visible")) && (o.value = !0);
  }), we(n, "blur", () => o.value = !1);
  const s = C({
    get: () => o.value,
    set(r) {
      var i, d;
      !r && o.value ? (i = n.value) == null || i.blur() : r && !o.value && ((d = n.value) == null || d.focus());
    }
  });
  return se(
    n,
    () => {
      s.value = l;
    },
    { immediate: !0, flush: "post" }
  ), { focused: s };
}
function ba(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
const Pr = {
  page: (e) => [e.pageX, e.pageY],
  client: (e) => [e.clientX, e.clientY],
  screen: (e) => [e.screenX, e.screenY],
  movement: (e) => e instanceof Touch ? null : [e.movementX, e.movementY]
};
function Lr(e = {}) {
  const {
    type: t = "page",
    touch: l = !0,
    resetOnTouchEnds: a = !1,
    initialValue: o = { x: 0, y: 0 },
    window: n = Ge,
    target: s = n,
    scroll: r = !0,
    eventFilter: i
  } = e;
  let d = null;
  const y = M(o.x), b = M(o.y), c = M(null), h = typeof t == "function" ? t : Pr[t], S = (m) => {
    const k = h(m);
    d = m, k && ([y.value, b.value] = k, c.value = "mouse");
  }, B = (m) => {
    if (m.touches.length > 0) {
      const k = h(m.touches[0]);
      k && ([y.value, b.value] = k, c.value = "touch");
    }
  }, F = () => {
    if (!d || !n)
      return;
    const m = h(d);
    d instanceof MouseEvent && m && (y.value = m[0] + n.scrollX, b.value = m[1] + n.scrollY);
  }, w = () => {
    y.value = o.x, b.value = o.y;
  }, V = i ? (m) => i(() => S(m), {}) : (m) => S(m), T = i ? (m) => i(() => B(m), {}) : (m) => B(m), $ = i ? () => i(() => F(), {}) : () => F();
  if (s) {
    const m = { passive: !0 };
    we(s, ["mousemove", "dragover"], V, m), l && t !== "movement" && (we(s, ["touchstart", "touchmove"], T, m), a && we(s, "touchend", w, m)), r && t === "page" && we(n, "scroll", $, { passive: !0 });
  }
  return {
    x: y,
    y: b,
    sourceType: c
  };
}
function $l(e, t = {}) {
  const {
    handleOutside: l = !0,
    window: a = Ge
  } = t, { x: o, y: n, sourceType: s } = Lr(t), r = M(e ?? (a == null ? void 0 : a.document.body)), i = M(0), d = M(0), y = M(0), b = M(0), c = M(0), h = M(0), S = M(!0);
  let B = () => {
  };
  return a && (B = se(
    [r, o, n],
    () => {
      const F = tt(r);
      if (!F)
        return;
      const {
        left: w,
        top: V,
        width: T,
        height: $
      } = F.getBoundingClientRect();
      y.value = w + a.pageXOffset, b.value = V + a.pageYOffset, c.value = $, h.value = T;
      const m = o.value - y.value, k = n.value - b.value;
      S.value = T === 0 || $ === 0 || m < 0 || k < 0 || m > T || k > $, (l || !S.value) && (i.value = m, d.value = k);
    },
    { immediate: !0 }
  ), we(document, "mouseleave", () => {
    S.value = !0;
  })), {
    x: o,
    y: n,
    sourceType: s,
    elementX: i,
    elementY: d,
    elementPositionX: y,
    elementPositionY: b,
    elementHeight: c,
    elementWidth: h,
    isOutside: S,
    stop: B
  };
}
function jo(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const l = e.parentNode;
    return !l || l.tagName === "BODY" ? !1 : jo(l);
  }
}
function Ir(e) {
  const t = e || window.event, l = t.target;
  return jo(l) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
function zr(e, t = !1) {
  const l = M(t);
  let a = null, o;
  se(xo(e), (r) => {
    const i = ba(xe(r));
    if (i) {
      const d = i;
      o = d.style.overflow, l.value && (d.style.overflow = "hidden");
    }
  }, {
    immediate: !0
  });
  const n = () => {
    const r = ba(xe(e));
    !r || l.value || (_a && (a = we(
      r,
      "touchmove",
      (i) => {
        Ir(i);
      },
      { passive: !1 }
    )), r.style.overflow = "hidden", l.value = !0);
  }, s = () => {
    const r = ba(xe(e));
    !r || !l.value || (_a && (a == null || a()), r.style.overflow = o, l.value = !1);
  };
  return yt(s), C({
    get() {
      return l.value;
    },
    set(r) {
      r ? n() : s();
    }
  });
}
function Hr(e, t = {}) {
  const {
    threshold: l = 50,
    onSwipe: a,
    onSwipeEnd: o,
    onSwipeStart: n,
    passive: s = !0,
    window: r = Ge
  } = t, i = It({ x: 0, y: 0 }), d = It({ x: 0, y: 0 }), y = C(() => i.x - d.x), b = C(() => i.y - d.y), { max: c, abs: h } = Math, S = C(() => c(h(y.value), h(b.value)) >= l), B = M(!1), F = C(() => S.value ? h(y.value) > h(b.value) ? y.value > 0 ? "left" : "right" : b.value > 0 ? "up" : "down" : "none"), w = (L) => [L.touches[0].clientX, L.touches[0].clientY], V = (L, v) => {
    i.x = L, i.y = v;
  }, T = (L, v) => {
    d.x = L, d.y = v;
  };
  let $;
  const m = Rr(r == null ? void 0 : r.document);
  s ? $ = m ? { passive: !0 } : { capture: !1 } : $ = m ? { passive: !1, capture: !0 } : { capture: !0 };
  const k = (L) => {
    B.value && (o == null || o(L, F.value)), B.value = !1;
  }, f = [
    we(e, "touchstart", (L) => {
      if (L.touches.length !== 1)
        return;
      $.capture && !$.passive && L.preventDefault();
      const [v, I] = w(L);
      V(v, I), T(v, I), n == null || n(L);
    }, $),
    we(e, "touchmove", (L) => {
      if (L.touches.length !== 1)
        return;
      const [v, I] = w(L);
      T(v, I), !B.value && S.value && (B.value = !0), B.value && (a == null || a(L));
    }, $),
    we(e, ["touchend", "touchcancel"], k, $)
  ];
  return {
    isPassiveEventSupported: m,
    isSwiping: B,
    direction: F,
    coordsStart: i,
    coordsEnd: d,
    lengthX: y,
    lengthY: b,
    stop: () => f.forEach((L) => L())
  };
}
function Rr(e) {
  if (!e)
    return !1;
  let t = !1;
  const l = {
    get passive() {
      return t = !0, !1;
    }
  };
  return e.addEventListener("x", ct, l), e.removeEventListener("x", ct), t;
}
function Se(e, t, l, a = {}) {
  var o, n, s;
  const {
    clone: r = !1,
    passive: i = !1,
    eventName: d,
    deep: y = !1,
    defaultValue: b,
    shouldEmit: c
  } = a, h = Ft(), S = l || (h == null ? void 0 : h.emit) || ((o = h == null ? void 0 : h.$emit) == null ? void 0 : o.bind(h)) || ((s = (n = h == null ? void 0 : h.proxy) == null ? void 0 : n.$emit) == null ? void 0 : s.bind(h == null ? void 0 : h.proxy));
  let B = d;
  t || (t = "modelValue"), B = B || `update:${t.toString()}`;
  const F = (T) => r ? typeof r == "function" ? r(T) : _r(T) : T, w = () => fr(e[t]) ? F(e[t]) : b, V = (T) => {
    c ? c(T) && S(B, T) : S(B, T);
  };
  if (i) {
    const T = w(), $ = M(T);
    let m = !1;
    return se(
      () => e[t],
      (k) => {
        m || (m = !0, $.value = F(k), Te(() => m = !1));
      }
    ), se(
      $,
      (k) => {
        !m && (k !== e[t] || y) && V(k);
      },
      { deep: y }
    ), $;
  } else
    return C({
      get() {
        return w();
      },
      set(T) {
        V(T);
      }
    });
}
const va = R({
  name: "ComponentOrEmpty",
  slots: Object,
  props: {
    tag: {
      type: String,
      default: "div"
    },
    to: {
      type: [String, Object],
      default: null
    },
    skip: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, { slots: t, attrs: l }) {
    return () => {
      var a, o, n;
      return e.skip ? (a = t.default) == null ? void 0 : a.call(t) : e.tag === "Teleport" ? ye(sa, { to: e.to }, [(o = t.default) == null ? void 0 : o.call(t)]) : ye(e.tag, { ...l }, [(n = t.default) == null ? void 0 : n.call(t)]);
    };
  }
}), Mt = (e) => Io(() => {
  const t = nt(e);
  return t ? `justify-content-${t}` : "";
}), bt = (e, t) => {
  const l = P(t), a = P(e), o = C(() => $s(a.value)), n = C(
    () => o.value ? Da(
      a.value,
      l.value ?? [
        "active",
        "activeClass",
        "append",
        "href",
        "rel",
        "replace",
        "routerComponentName",
        "target",
        "to",
        "variant",
        "opacity",
        "opacityHover",
        "underlineVariant",
        "underlineOffset",
        "underlineOffsetHover",
        "underlineOpacity",
        "underlineOpacityHover"
      ]
    ) : {}
  );
  return { computedLink: o, computedLinkProps: n };
}, je = (e) => C(() => {
  const t = nt(e);
  return {
    [`text-bg-${t.variant}`]: t.variant !== null,
    [`text-${t.textVariant}`]: t.textVariant !== null && t.variant === null,
    [`bg-${t.bgVariant}`]: t.bgVariant !== null && t.variant === null
  };
});
function u(e) {
  return Io(() => {
    const t = nt(e);
    return t == null ? t : ia(t);
  });
}
const qo = zo(() => {
  const e = It([]);
  return { items: e, reset: () => {
    e.splice(0, e.length);
  } };
}), xr = (e = {}) => {
  const t = e.persist ?? !1, l = "data-bs-theme", a = "body";
  return Nr({
    attribute: l,
    selector: a,
    storageKey: t === !0 ? `bv-color-${e.attribute ?? l}-${e.selector ?? a}` : null,
    ...e
  });
}, Go = (e, t = M(1e3), l = {}) => {
  const a = He(P(e)), o = He(P(t)), n = M(!1), s = M(0), r = P(() => Math.ceil(a.value / o.value)), i = P(
    () => b.value || n.value ? Math.round(a.value - s.value * o.value) : 0
  ), { pause: d, resume: y, isActive: b } = Mo(
    () => {
      s.value = s.value + 1;
    },
    t,
    l
  ), c = () => {
    n.value = !1, s.value = 0, y();
  }, h = () => {
    n.value = !1, s.value = r.value;
  };
  Ot(() => {
    s.value > r.value && (s.value = r.value), s.value === r.value && d();
  }), se([o, a], () => {
    h(), c();
  });
  const S = () => {
    b.value !== !1 && (n.value = !0, d());
  }, B = () => {
    s.value !== r.value && (n.value = !1, y());
  };
  return {
    isActive: He(b),
    isPaused: He(n),
    restart: c,
    stop: h,
    pause: S,
    resume: B,
    value: i
  };
}, ht = (e) => C(() => {
  const t = nt(e);
  return t === !0 ? "is-valid" : t === !1 ? "is-invalid" : null;
}), Wo = (e) => C(() => {
  const t = nt(e);
  return {
    "form-check": t.plain === !1 && t.button === !1,
    "form-check-inline": t.inline === !0,
    "form-switch": t.switch === !0,
    [`form-control-${t.size}`]: t.size !== void 0 && t.size !== "md" && t.button === !1
  };
}), Uo = (e) => {
  const t = P(e), l = ht(P(() => t.value.state ?? null));
  return C(() => [
    l.value,
    {
      "form-check-input": t.value.plain === !1 && t.value.button === !1,
      "btn-check": t.value.button === !0
    }
  ]);
}, Xo = (e) => C(() => {
  const t = nt(e);
  return {
    "form-check-label": t.plain === !1 && t.button === !1,
    btn: t.button === !0,
    [`btn-${t.buttonVariant}`]: t.button === !0 && t.buttonVariant !== void 0 && t.buttonVariant !== null,
    [`btn-${t.size}`]: t.button && t.size && t.size !== "md"
  };
}), Ko = (e) => C(() => {
  const t = nt(e);
  return {
    "aria-invalid": da(t.ariaInvalid, t.state),
    "aria-required": t.required === !0 ? !0 : void 0
  };
}), Jo = (e) => C(() => {
  const t = nt(e);
  return {
    "was-validated": t.validated === !0,
    "btn-group": t.buttons === !0 && t.stacked === !1,
    "btn-group-vertical": t.stacked === !0 && t.buttons === !0,
    [`btn-group-${t.size}`]: t.size !== void 0
  };
}), Yo = (e, t) => {
  const l = M(null);
  let a = null, o = !0;
  const n = Se(e, "modelValue", t), s = ke(() => e.id, "input"), r = u(() => e.autofocus), i = u(() => e.disabled), d = u(() => e.lazy), y = u(() => e.lazyFormatter), b = u(() => e.number), c = u(() => e.state), h = u(() => e.trim), S = Be(P(() => e.debounce ?? 0)), B = Be(P(() => e.debounceMaxWait ?? NaN)), F = P(
    () => d.value === !0 ? 0 : S.value
  ), w = P(
    () => d.value === !0 ? NaN : B.value
  ), V = br(
    (O) => {
      n.value = O;
    },
    F,
    { maxWait: w }
  ), T = (O, q = !1) => {
    d.value === !0 && q === !1 || V(O);
  }, { focused: $ } = Ne(l, {
    initialValue: r.value
  }), m = (O, q, Y = !1) => (O = String(O), typeof e.formatter == "function" && (!y.value || Y) ? (o = !1, e.formatter(O, q)) : O), k = (O) => h.value ? O.trim() : b.value ? Number.parseFloat(O) : O;
  Ye(() => {
    l.value && (l.value.value = n.value);
  }), xn(() => {
    Te(() => {
      r.value && ($.value = !0);
    });
  });
  const f = C(
    () => da(e.ariaInvalid, c.value)
  ), _ = (O) => {
    const { value: q } = O.target, Y = m(q, O);
    if (Y === !1 || O.defaultPrevented) {
      O.preventDefault();
      return;
    }
    const U = k(Y);
    a = q, T(U), t("input", Y);
  }, L = (O) => {
    const { value: q } = O.target, Y = m(q, O);
    if (Y === !1 || O.defaultPrevented) {
      O.preventDefault();
      return;
    }
    const U = k(Y);
    n.value !== U && (a = q, T(Y, !0)), t("change", Y);
  }, v = (O) => {
    if (t("blur", O), !d.value && !y.value)
      return;
    const { value: q } = O.target, Y = m(q, O, !0), U = k(Y);
    n.value !== U && (a = q, T(Y, !0));
  }, I = () => {
    i.value || ($.value = !0);
  }, z = () => {
    i.value || ($.value = !1);
  };
  return se(n, (O) => {
    l.value && (l.value.value = a && o ? a : O, a = null, o = !0);
  }), {
    input: l,
    computedId: s,
    computedAriaInvalid: f,
    onInput: _,
    onChange: L,
    onBlur: v,
    focus: I,
    blur: z
  };
}, wt = (e, t) => {
  if (!e)
    return e;
  if (t in e)
    return e[t];
  const l = t.split(".");
  return wt(e[l[0]], l.splice(1).join("."));
}, ha = (e, t = null, l, a) => {
  if (Object.prototype.toString.call(e) === "[object Object]") {
    const o = wt(e, a.valueField), n = wt(e, a.textField), s = wt(e, a.htmlField), r = wt(e, a.disabledField), i = e[a.optionsField] || null;
    return i !== null ? {
      label: String(wt(e, a.labelField) || n),
      options: Qa(i, l, a)
    } : {
      value: typeof o > "u" ? t || n : o,
      text: String(typeof n > "u" ? t : n),
      html: s,
      disabled: !!r
    };
  }
  return {
    value: t || e,
    text: String(e),
    disabled: !1
  };
}, Qa = (e, t, l) => Array.isArray(e) ? e.map((a) => ha(a, null, t, l)) : Object.prototype.toString.call(e) === "[object Object]" ? (console.warn(
  `[BootstrapVue warn]: ${t} - Setting prop "options" to an object is deprecated. Use the array format instead.`
), Object.keys(e).map((a) => {
  const o = e[a];
  switch (typeof o) {
    case "object":
      return ha(o.text, String(o.value), t, l);
    default:
      return ha(o, String(a), t, l);
  }
})) : [], ke = (e, t) => C(() => nt(e) || pt(t)), Ba = "modal-open", el = cr(() => {
  const e = M([]), t = M([]), l = P(() => t.value.length), a = P(() => t.value[t.value.length - 1]), o = (d) => t.value.push(d), n = () => t.value.pop(), s = (d) => {
    t.value = t.value.filter((y) => y.uid !== d.uid);
  }, r = (d) => e.value.find((y) => {
    var b;
    return ((b = y.exposed) == null ? void 0 : b.id) === d;
  }) || null, i = Ya("updateHTMLAttrs", (d, y, b) => {
    const c = typeof d == "string" ? window == null ? void 0 : window.document.querySelector(d) : tt(d);
    c && (y === "class" ? c.classList.toggle(Ba, b === Ba) : c.setAttribute(y, b));
  });
  return yt(() => {
    i("body", "class", "");
  }), se(l, (d) => {
    i("body", "class", d > 0 ? Ba : "");
  }), { registry: e, stack: t, last: a, count: l, push: o, pop: n, remove: s, find: r };
}), Mr = (e) => {
  const { registry: t, push: l, remove: a } = el(), o = Ft();
  if (!o || o.type.__name !== "BModal")
    throw new Error("useModalManager must only use in BModal component");
  t.value.push(o), se(
    e,
    (n, s) => {
      n ? l(o) : s && !n && a(o);
    },
    { immediate: !0 }
  );
}, Dr = (e = void 0) => {
  const { find: t } = el(), l = Ft(), a = C(() => e ? t(e) : l ? Zo(l) : null), o = P(() => {
    var n;
    return (n = a.value) == null ? void 0 : n.proxy;
  });
  return {
    show() {
      var n, s;
      (s = (n = a.value) == null ? void 0 : n.exposed) == null || s.show();
    },
    hide(n = "") {
      var s, r;
      (r = (s = a.value) == null ? void 0 : s.exposed) == null || r.hide(n);
    },
    modal: o
  };
}, Zo = (e) => e.parent ? e.parent.type.__name === "BModal" ? e.parent : Zo(e.parent) : null, jr = () => {
  const { last: e, stack: t } = el();
  return {
    hide: (o = "") => {
      var n;
      e.value && ((n = e.value.exposed) == null || n.hide(o));
    },
    hideAll: (o = "") => {
      var s;
      const n = t.value.reverse();
      for (const r of n)
        (s = r.exposed) == null || s.hide(o);
    }
    // Todo: Supports listening events globally in the future
  };
}, Qo = (e, t) => {
  const l = P(() => e), a = P(() => t), o = P(() => !a.value);
  Ye(() => {
    const n = zr(
      document.body,
      l.value && o.value
    );
    se([l, o], ([s, r]) => {
      n.value = s && r;
    });
  });
}, qr = (e, t, l, a, o) => {
  if (e === void 0 || t === void 0 || l === void 0 || a === void 0)
    return t ?? [];
  const n = l;
  return t.sort((s, r) => {
    if (o !== void 0)
      return o(s, r, l, a);
    const i = (b) => typeof b == "object" ? JSON.stringify(b) : b;
    return i(s[n]) > i(r[n]) ? a ? -1 : 1 : i(r[n]) > i(s[n]) ? a ? 1 : -1 : 0;
  });
}, Gr = (e, t, l) => e.filter(
  (a) => Object.entries(a).filter((o) => {
    const [n, s] = o;
    return !s || n[0] === "_" || l && l.length > 0 && !l.includes(n) ? !1 : (typeof s == "object" ? JSON.stringify(Object.values(s)) : s.toString()).toLowerCase().includes(t.toLowerCase());
  }).length > 0
), Wr = (e, t, l, a, o) => {
  let n = e.value;
  const s = "isFilterableTable" in l && l.isFilterableTable.value === !0 && t.filter;
  (s && !a.value || s && a.value && l.noProviderFilteringBoolean.value) && (n = Gr(n, t.filter, t.filterable));
  const r = "isSortable" in l && l.isSortable.value === !0;
  return (r && !a.value || r && a.value && l.noProviderSortingBoolean.value) && (n = qr(
    t.fields,
    n,
    o == null ? void 0 : o.value,
    l.sortDescBoolean.value,
    t.sortCompare
  )), n;
}, Ur = (e, t, l, a) => {
  const o = M(), n = M(e.items ?? []), s = M([0, n.value.length]), r = C(() => {
    const b = t.requireItemsMapping.value ? Wr(n, e, t, l, a) : l.value ? n.value : e.items ?? [];
    if (e.perPage !== void 0) {
      const c = ((e.currentPage ?? 0) - 1) * e.perPage, h = c + e.perPage > b.length ? b.length : c + e.perPage;
      s.value = [c, h];
    }
    return b;
  }), i = C(() => e.perPage === void 0 || l.value && !t.noProviderPagingBoolean.value ? r.value : r.value.slice(s.value[0], s.value[1]));
  return {
    internalItems: n,
    computedItems: r,
    updateInternalItems: async (b) => {
      try {
        return n.value = b, n.value;
      } catch {
        return;
      }
    },
    filteredHandler: o,
    notifyFilteredItems: () => {
      o.value && o.value(r.value);
    },
    computedDisplayItems: i
  };
}, Xr = "top-right", en = zo(() => {
  const e = M([]);
  return { toasts: e, show: (...[a, o]) => {
    const n = { pos: Xr };
    typeof a == "string" ? Object.assign(n, o, {
      body: a,
      value: (o == null ? void 0 : o.value) || 5e3
    }) : Object.assign(n, a, { value: a.value || 5e3 });
    const s = Symbol();
    return e.value.push({ ...n, self: s }), s;
  }, hide: (a) => {
    const o = e.value.findIndex((n) => n.self === a);
    o !== -1 && e.value.splice(o, 1);
  } };
}), Kr = ["id"], Jr = ["innerHTML"], Yr = ["innerHTML"], tl = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "BPopover",
  props: {
    modelValue: { type: [String, Boolean], default: !1 },
    container: { default: void 0 },
    target: { default: null },
    reference: { default: null },
    content: { default: void 0 },
    id: { default: void 0 },
    title: { default: void 0 },
    delay: { default: () => ({ show: 100, hide: 300 }) },
    click: { type: [String, Boolean], default: !1 },
    manual: { type: [String, Boolean], default: !1 },
    variant: { default: null },
    offset: { default: null },
    customClass: { default: "" },
    placement: { default: "top" },
    strategy: { default: "absolute" },
    floatingMiddleware: { default: void 0 },
    noFlip: { type: [String, Boolean], default: !1 },
    noShift: { type: [String, Boolean], default: !1 },
    noFade: { type: [String, Boolean], default: !1 },
    noAutoClose: { type: [String, Boolean], default: !1 },
    hide: { type: [String, Boolean], default: !0 },
    realtime: { type: [String, Boolean], default: !1 },
    inline: { type: [String, Boolean], default: !1 },
    tooltip: { type: [String, Boolean], default: !1 },
    html: { type: [String, Boolean], default: !1 },
    noninteractive: { type: [String, Boolean], default: !1 }
  },
  emits: ["show", "shown", "hide", "hidden", "hide-prevented", "show-prevented", "update:modelValue"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = u(() => a.modelValue), n = M(o.value), s = M(o.value);
    Ot(() => {
      l("update:modelValue", n.value);
    }), se(o, () => {
      o.value !== n.value && (o.value ? le() : N(new Event("update:modelValue")));
    });
    const r = ke(() => a.id, "popover"), i = u(() => a.click), d = u(() => a.manual), y = u(() => a.noShift), b = u(() => a.noFlip), c = u(() => a.noFade), h = u(() => a.noAutoClose), S = u(() => a.hide), B = u(() => a.realtime), F = u(() => a.inline), w = u(() => a.tooltip), V = u(() => a.noninteractive), T = u(() => a.html), $ = M(!1), m = M(null), k = M(null), f = M(null), _ = M(null), L = M(null), v = C(
      () => a.title ? kt(a.title, Ct) : ""
    ), I = C(
      () => a.content ? kt(a.content, Ct) : ""
    ), z = P(() => a.placement.startsWith("auto")), O = Be(P(() => a.offset ?? NaN)), q = C(() => {
      if (a.floatingMiddleware !== void 0)
        return a.floatingMiddleware;
      const Q = a.offset !== null ? O.value : w.value ? 0 : 10, ne = [ko(Q)];
      return b.value === !1 && !z.value && ne.push(wo()), z.value && ne.push(
        Is({
          alignment: a.placement.split("-")[1] || void 0
        })
      ), y.value === !1 && ne.push($o()), S.value === !0 && ne.push(zs({ padding: 10 })), F.value === !0 && ne.push(Rs()), ne.push(nr({ element: f, padding: 10 })), ne;
    }), Y = P(
      () => z.value ? void 0 : a.placement
    ), { floatingStyles: U, middlewareData: ue, placement: ee, update: pe } = Lo(k, m, {
      placement: Y,
      middleware: q,
      strategy: He(P(a, "strategy")),
      whileElementsMounted: (...Q) => No(...Q, { animationFrame: B.value })
    }), te = M({ position: "absolute" });
    se(ue, () => {
      var Q;
      if (S.value === !0 && ((Q = ue.value.hide) != null && Q.referenceHidden ? $.value = !0 : $.value = !1), ue.value.arrow) {
        const { x: ne, y: Ae } = ue.value.arrow;
        te.value = {
          position: "absolute",
          top: Ae ? `${Ae}px` : "",
          left: ne ? `${ne}px` : ""
        };
      }
    });
    const ie = C(() => {
      const Q = w.value ? "tooltip" : "popover";
      return [
        Q,
        `b-${Q}`,
        {
          [`b-${Q}-${a.variant}`]: a.variant !== null,
          show: n.value && !$.value,
          "pe-none": !n.value,
          fade: !c.value,
          "d-none": !n.value && c.value,
          [`${a.customClass}`]: a.customClass !== void 0,
          [`bs-${Q}-${Qr(ee.value)}`]: ee.value !== void 0
        }
      ];
    }), { isOutside: me } = $l(m), { isOutside: G } = $l(_), W = (Q) => {
      const ne = Q ?? new Event("click");
      n.value ? N(ne) : le();
    }, de = (Q, ne = {}) => new Et(Q, {
      cancelable: !1,
      target: m.value || null,
      relatedTarget: null,
      trigger: null,
      ...ne,
      componentId: r.value
    });
    let ge;
    const le = () => {
      const Q = de("show", { cancelable: !0 });
      if (l("show", Q), Q.defaultPrevented) {
        l("show-prevented");
        return;
      }
      s.value = !0, Te(() => {
        var ne;
        pe(), ge = setTimeout(
          () => {
            pe(), n.value = !0, Te(() => {
              l("shown", de("shown"));
            });
          },
          typeof a.delay == "number" ? a.delay : ((ne = a.delay) == null ? void 0 : ne.show) || 0
        );
      });
    }, N = (Q) => {
      var rt;
      const ne = de("hide", { cancelable: !0 });
      if (l("hide", ne), ne.defaultPrevented) {
        l("hide-prevented");
        return;
      }
      ge && (clearTimeout(ge), ge = void 0);
      const Ae = typeof a.delay == "number" ? a.delay : ((rt = a.delay) == null ? void 0 : rt.hide) || 0;
      setTimeout(() => {
        var De, Ce;
        (Q == null ? void 0 : Q.type) === "click" || (Q == null ? void 0 : Q.type) === "update:modelValue" && d.value || !V.value && me.value && G.value && !((De = m.value) != null && De.contains(document == null ? void 0 : document.activeElement)) && !((Ce = _.value) != null && Ce.contains(document == null ? void 0 : document.activeElement)) || V.value && G.value ? (n.value = !1, Te(() => {
          setTimeout(
            () => {
              s.value = !1;
            },
            m.value ? wa(m.value) : 150
          ), l("hidden", de("hidden"));
        })) : setTimeout(
          () => {
            N(Q);
          },
          Ae < 50 ? 50 : Ae
        );
      }, Ae);
    };
    t({
      hideFn: N,
      show: le,
      toggle: W
    });
    const j = (Q) => {
      const ne = g(Q);
      if (ne) {
        if (typeof ne == "string") {
          const Ae = document.getElementById(ne);
          return Ae || void 0;
        }
        return ne.$el ? ne.$el : ne;
      }
    }, X = () => {
      var Q;
      if (a.target) {
        const ne = j(a.target);
        ne ? _.value = ne : console.warn("Target element not found", a.target);
      } else
        _.value = (Q = L.value) == null ? void 0 : Q.nextElementSibling;
      if (a.reference) {
        const ne = j(a.reference);
        ne ? k.value = ne : console.warn("Reference element not found", a.reference);
      } else
        k.value = _.value;
      !_.value || d.value || xa && (i.value && _.value.addEventListener("click", W), !i.value && _.value.addEventListener("pointerenter", le), !i.value && _.value.addEventListener("pointerleave", N), !i.value && _.value.addEventListener("focus", le), !i.value && _.value.addEventListener("blur", N));
    }, ce = () => {
      _.value && (_.value.removeEventListener("click", W), _.value.removeEventListener("pointerenter", le), _.value.removeEventListener("pointerleave", N), _.value.removeEventListener("focus", le), _.value.removeEventListener("blur", N));
    };
    return Do(
      m,
      () => {
        n.value && i.value && !h.value && !d.value && N(new Event("clickOutside"));
      },
      { ignore: [_] }
    ), se([() => a.click, () => a.target, () => a.reference], () => {
      ce(), X();
    }), Ye(X), Ia(ce), (Q, ne) => (p(), E(fe, null, [
      Z("span", {
        ref_key: "placeholder",
        ref: L
      }, null, 512),
      A(Q.$slots, "target", {
        show: le,
        hide: N,
        toggle: W,
        showState: n.value
      }),
      be(va, {
        tag: "Teleport",
        to: Q.container,
        skip: !Q.container
      }, {
        default: D(() => [
          s.value ? (p(), E("div", ae({
            key: 0,
            id: Q.id
          }, Q.$attrs, {
            ref_key: "element",
            ref: m,
            class: ie.value,
            role: "tooltip",
            tabindex: "-1",
            style: g(U)
          }), [
            Z("div", {
              ref_key: "arrow",
              ref: f,
              class: H(`${g(w) ? "tooltip" : "popover"}-arrow`),
              style: Re(te.value),
              "data-popper-arrow": ""
            }, null, 6),
            Q.title || Q.$slots.title ? (p(), E(fe, { key: 0 }, [
              g(T) ? (p(), E("div", {
                key: 1,
                class: H(g(w) ? "tooltip-inner" : "popover-header"),
                innerHTML: v.value
              }, null, 10, Jr)) : (p(), E("div", {
                key: 0,
                class: H(g(w) ? "tooltip-inner" : "popover-header")
              }, [
                A(Q.$slots, "title", {}, () => [
                  re(J(Q.title), 1)
                ])
              ], 2))
            ], 64)) : K("", !0),
            g(w) && !Q.$slots.title && !Q.title || !g(w) ? (p(), E(fe, { key: 1 }, [
              g(T) ? (p(), E("div", {
                key: 1,
                class: H(g(w) ? "tooltip-inner" : "popover-body"),
                innerHTML: I.value
              }, null, 10, Yr)) : (p(), E("div", {
                key: 0,
                class: H(g(w) ? "tooltip-inner" : "popover-body")
              }, [
                A(Q.$slots, "default", {}, () => [
                  re(J(Q.content), 1)
                ])
              ], 2))
            ], 64)) : K("", !0)
          ], 16, Kr)) : K("", !0)
        ]),
        _: 3
      }, 8, ["to", "skip"])
    ], 64));
  }
}), Zr = ({
  top: e,
  end: t,
  start: l,
  alignCenter: a,
  alignEnd: o
}) => {
  const n = e ? "top" : l ? "left" : t ? "right" : "bottom", s = o ? "end" : a ? null : "start";
  return `${n}${s ? `-${s}` : ""}`;
}, Qr = (e) => {
  const [t] = e.split("-");
  switch (t) {
    case "left":
      return "start";
    case "right":
      return "end";
    default:
      return t;
  }
}, Ht = (e) => typeof e != "object" || e.active !== !1, la = (e, t) => {
  if (!Ht(e))
    return {};
  const a = typeof e > "u" || typeof e == "object" && !e.title && !e.content, o = t.getAttribute("title") || t.getAttribute("data-original-title");
  return a ? o ? (t.removeAttribute("title"), t.setAttribute("data-original-title", o), {
    content: kt(o, Ct)
  }) : {} : typeof e == "string" ? {
    content: kt(e, Ct)
  } : {
    title: e != null && e.title ? kt(e == null ? void 0 : e.title, Ct) : void 0,
    content: e != null && e.content ? kt(e == null ? void 0 : e.content, Ct) : void 0
  };
}, _t = (e, t) => ({
  target: t,
  modelValue: e.modifiers.show,
  inline: e.modifiers.inline,
  click: e.modifiers.click,
  realtime: e.modifiers.realtime,
  placement: e.modifiers.left ? "left" : e.modifiers.right ? "right" : e.modifiers.bottom ? "bottom" : e.modifiers.top ? "top" : void 0,
  html: !0,
  ...typeof e.value == "object" ? e.value : {},
  title: null,
  content: null
}), oa = (e, t) => {
  var a;
  const l = document.createElement("span");
  t.modifiers.body ? document.body.appendChild(l) : t.modifiers.child ? e.appendChild(l) : (a = e.parentNode) == null || a.insertBefore(l, e.nextSibling), e.$__app = Mn({ render: () => {
    var o;
    return ye(tl, { ...(o = e.$__state) == null ? void 0 : o.value });
  } }), e.$__app.mount(l), e.$__element = l;
}, tn = (e) => {
  var l;
  const t = e.$__element;
  (l = e.$__app) == null || l.unmount(), delete e.$__app, delete e.$__state, setTimeout(() => {
    t == null || t.remove();
  }, 0), delete e.$__element;
}, _l = (e, t) => {
  const { all: l, ...a } = e, o = {};
  l && t.forEach((s) => {
    o[s] = l;
  });
  const n = { ...o, ...a };
  return Object.entries(n).filter(([s, r]) => !!r && t.includes(s)).map(([s]) => s);
}, ei = ["id"], ti = /* @__PURE__ */ R({
  __name: "BAccordion",
  props: {
    flush: { type: [String, Boolean], default: !1 },
    free: { type: [String, Boolean], default: !1 },
    id: { default: void 0 },
    modelValue: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const l = e, a = Se(l, "modelValue", t, { passive: !0 }), o = ke(() => l.id, "accordion"), n = u(() => l.flush), s = u(() => l.free), r = C(() => ({
      "accordion-flush": n.value
    }));
    return We(mo, {
      openItem: He(a),
      free: s,
      setOpenItem: (i) => {
        a.value = i;
      }
    }), (i, d) => (p(), E("div", {
      id: g(o),
      class: H(["accordion", r.value])
    }, [
      A(i.$slots, "default")
    ], 10, ei));
  }
}), an = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "BCollapse",
  props: {
    id: { default: void 0 },
    modelValue: { type: [String, Boolean], default: !1 },
    tag: { default: "div" },
    toggle: { type: [String, Boolean], default: !1 },
    horizontal: { type: [String, Boolean], default: !1 },
    visible: { type: [String, Boolean], default: !1 },
    isNav: { type: [String, Boolean], default: !1 }
  },
  emits: ["show", "shown", "hide", "hidden", "hide-prevented", "show-prevented", "update:modelValue"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = (m, k = {}) => new Et(m, {
      cancelable: !1,
      target: c.value || null,
      relatedTarget: null,
      trigger: null,
      ...k,
      componentId: b.value
    }), n = Se(a, "modelValue", l, { passive: !0 }), s = u(n), r = u(() => a.toggle), i = u(() => a.horizontal), d = u(() => a.isNav), y = u(() => a.visible), b = ke(() => a.id, "collapse"), c = M(null), h = M(!1), S = M(s.value), B = C(() => ({
      show: S.value,
      "navbar-collapse": d.value,
      collapsing: h.value,
      closing: S.value && !s.value,
      "collapse-horizontal": i.value
    })), F = () => {
      n.value = !1;
    }, w = () => {
      n.value = !0;
    }, V = () => {
      n.value = !s.value;
    }, T = () => {
      S.value = !0, h.value = !0;
      const m = o("show", { cancelable: !0 });
      if (l("show", m), m.defaultPrevented) {
        l("show-prevented");
        return;
      }
      Te(() => {
        c.value !== null && (i.value ? c.value.style.width = `${c.value.scrollWidth}px` : c.value.style.height = `${c.value.scrollHeight}px`, setTimeout(() => {
          h.value = !1, l("shown"), c.value !== null && (c.value.style.height = "", c.value.style.width = "");
        }, wa(c.value)));
      });
    }, $ = () => {
      const m = o("hide", { cancelable: !0 });
      if (l("hide", m), m.defaultPrevented) {
        l("hide-prevented");
        return;
      }
      c.value !== null && (i.value ? c.value.style.width = `${c.value.scrollWidth}px` : c.value.style.height = `${c.value.scrollHeight}px`, c.value.offsetHeight, h.value = !0, Te(() => {
        c.value !== null && (c.value.style.height = "", c.value.style.width = "", setTimeout(() => {
          S.value = !1, h.value = !1, l("hidden");
        }, wa(c.value)));
      }));
    };
    return se([n, S], () => {
      if (s.value === !0) {
        if (S.value)
          return;
        T();
        return;
      }
      $();
    }), Ye(() => {
      c.value !== null && !s.value && r.value && Te(() => {
        n.value = !0;
      });
    }), y.value && (n.value = !0, S.value = !0), se(y, (m) => {
      m ? w() : F();
    }), we(c, "bv-toggle", () => {
      n.value = !s.value;
    }), t({
      close: F,
      open: w,
      toggle: V,
      visible: He(S),
      isNav: d
    }), We(ja, {
      id: b,
      close: F,
      open: w,
      toggle: V,
      visible: He(S),
      isNav: d
    }), (m, k) => (p(), E(fe, null, [
      A(m.$slots, "header", {
        id: g(b),
        visible: g(s),
        toggle: V,
        open: w,
        close: F
      }),
      (p(), x(oe(m.tag), ae({
        id: g(b),
        ref_key: "element",
        ref: c,
        class: ["collapse", B.value],
        "is-nav": g(d)
      }, m.$attrs), {
        default: D(() => [
          A(m.$slots, "default", {
            visible: g(s),
            toggle: m.toggle,
            open: w,
            close: F
          })
        ]),
        _: 3
      }, 16, ["id", "class", "is-nav"])),
      A(m.$slots, "footer", {
        id: g(b),
        visible: g(s),
        toggle: V,
        open: w,
        close: F
      })
    ], 64));
  }
}), ai = { class: "accordion-item" }, li = ["aria-expanded", "aria-controls", "onClick"], oi = { class: "accordion-body" }, ni = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "BAccordionItem",
  props: {
    id: { default: void 0 },
    title: { default: void 0 },
    modelValue: { type: [String, Boolean], default: !1 },
    headerTag: { default: "h2" },
    tag: { default: void 0 },
    toggle: { type: [String, Boolean], default: void 0 },
    horizontal: { type: [String, Boolean], default: void 0 },
    visible: { type: [String, Boolean], default: !1 },
    isNav: { type: [String, Boolean], default: void 0 }
  },
  emits: ["show", "shown", "hide", "hidden", "hide-prevented", "show-prevented", "update:modelValue"],
  setup(e, { emit: t }) {
    const l = e, a = Se(l, "modelValue", t, { passive: !0 }), o = Pe(mo, null), n = ke(() => l.id, "accordion_item");
    return Ye(() => {
      a.value && !(o != null && o.free.value) && (o == null || o.setOpenItem(n.value)), !a.value && (o == null ? void 0 : o.openItem.value) === n.value && (a.value = !0);
    }), se(
      () => o == null ? void 0 : o.openItem.value,
      () => a.value = (o == null ? void 0 : o.openItem.value) === n.value && !(o != null && o.free.value)
    ), se(a, () => {
      a.value && !(o != null && o.free.value) && (o == null || o.setOpenItem(n.value));
    }), (s, r) => (p(), E("div", ai, [
      be(an, ae({
        id: g(n),
        modelValue: g(a),
        "onUpdate:modelValue": r[0] || (r[0] = (i) => La(a) ? a.value = i : null),
        class: "accordion-collapse"
      }, s.$attrs, {
        "aria-labelledby": `${g(n)}-heading`,
        tag: s.tag,
        toggle: s.toggle,
        horizontal: s.horizontal,
        visible: s.visible,
        "is-nav": s.isNav,
        onShow: r[1] || (r[1] = (i) => t("show", i)),
        onShown: r[2] || (r[2] = (i) => t("shown")),
        onHide: r[3] || (r[3] = (i) => t("hide", i)),
        onHidden: r[4] || (r[4] = (i) => t("hidden")),
        onHidePrevented: r[5] || (r[5] = (i) => t("hide-prevented")),
        onShowPrevented: r[6] || (r[6] = (i) => t("show-prevented"))
      }), {
        header: D(({ visible: i, toggle: d }) => [
          (p(), x(oe(s.headerTag), {
            id: `${g(n)}-heading`,
            class: "accordion-header"
          }, {
            default: D(() => [
              Z("button", {
                class: H(["accordion-button", { collapsed: !i }]),
                type: "button",
                "aria-expanded": i ? "true" : "false",
                "aria-controls": g(n),
                onClick: d
              }, [
                A(s.$slots, "title", {}, () => [
                  re(J(s.title), 1)
                ])
              ], 10, li)
            ]),
            _: 2
          }, 1032, ["id"]))
        ]),
        default: D(() => [
          Z("div", oi, [
            A(s.$slots, "default")
          ])
        ]),
        _: 3
      }, 16, ["id", "modelValue", "aria-labelledby", "tag", "toggle", "horizontal", "visible", "is-nav"])
    ]));
  }
}), Nt = /* @__PURE__ */ R({
  __name: "BTransition",
  props: {
    appear: { type: [String, Boolean], default: !1 },
    mode: { default: void 0 },
    noFade: { type: [String, Boolean], default: !1 },
    transProps: { default: void 0 }
  },
  setup(e) {
    const t = e, l = u(() => t.appear), a = u(() => t.noFade), o = C(() => {
      const r = {
        name: "",
        enterActiveClass: "",
        enterToClass: "",
        leaveActiveClass: "",
        leaveToClass: "showing",
        enterFromClass: "showing",
        leaveFromClass: ""
      }, i = {
        ...r,
        enterActiveClass: "fade showing",
        leaveActiveClass: "fade showing"
      };
      return a.value ? r : i;
    }), n = C(() => ({ mode: t.mode, css: !0, ...o.value })), s = C(
      () => t.transProps !== void 0 ? {
        // Order matters here since the props.transProps would get overwritten if it came first
        // But the goal of props.transProps is to overwrite base properties
        ...n.value,
        ...t.transProps
      } : l.value ? {
        ...n.value,
        appear: !0,
        appearActiveClass: o.value.enterActiveClass,
        appearToClass: o.value.enterToClass
      } : n.value
    );
    return (r, i) => (p(), x(Dn, _e(Ee(s.value)), {
      default: D(() => [
        A(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
const si = ["type", "disabled", "aria-label"], Pt = /* @__PURE__ */ R({
  __name: "BCloseButton",
  props: {
    ariaLabel: { default: "Close" },
    disabled: { type: [String, Boolean], default: !1 },
    type: { default: "button" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const l = e, a = u(() => l.disabled);
    return (o, n) => (p(), E("button", {
      type: o.type,
      class: "btn-close",
      disabled: g(a),
      "aria-label": o.ariaLabel,
      onClick: n[0] || (n[0] = (s) => t("click", s))
    }, null, 8, si));
  }
}), ri = {
  key: 0,
  class: "visually-hidden"
}, pa = /* @__PURE__ */ R({
  __name: "BSpinner",
  props: {
    label: { default: void 0 },
    role: { default: "status" },
    small: { type: [String, Boolean], default: !1 },
    tag: { default: "span" },
    type: { default: "border" },
    variant: { default: null }
  },
  setup(e) {
    const t = e, l = Oe(), a = u(() => t.small), o = C(() => [
      `spinner-${t.type}`,
      {
        [`spinner-${t.type}-sm`]: a.value,
        [`text-${t.variant}`]: t.variant !== null
      }
    ]), n = P(() => !Ve(l.label));
    return (s, r) => (p(), x(oe(s.tag), {
      class: H(o.value),
      role: s.label || n.value ? s.role : null,
      "aria-hidden": s.label || n.value ? null : !0
    }, {
      default: D(() => [
        s.label || n.value ? (p(), E("span", ri, [
          A(s.$slots, "label", {}, () => [
            re(J(s.label), 1)
          ])
        ])) : K("", !0)
      ]),
      _: 3
    }, 8, ["class", "role", "aria-hidden"]));
  }
}), Tl = "active", Qe = /* @__PURE__ */ R({
  __name: "BLink",
  props: {
    active: { type: [String, Boolean], default: void 0 },
    activeClass: { default: "router-link-active" },
    append: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    event: { default: "click" },
    href: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: [String, Boolean], default: !1 },
    routerComponentName: { default: "router-link" },
    routerTag: { default: "a" },
    target: { default: "_self" },
    to: { default: void 0 },
    variant: { default: null },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    underlineVariant: { default: null },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    icon: { type: [String, Boolean], default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const l = e, a = Yl(), o = u(() => l.active), n = u(() => l.icon);
    u(() => l.append);
    const s = u(() => l.disabled);
    u(() => l.replace);
    const r = Pe(ja, null), i = Pe(qa, null), d = Ft(), y = C(() => {
      const F = l.routerComponentName.split("-").map((V) => V.charAt(0).toUpperCase() + V.slice(1)).join("");
      return !((d == null ? void 0 : d.appContext.app.component(F)) !== void 0) || s.value || !l.to ? "a" : l.routerComponentName;
    }), b = C(() => {
      const F = "#";
      if (l.href)
        return l.href;
      if (typeof l.to == "string")
        return l.to || F;
      const w = l.to;
      if (Object.prototype.toString.call(w) === "[object Object]" && (w.path || w.query || w.hash)) {
        const V = w.path || "", T = w.query ? `?${Object.keys(w.query).map((m) => `${m}=${w.query[m]}`).join("=")}` : "", $ = !w.hash || w.hash.charAt(0) === "#" ? w.hash || "" : `#${w.hash}`;
        return `${V}${T}${$}` || F;
      }
      return F;
    }), c = C(() => ({
      [`link-${l.variant}`]: l.variant !== null,
      [`link-opacity-${l.opacity}`]: l.opacity !== void 0,
      [`link-opacity-${l.opacityHover}-hover`]: l.opacityHover !== void 0,
      [`link-underline-${l.underlineVariant}`]: l.underlineVariant !== null,
      [`link-offset-${l.underlineOffset}`]: l.underlineOffset !== void 0,
      [`link-offset-${l.underlineOffsetHover}-hover`]: l.underlineOffsetHover !== void 0,
      [`link-underline-opacity-${l.underlineOpacity}`]: l.underlineOpacity !== void 0,
      [`link-underline-opacity-${l.underlineOpacityHover}-hover`]: l.underlineOpacityHover !== void 0,
      "icon-link": n.value === !0
    })), h = C(() => ({
      class: c.value,
      to: l.to,
      href: b.value,
      target: l.target,
      rel: l.target === "_blank" && l.rel === void 0 ? "noopener" : l.rel || void 0,
      tabindex: s.value ? "-1" : typeof a.tabindex > "u" ? null : a.tabindex,
      "aria-disabled": s.value ? !0 : null
    })), S = C(() => ({
      [Tl]: o.value,
      disabled: s.value
    })), B = (F) => {
      var w, V, T;
      if (s.value) {
        F.preventDefault(), F.stopImmediatePropagation();
        return;
      }
      (((w = r == null ? void 0 : r.isNav) == null ? void 0 : w.value) === !0 && i === null || i !== null && ((V = i.autoClose) == null ? void 0 : V.value) === !0) && ((T = r == null ? void 0 : r.close) == null || T.call(r)), t("click", F);
    };
    return (F, w) => y.value === "router-link" ? (p(), x(oe(y.value), ae({ key: 0 }, h.value, { custom: "" }), {
      default: D(({ href: V, navigate: T, isActive: $ }) => [
        (p(), x(oe(F.routerTag), ae({
          href: V,
          class: [(g(o) ?? $) && `${F.activeClass} ${Tl}`]
        }, F.$attrs, {
          onClick: (m) => {
            T(m), B(m);
          }
        }), {
          default: D(() => [
            A(F.$slots, "default")
          ]),
          _: 2
        }, 1040, ["href", "class", "onClick"]))
      ]),
      _: 3
    }, 16)) : (p(), x(oe(y.value), ae({
      key: 1,
      class: S.value
    }, h.value, { onClick: B }), {
      default: D(() => [
        A(F.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), it = /* @__PURE__ */ R({
  __name: "BButton",
  props: {
    pill: { type: [String, Boolean], default: !1 },
    pressed: { type: [String, Boolean], default: void 0 },
    size: { default: "md" },
    squared: { type: [String, Boolean], default: !1 },
    tag: { default: "button" },
    type: { default: "button" },
    variant: { default: "secondary" },
    loading: { type: [String, Boolean], default: !1 },
    loadingFill: { type: [String, Boolean], default: !1 },
    block: { type: [String, Boolean], default: !1 },
    loadingText: { default: "Loading..." },
    active: { type: [String, Boolean], default: !1 },
    activeClass: { default: void 0 },
    append: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    event: { default: "click" },
    href: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: [String, Boolean], default: !1 },
    routerComponentName: { default: "router-link" },
    routerTag: { default: "a" },
    target: { default: "_self" },
    to: { default: void 0 },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    underlineVariant: { default: null },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    icon: { type: [String, Boolean], default: !1 }
  },
  emits: ["click", "update:pressed"],
  setup(e, { emit: t }) {
    const l = e, a = Se(l, "pressed", t), o = u(() => l.active), n = u(() => l.block), s = u(() => l.disabled), r = u(() => l.pill), i = u(() => l.pressed), d = u(() => l.squared), y = u(() => l.loading), b = u(() => l.loadingFill), { computedLink: c } = bt(l), h = P(() => typeof i.value == "boolean"), S = P(
      () => l.tag === "button" && l.href === void 0 && l.to === void 0
    ), B = P(() => l.to !== void 0), F = P(() => l.href !== void 0 ? !1 : !S.value), w = C(() => [
      [`btn-${l.size}`],
      {
        [`btn-${l.variant}`]: l.variant !== null,
        "btn-block": n.value,
        active: o.value || i.value,
        "rounded-pill": r.value,
        "rounded-0": d.value,
        disabled: s.value
      }
    ]), V = P(() => B.value ? Qe : l.href ? "a" : l.tag), T = ($) => {
      if (s.value) {
        $.preventDefault(), $.stopPropagation();
        return;
      }
      t("click", $), h.value && (a.value = !i.value);
    };
    return ($, m) => (p(), x(oe(V.value), {
      class: H(["btn", w.value]),
      "aria-disabled": F.value ? g(s) : null,
      "aria-pressed": h.value ? g(i) : null,
      autocomplete: h.value ? "off" : null,
      disabled: S.value ? g(s) : null,
      href: $.href,
      rel: g(c) ? $.rel : null,
      role: F.value || g(c) ? "button" : null,
      target: g(c) ? $.target : null,
      type: S.value ? $.type : null,
      to: S.value ? null : $.to,
      append: g(c) ? $.append : null,
      "active-class": B.value ? $.activeClass : null,
      event: B.value ? $.event : null,
      replace: B.value ? $.replace : null,
      "router-component-name": B.value ? $.routerComponentName : null,
      "router-tag": B.value ? $.routerTag : null,
      onClick: T
    }, {
      default: D(() => [
        g(y) ? A($.$slots, "loading", { key: 0 }, () => [
          g(b) ? K("", !0) : (p(), E(fe, { key: 0 }, [
            re(J($.loadingText), 1)
          ], 64)),
          A($.$slots, "loading-spinner", {}, () => [
            be(pa, {
              small: $.size !== "lg",
              label: g(b) ? $.loadingText : void 0
            }, null, 8, ["small", "label"])
          ])
        ]) : A($.$slots, "default", { key: 1 })
      ]),
      _: 3
    }, 8, ["class", "aria-disabled", "aria-pressed", "autocomplete", "disabled", "href", "rel", "role", "target", "type", "to", "append", "active-class", "event", "replace", "router-component-name", "router-tag"]));
  }
}), ii = /* @__PURE__ */ R({
  __name: "BAlert",
  props: {
    closeVariant: { default: "secondary" },
    closeClass: { default: void 0 },
    closeLabel: { default: "Close" },
    closeContent: { default: void 0 },
    noHoverPause: { type: [String, Boolean], default: !1 },
    dismissible: { type: [String, Boolean], default: !1 },
    fade: { type: [String, Boolean], default: !1 },
    modelValue: { type: [Boolean, Number], default: !1 },
    variant: { default: "info" },
    immediate: { type: [String, Boolean], default: !0 },
    interval: { default: 1e3 },
    showOnPause: { type: [String, Boolean], default: !0 }
  },
  emits: ["close", "closed", "close-countdown", "update:modelValue"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = Oe(), n = M(null), s = Se(a, "modelValue", l), r = Za(n), i = u(() => a.dismissible), d = u(() => a.fade), y = u(() => a.immediate), b = u(() => a.showOnPause), c = u(() => a.noHoverPause), h = Be(() => a.interval), S = P(() => !Ve(o.close)), B = P(() => typeof s.value == "boolean" ? 0 : s.value), F = C(() => ({
      [`alert-${a.variant}`]: a.variant !== null,
      "alert-dismissible": i.value
    })), w = C(() => [a.closeClass, { "btn-close-custom": S.value }]), {
      isActive: V,
      pause: T,
      restart: $,
      resume: m,
      stop: k,
      isPaused: f,
      value: _
    } = Go(B, h, {
      immediate: typeof s.value == "number" && y.value
    }), L = P(
      () => typeof s.value == "boolean" ? s.value : V.value || b.value && f.value
    ), v = C(() => ({
      variant: S.value ? a.closeVariant : void 0,
      class: w.value
    }));
    Ot(() => {
      l("close-countdown", _.value);
    });
    const I = () => {
      l("close"), typeof s.value == "boolean" ? s.value = !1 : (s.value = 0, k()), l("closed");
    }, z = () => {
      c.value || T();
    };
    return se(r, (O) => {
      if (O) {
        z();
        return;
      }
      m();
    }), Ia(k), t({
      pause: T,
      resume: m,
      restart: $,
      stop: k
    }), (O, q) => (p(), x(Nt, {
      "no-fade": !g(d),
      "trans-props": { enterToClass: "show" }
    }, {
      default: D(() => [
        L.value ? (p(), E("div", {
          key: 0,
          ref_key: "element",
          ref: n,
          class: H(["alert", F.value]),
          role: "alert",
          "aria-live": "polite",
          "aria-atomic": "true"
        }, [
          A(O.$slots, "default", {}, void 0, !0),
          g(i) ? (p(), E(fe, { key: 0 }, [
            S.value || O.closeContent ? (p(), x(it, ae({ key: 0 }, v.value, { onClick: I }), {
              default: D(() => [
                A(O.$slots, "close", {}, () => [
                  re(J(O.closeContent), 1)
                ], !0)
              ]),
              _: 3
            }, 16)) : (p(), x(Pt, ae({
              key: 1,
              "aria-label": O.closeLabel
            }, v.value, { onClick: I }), null, 16, ["aria-label"]))
          ], 64)) : K("", !0)
        ], 2)) : K("", !0)
      ]),
      _: 3
    }, 8, ["no-fade"]));
  }
});
const ma = (e, t) => {
  const l = e.__vccOpts || e;
  for (const [a, o] of t)
    l[a] = o;
  return l;
}, ui = /* @__PURE__ */ ma(ii, [["__scopeId", "data-v-dd6c5e17"]]), di = {
  key: 0,
  class: "b-avatar-custom"
}, ci = {
  key: 1,
  class: "b-avatar-img"
}, fi = ["src", "alt"], vi = { key: 1 }, Ta = (e) => {
  const t = typeof e == "string" && Un(e) ? Kt(e, 0) : e;
  return typeof t == "number" ? `${t}px` : t || null;
}, pi = /* @__PURE__ */ R({
  __name: "BAvatar",
  props: {
    alt: { default: "avatar" },
    badge: { type: [Boolean, String], default: !1 },
    badgeLeft: { type: [String, Boolean], default: !1 },
    badgeOffset: { default: void 0 },
    badgeTop: { type: [String, Boolean], default: !1 },
    badgeVariant: { default: "primary" },
    badgeTextVariant: { default: null },
    badgeBgVariant: { default: null },
    button: { type: [String, Boolean], default: !1 },
    buttonType: { default: "button" },
    icon: { type: [String, Boolean], default: void 0 },
    rounded: { type: [Boolean, String], default: "circle" },
    size: { default: void 0 },
    square: { type: [String, Boolean], default: !1 },
    src: { default: void 0 },
    text: { default: void 0 },
    active: { type: [String, Boolean], default: void 0 },
    activeClass: { default: void 0 },
    append: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    href: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: [String, Boolean], default: !1 },
    routerComponentName: { default: "router-link" },
    target: { default: "_self" },
    to: { default: void 0 },
    variant: { default: "secondary" },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    underlineVariant: { default: null },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  emits: ["click", "img-error"],
  setup(e, { emit: t }) {
    const l = e, a = Oe(), { computedLink: o, computedLinkProps: n } = bt(l), s = Pe(po, null), r = ["sm", null, "lg"], i = 0.4, d = i * 0.7, y = u(() => l.badgeLeft), b = u(() => l.badgeTop), c = u(() => l.button), h = u(() => l.disabled), S = u(() => l.square), B = P(() => !Ve(a.default)), F = P(() => !Ve(a.badge)), w = P(() => !!l.badge || l.badge === "" || F.value), V = P(() => (s == null ? void 0 : s.size.value) ?? Ta(l.size)), T = P(() => (s == null ? void 0 : s.variant.value) ?? l.variant), $ = P(() => (s == null ? void 0 : s.rounded.value) ?? l.rounded), m = je(() => ({
      variant: l.badgeVariant,
      bgVariant: l.badgeBgVariant,
      textVariant: l.badgeTextVariant
    })), k = P(() => l.badge === !0 ? "" : l.badge), f = P(() => (s == null ? void 0 : s.textVariant.value) ?? l.textVariant), _ = P(() => (s == null ? void 0 : s.bgVariant.value) ?? l.bgVariant), L = je(() => ({
      bgVariant: _.value,
      textVariant: f.value,
      variant: T.value
    })), v = C(() => [
      L.value,
      {
        [`b-avatar-${l.size}`]: !!l.size && r.indexOf(Ta(l.size)) !== -1,
        badge: !c.value && T.value !== null && B.value,
        rounded: $.value === "" || $.value === !0,
        "rounded-circle": !S.value && $.value === "circle",
        "rounded-0": S.value || $.value === "0",
        "rounded-1": !S.value && $.value === "sm",
        "rounded-3": !S.value && $.value === "lg",
        "rounded-top": !S.value && $.value === "top",
        "rounded-bottom": !S.value && $.value === "bottom",
        "rounded-start": !S.value && $.value === "left",
        "rounded-end": !S.value && $.value === "right",
        btn: c.value,
        [`btn-${T.value}`]: c.value ? T.value !== null : !1
      }
    ]), I = C(() => {
      const ee = l.badgeOffset || "0px";
      return {
        fontSize: (r.indexOf(V.value || null) === -1 ? `calc(${V.value} * ${d})` : "") || "",
        top: b.value ? ee : "",
        bottom: b.value ? "" : ee,
        left: y.value ? ee : "",
        right: y.value ? "" : ee
      };
    }), z = C(() => {
      const ee = r.indexOf(V.value || null) === -1 ? `calc(${V.value} * ${i})` : null;
      return ee ? { fontSize: ee } : {};
    }), O = C(() => {
      var te;
      const ee = ((te = s == null ? void 0 : s.overlapScale) == null ? void 0 : te.value) || 0, pe = V.value && ee ? `calc(${V.value} * -${ee})` : null;
      return pe ? { marginLeft: pe, marginRight: pe } : {};
    }), q = P(
      () => o.value ? Qe : c.value ? "button" : "span"
    ), Y = C(() => ({
      ...O.value,
      width: V.value ?? void 0,
      height: V.value ?? void 0
    })), U = (ee) => {
      !h.value && (o.value || c.value) && t("click", ee);
    }, ue = (ee) => {
      t("img-error", ee);
    };
    return (ee, pe) => (p(), x(oe(q.value), ae({
      class: ["b-avatar", v.value],
      style: Y.value
    }, g(n), {
      type: g(c) && !g(o) ? l.buttonType : void 0,
      disabled: g(h) || null,
      onClick: U
    }), {
      default: D(() => [
        B.value ? (p(), E("span", di, [
          A(ee.$slots, "default")
        ])) : ee.src ? (p(), E("span", ci, [
          Z("img", {
            src: ee.src,
            alt: ee.alt,
            onError: ue
          }, null, 40, fi)
        ])) : ee.text ? (p(), E("span", {
          key: 2,
          class: "b-avatar-text",
          style: Re(z.value)
        }, J(ee.text), 5)) : K("", !0),
        w.value ? (p(), E("span", {
          key: 3,
          class: H(["b-avatar-badge", g(m)]),
          style: Re(I.value)
        }, [
          F.value ? A(ee.$slots, "badge", { key: 0 }) : (p(), E("span", vi, J(k.value), 1))
        ], 6)) : K("", !0)
      ]),
      _: 3
    }, 16, ["class", "style", "type", "disabled"]));
  }
}), mi = /* @__PURE__ */ R({
  __name: "BAvatarGroup",
  props: {
    overlap: { default: 0.3 },
    rounded: { type: [Boolean, String], default: !1 },
    size: { default: void 0 },
    square: { type: [String, Boolean], default: !1 },
    tag: { default: "div" },
    variant: { default: null },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  setup(e) {
    const t = e, l = u(() => t.square), a = Be(() => t.overlap), o = C(() => Ta(t.size)), n = C(() => Math.min(Math.max(a.value, 0), 1) / 2), s = C(() => {
      const r = o.value ? `calc(${o.value} * ${n.value})` : null;
      return r ? { paddingLeft: r, paddingRight: r } : {};
    });
    return We(po, {
      overlapScale: n,
      size: P(() => t.size),
      square: l,
      rounded: P(() => t.rounded),
      variant: P(() => t.variant),
      bgVariant: P(() => t.bgVariant),
      textVariant: P(() => t.textVariant)
    }), (r, i) => (p(), x(oe(r.tag), {
      class: "b-avatar-group",
      role: "group"
    }, {
      default: D(() => [
        Z("div", {
          class: "b-avatar-group-inner",
          style: Re(s.value)
        }, [
          A(r.$slots, "default")
        ], 4)
      ]),
      _: 3
    }));
  }
}), gi = /* @__PURE__ */ R({
  __name: "BBadge",
  props: {
    pill: { type: [String, Boolean], default: !1 },
    tag: { default: "span" },
    textIndicator: { type: [String, Boolean], default: !1 },
    dotIndicator: { type: [String, Boolean], default: !1 },
    active: { type: [String, Boolean], default: void 0 },
    activeClass: { default: void 0 },
    append: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    href: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: [String, Boolean], default: !1 },
    routerComponentName: { default: "router-link" },
    target: { default: "_self" },
    to: { default: void 0 },
    variant: { default: "secondary" },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    underlineVariant: { default: null },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    icon: { type: [String, Boolean], default: !1 },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  setup(e) {
    const t = e, l = u(() => t.pill), a = u(() => t.textIndicator), o = u(() => t.dotIndicator), n = u(() => t.active), s = u(() => t.disabled), r = je(t), { computedLink: i, computedLinkProps: d } = bt(t, [
      "active",
      "activeClass",
      "append",
      "disabled",
      "href",
      "rel",
      "replace",
      "routerComponentName",
      "target",
      "to",
      "opacity",
      "opacityHover",
      "underlineVariant",
      "underlineOffset",
      "underlineOffsetHover",
      "underlineOpacity",
      "underlineOpacityHover",
      "icon"
    ]), y = P(() => i.value ? Qe : t.tag), b = C(() => [
      r.value,
      {
        active: n.value,
        disabled: s.value,
        "rounded-pill": l.value,
        "position-absolute top-0 start-100 translate-middle": a.value || o.value,
        "p-2 border border-light rounded-circle": o.value,
        "text-decoration-none": i.value
      }
    ]);
    return (c, h) => (p(), x(oe(y.value), ae({
      class: ["badge", b.value]
    }, g(d)), {
      default: D(() => [
        A(c.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), ln = /* @__PURE__ */ R({
  __name: "BBreadcrumbItem",
  props: {
    ariaCurrent: { default: "location" },
    text: { default: void 0 },
    active: { type: [String, Boolean], default: !1 },
    activeClass: { default: void 0 },
    append: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    href: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: [String, Boolean], default: !1 },
    routerComponentName: { default: "router-link" },
    target: { default: "_self" },
    to: { default: void 0 },
    variant: { default: void 0 },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    underlineVariant: { default: null },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    icon: { type: [String, Boolean], default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const l = e, a = u(() => l.active), o = u(() => l.disabled), n = C(() => ({
      active: a.value
    })), s = P(() => a.value ? "span" : Qe), r = P(() => a.value ? l.ariaCurrent : void 0), i = C(
      () => s.value !== "span" ? Da(l, [
        "active",
        "activeClass",
        "append",
        "disabled",
        "href",
        "rel",
        "replace",
        "routerComponentName",
        "target",
        "to",
        "variant",
        "opacity",
        "opacityHover",
        "underlineVariant",
        "underlineOffset",
        "underlineOffsetHover",
        "underlineOpacity",
        "underlineOpacityHover",
        "icon"
      ]) : {}
    ), d = (y) => {
      if (o.value || a.value) {
        y.preventDefault(), y.stopImmediatePropagation();
        return;
      }
      o.value || t("click", y);
    };
    return (y, b) => (p(), E("li", {
      class: H(["breadcrumb-item", n.value])
    }, [
      (p(), x(oe(s.value), ae({ "aria-current": r.value }, i.value, { onClick: d }), {
        default: D(() => [
          A(y.$slots, "default", {}, () => [
            re(J(y.text), 1)
          ])
        ]),
        _: 3
      }, 16, ["aria-current"]))
    ], 2));
  }
}), yi = { "aria-label": "breadcrumb" }, bi = { class: "breadcrumb" }, hi = /* @__PURE__ */ R({
  __name: "BBreadcrumb",
  props: {
    items: { default: void 0 }
  },
  setup(e) {
    const t = e, l = qo(), a = C(() => {
      const o = t.items || (l == null ? void 0 : l.items) || [];
      let n = !1;
      return o.map((r, i) => (typeof r == "string" && (r = { text: r }, i < o.length - 1 && (r.href = "#")), r.active && (n = !0), !r.active && !n && (r.active = i + 1 === o.length), r));
    });
    return (o, n) => (p(), E("nav", yi, [
      Z("ol", bi, [
        A(o.$slots, "prepend"),
        (p(!0), E(fe, null, he(a.value, (s, r) => (p(), x(ln, ae({ key: r }, s), {
          default: D(() => [
            re(J(s.text), 1)
          ]),
          _: 2
        }, 1040))), 128)),
        A(o.$slots, "default"),
        A(o.$slots, "append")
      ])
    ]));
  }
}), Bi = /* @__PURE__ */ R({
  __name: "BButtonGroup",
  props: {
    ariaLabel: { default: "Group" },
    size: { default: "md" },
    tag: { default: "div" },
    vertical: { type: [String, Boolean], default: !1 }
  },
  setup(e) {
    const t = e, l = u(() => t.vertical), a = C(() => ({
      "btn-group": !l.value,
      [`btn-group-${t.size}`]: t.size !== "md",
      "btn-group-vertical": l.value
    }));
    return (o, n) => (p(), x(oe(o.tag), {
      class: H(a.value),
      role: "group",
      "aria-label": o.ariaLabel
    }, {
      default: D(() => [
        A(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "aria-label"]));
  }
}), Si = ["role", "aria-label"], wi = /* @__PURE__ */ R({
  __name: "BButtonToolbar",
  props: {
    ariaLabel: { default: "Group" },
    justify: { type: [String, Boolean], default: !1 },
    role: { default: "toolbar" }
  },
  setup(e) {
    const t = e, l = u(() => t.justify), a = C(() => ({
      "justify-content-between": l.value
    }));
    return (o, n) => (p(), E("div", {
      class: H([a.value, "btn-toolbar"]),
      role: o.role,
      "aria-label": o.ariaLabel
    }, [
      A(o.$slots, "default")
    ], 10, Si));
  }
}), Ci = ["src", "width", "height", "srcset", "sizes", "loading"], ki = '<svg width="%{w}" height="%{h}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 %{w} %{h}" preserveAspectRatio="none"><rect width="100%" height="100%" style="fill:%{f};"></rect></svg>', al = /* @__PURE__ */ R({
  __name: "BImg",
  props: {
    blank: { type: [String, Boolean], default: !1 },
    blankColor: { default: "transparent" },
    block: { type: [String, Boolean], default: !1 },
    center: { type: [String, Boolean], default: !1 },
    fluid: { type: [String, Boolean], default: !1 },
    lazy: { type: [String, Boolean], default: !1 },
    fluidGrow: { type: [String, Boolean], default: !1 },
    height: { default: void 0 },
    start: { type: [String, Boolean], default: !1 },
    end: { type: [String, Boolean], default: !1 },
    rounded: { type: [Boolean, String], default: !1 },
    sizes: { default: void 0 },
    src: { default: void 0 },
    srcset: { default: void 0 },
    thumbnail: { type: [String, Boolean], default: !1 },
    width: { default: void 0 }
  },
  setup(e) {
    const t = e, l = u(() => t.lazy), a = u(() => t.blank), o = u(() => t.block), n = u(() => t.center), s = u(() => t.fluid), r = u(() => t.fluidGrow), i = u(() => t.start), d = u(() => t.end), y = u(() => t.thumbnail), b = Be(P(() => t.height ?? NaN)), c = Be(P(() => t.width ?? NaN)), h = C(
      () => typeof t.srcset == "string" ? t.srcset.split(",").filter(($) => $).join(",") : Array.isArray(t.srcset) ? t.srcset.filter(($) => $).join(",") : void 0
    ), S = C(
      () => typeof t.sizes == "string" ? t.sizes.split(",").filter(($) => $).join(",") : Array.isArray(t.sizes) ? t.sizes.filter(($) => $).join(",") : void 0
    ), B = C(() => {
      const $ = Number.isNaN(c.value) ? void 0 : c.value, m = Number.isNaN(b.value) ? void 0 : b.value;
      if (a.value) {
        if ($ !== void 0 && m === void 0)
          return { height: $, width: $ };
        if ($ === void 0 && m !== void 0)
          return { height: m, width: m };
        if ($ === void 0 && m === void 0)
          return { height: 1, width: 1 };
      }
      return {
        width: $,
        height: m
      };
    }), F = C(
      () => T(B.value.width, B.value.height, t.blankColor)
    ), w = C(
      () => i.value ? "float-start" : d.value ? "float-end" : n.value ? "mx-auto" : void 0
    ), V = C(() => ({
      "img-thumbnail": y.value,
      "img-fluid": s.value || r.value,
      "w-100": r.value,
      rounded: t.rounded === "" || t.rounded === !0,
      [`rounded-${t.rounded}`]: typeof t.rounded == "string" && t.rounded !== "",
      [`${w.value}`]: w.value !== void 0,
      "d-block": o.value || n.value
    })), T = ($, m, k) => `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
      ki.replace("%{w}", String($)).replace("%{h}", String(m)).replace("%{f}", k)
    )}`;
    return ($, m) => (p(), E("img", {
      class: H(V.value),
      src: g(a) ? F.value : t.src,
      width: B.value.width || void 0,
      height: B.value.height || void 0,
      srcset: g(a) ? void 0 : h.value,
      sizes: g(a) ? void 0 : S.value,
      loading: g(l) ? "lazy" : "eager"
    }, null, 10, Ci));
  }
}), na = /* @__PURE__ */ R({
  __name: "BCardImg",
  props: {
    bottom: { type: [String, Boolean], default: !1 },
    top: { type: [String, Boolean], default: !1 },
    blank: { type: [String, Boolean] },
    blankColor: {},
    block: { type: [String, Boolean] },
    center: { type: [String, Boolean] },
    fluid: { type: [String, Boolean] },
    lazy: { type: [String, Boolean] },
    fluidGrow: { type: [String, Boolean] },
    height: {},
    start: { type: [String, Boolean] },
    end: { type: [String, Boolean] },
    rounded: { type: [Boolean, String] },
    sizes: {},
    src: {},
    srcset: {},
    thumbnail: { type: [String, Boolean] },
    width: {}
  },
  setup(e) {
    const t = e, l = u(() => t.bottom), a = u(() => t.end), o = u(() => t.start), n = u(() => t.top), s = C(
      () => n.value ? "card-img-top" : a.value ? "card-img-right" : l.value ? "card-img-bottom" : o.value ? "card-img-left" : "card-img"
    ), r = C(() => io(t, ["bottom", "top", "end", "start"]));
    return (i, d) => (p(), x(al, ae(r.value, { class: s.value }), null, 16, ["class"]));
  }
}), $i = ["innerHTML"], on = /* @__PURE__ */ R({
  __name: "BCardHeadFoot",
  props: {
    text: { default: void 0 },
    borderVariant: { default: null },
    html: { default: void 0 },
    tag: { default: "div" },
    variant: { default: null },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  setup(e) {
    const t = e, l = je(t), a = C(() => [
      l.value,
      {
        [`border-${t.borderVariant}`]: t.borderVariant !== null
      }
    ]);
    return (o, n) => (p(), x(oe(o.tag), {
      class: H(a.value)
    }, {
      default: D(() => [
        o.html ? (p(), E("div", {
          key: 0,
          innerHTML: o.html
        }, null, 8, $i)) : A(o.$slots, "default", { key: 1 }, () => [
          re(J(o.text), 1)
        ])
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), nn = /* @__PURE__ */ R({
  __name: "BCardHeader",
  props: {
    text: { default: void 0 },
    borderVariant: { default: void 0 },
    html: { default: void 0 },
    tag: { default: "div" },
    variant: { default: void 0 },
    bgVariant: { default: void 0 },
    textVariant: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (l, a) => (p(), x(on, ae({ class: "card-header" }, t), {
      default: D(() => [
        A(l.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), sn = /* @__PURE__ */ R({
  __name: "BCardTitle",
  props: {
    text: { default: void 0 },
    tag: { default: "h4" }
  },
  setup(e) {
    return (t, l) => (p(), x(oe(t.tag), { class: "card-title" }, {
      default: D(() => [
        A(t.$slots, "default", {}, () => [
          re(J(t.text), 1)
        ])
      ]),
      _: 3
    }));
  }
}), rn = /* @__PURE__ */ R({
  __name: "BCardSubtitle",
  props: {
    text: { default: void 0 },
    tag: { default: "h6" },
    textVariant: { default: "body-secondary" }
  },
  setup(e) {
    const t = e, l = C(() => ({
      [`text-${t.textVariant}`]: t.textVariant !== null
    }));
    return (a, o) => (p(), x(oe(a.tag), {
      class: H(["card-subtitle mb-2", l.value])
    }, {
      default: D(() => [
        A(a.$slots, "default", {}, () => [
          re(J(a.text), 1)
        ])
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), un = /* @__PURE__ */ R({
  __name: "BCardBody",
  props: {
    tag: { default: "div" },
    overlay: { type: [String, Boolean], default: !1 },
    subtitle: { default: void 0 },
    subtitleTag: { default: "h4" },
    subtitleTextVariant: { default: void 0 },
    title: { default: void 0 },
    titleTag: { default: "h4" },
    text: { default: void 0 },
    variant: { default: null },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  setup(e) {
    const t = e, l = Oe(), a = u(() => t.overlay), o = je(t), n = P(() => !Ve(l.title)), s = P(() => !Ve(l.subtitle)), r = C(() => [
      o.value,
      {
        "card-img-overlay": a.value
      }
    ]);
    return (i, d) => (p(), x(oe(i.tag), {
      class: H(["card-body", r.value])
    }, {
      default: D(() => [
        i.title || n.value ? (p(), x(sn, {
          key: 0,
          tag: i.titleTag
        }, {
          default: D(() => [
            A(i.$slots, "title", {}, () => [
              re(J(i.title), 1)
            ])
          ]),
          _: 3
        }, 8, ["tag"])) : K("", !0),
        i.subtitle || s.value ? (p(), x(rn, {
          key: 1,
          tag: i.subtitleTag,
          "text-variant": i.subtitleTextVariant
        }, {
          default: D(() => [
            A(i.$slots, "subtitle", {}, () => [
              re(J(i.subtitle), 1)
            ])
          ]),
          _: 3
        }, 8, ["tag", "text-variant"])) : K("", !0),
        A(i.$slots, "default", {}, () => [
          re(J(i.text), 1)
        ])
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), dn = /* @__PURE__ */ R({
  __name: "BCardFooter",
  props: {
    text: { default: void 0 },
    borderVariant: { default: void 0 },
    html: { default: void 0 },
    tag: { default: "div" },
    variant: { default: void 0 },
    bgVariant: { default: void 0 },
    textVariant: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (l, a) => (p(), x(on, ae({ class: "card-footer" }, t), {
      default: D(() => [
        A(l.$slots, "default", {}, () => [
          re(J(l.text), 1)
        ])
      ]),
      _: 3
    }, 16));
  }
}), cn = /* @__PURE__ */ R({
  __name: "BCard",
  props: {
    align: { default: void 0 },
    bodyBgVariant: { default: void 0 },
    bodyTextVariant: { default: void 0 },
    bodyClass: { default: void 0 },
    bodyTag: { default: "div" },
    borderVariant: { default: null },
    footer: { default: void 0 },
    footerVariant: { default: null },
    footerBgVariant: { default: void 0 },
    footerBorderVariant: { default: void 0 },
    footerClass: { default: void 0 },
    footerHtml: { default: "" },
    footerTag: { default: "div" },
    footerTextVariant: { default: void 0 },
    header: { default: void 0 },
    headerBgVariant: { default: void 0 },
    headerBorderVariant: { default: void 0 },
    headerClass: { default: void 0 },
    headerHtml: { default: "" },
    headerTag: { default: "div" },
    headerVariant: { default: null },
    headerTextVariant: { default: void 0 },
    imgAlt: { default: void 0 },
    imgBottom: { type: [String, Boolean], default: !1 },
    imgEnd: { type: [String, Boolean], default: !1 },
    imgHeight: { default: void 0 },
    imgSrc: { default: void 0 },
    imgStart: { type: [String, Boolean], default: !1 },
    imgTop: { type: [String, Boolean], default: !1 },
    imgWidth: { default: void 0 },
    noBody: { type: [String, Boolean], default: !1 },
    overlay: { type: [String, Boolean], default: !1 },
    subtitle: { default: void 0 },
    subtitleTag: { default: "h6" },
    subtitleTextVariant: { default: "body-secondary" },
    tag: { default: "div" },
    title: { default: void 0 },
    titleTag: { default: "h4" },
    bodyText: { default: "" },
    variant: { default: null },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  setup(e) {
    const t = e, l = Oe(), a = u(() => t.imgBottom), o = u(() => t.imgEnd), n = u(() => t.imgStart), s = u(() => t.noBody), r = P(() => !Ve(l.header)), i = P(() => !Ve(l.footer)), d = je(t), y = C(() => [
      d.value,
      {
        [`text-${t.align}`]: t.align !== void 0,
        [`border-${t.borderVariant}`]: t.borderVariant !== null,
        "flex-row": n.value,
        "flex-row-reverse": o.value
      }
    ]), b = C(() => ({
      src: t.imgSrc,
      alt: t.imgAlt,
      height: t.imgHeight,
      width: t.imgWidth,
      bottom: t.imgBottom,
      end: t.imgEnd,
      start: t.imgStart,
      top: t.imgTop
    }));
    return (c, h) => (p(), x(oe(c.tag), {
      class: H(["card", y.value])
    }, {
      default: D(() => [
        g(a) ? K("", !0) : A(c.$slots, "img", { key: 0 }, () => [
          c.imgSrc ? (p(), x(na, _e(ae({ key: 0 }, b.value)), null, 16)) : K("", !0)
        ]),
        c.header || r.value || c.headerHtml ? (p(), x(nn, {
          key: 1,
          "bg-variant": c.headerBgVariant,
          variant: c.headerVariant,
          "border-variant": c.headerBorderVariant,
          html: c.headerHtml,
          tag: c.headerTag,
          "text-variant": c.headerTextVariant,
          class: H(c.headerClass)
        }, {
          default: D(() => [
            A(c.$slots, "header", {}, () => [
              re(J(c.header), 1)
            ])
          ]),
          _: 3
        }, 8, ["bg-variant", "variant", "border-variant", "html", "tag", "text-variant", "class"])) : K("", !0),
        g(s) ? A(c.$slots, "default", { key: 3 }, () => [
          re(J(c.bodyText), 1)
        ]) : (p(), x(un, {
          key: 2,
          overlay: c.overlay,
          "bg-variant": c.bodyBgVariant,
          tag: c.bodyTag,
          "text-variant": c.bodyTextVariant,
          subtitle: c.subtitle,
          "subtitle-tag": c.subtitleTag,
          "subtitle-text-variant": c.subtitleTextVariant,
          title: c.title,
          "title-tag": c.titleTag,
          class: H(c.bodyClass)
        }, {
          default: D(() => [
            A(c.$slots, "default", {}, () => [
              re(J(c.bodyText), 1)
            ])
          ]),
          _: 3
        }, 8, ["overlay", "bg-variant", "tag", "text-variant", "subtitle", "subtitle-tag", "subtitle-text-variant", "title", "title-tag", "class"])),
        c.footer || i.value || c.footerHtml ? (p(), x(dn, {
          key: 4,
          "bg-variant": c.footerBgVariant,
          "border-variant": c.footerBorderVariant,
          variant: c.footerVariant,
          html: c.footerHtml,
          tag: c.footerTag,
          "text-variant": c.footerTextVariant,
          class: H(c.footerClass)
        }, {
          default: D(() => [
            A(c.$slots, "footer", {}, () => [
              re(J(c.footer), 1)
            ])
          ]),
          _: 3
        }, 8, ["bg-variant", "border-variant", "variant", "html", "tag", "text-variant", "class"])) : K("", !0),
        g(a) ? A(c.$slots, "img", { key: 5 }, () => [
          c.imgSrc ? (p(), x(na, _e(ae({ key: 0 }, b.value)), null, 16)) : K("", !0)
        ]) : K("", !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), _i = /* @__PURE__ */ R({
  __name: "BCardGroup",
  props: {
    columns: { type: [String, Boolean], default: !1 },
    deck: { type: [String, Boolean], default: !1 },
    tag: { default: "div" }
  },
  setup(e) {
    const t = e, l = u(() => t.columns), a = u(() => t.deck), o = C(
      () => a.value ? "card-deck" : l.value ? "card-columns" : "card-group"
    );
    return (n, s) => (p(), x(oe(n.tag), {
      class: H(o.value)
    }, {
      default: D(() => [
        A(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Ti = /* @__PURE__ */ R({
  __name: "BCardText",
  props: {
    text: { default: void 0 },
    tag: { default: "p" }
  },
  setup(e) {
    return (t, l) => (p(), x(oe(t.tag), { class: "card-text" }, {
      default: D(() => [
        A(t.$slots, "default", {}, () => [
          re(J(t.text), 1)
        ])
      ]),
      _: 3
    }));
  }
}), Vi = ["id"], Ai = {
  key: 0,
  class: "carousel-indicators"
}, Oi = ["aria-current", "aria-label", "onClick"], Fi = /* @__PURE__ */ Z("span", {
  class: "carousel-control-prev-icon",
  "aria-hidden": "true"
}, null, -1), Ei = { class: "visually-hidden" }, Ni = /* @__PURE__ */ Z("span", {
  class: "carousel-control-next-icon",
  "aria-hidden": "true"
}, null, -1), Pi = { class: "visually-hidden" }, Li = /* @__PURE__ */ R({
  __name: "BCarousel",
  props: {
    ride: { type: [Boolean, String], default: !1 },
    noHoverPause: { type: [String, Boolean], default: !1 },
    rideReverse: { type: [String, Boolean], default: !1 },
    fade: { type: [String, Boolean], default: !1 },
    id: { default: void 0 },
    imgHeight: { default: void 0 },
    imgWidth: { default: void 0 },
    background: { default: void 0 },
    modelValue: { default: 0 },
    controls: { type: [String, Boolean], default: !1 },
    indicators: { type: [String, Boolean], default: !1 },
    interval: { default: 5e3 },
    noTouch: { type: [String, Boolean], default: !1 },
    noWrap: { type: [String, Boolean], default: !1 },
    controlsPrevText: { default: "Previous" },
    controlsNextText: { default: "Next" },
    indicatorsButtonLabel: { default: "Slide" },
    keyboard: { type: [String, Boolean], default: !0 },
    touchThreshold: { default: 50 }
  },
  emits: ["slid", "slide", "update:modelValue"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = Oe(), n = ke(() => a.id, "carousel"), s = Se(a, "modelValue", l, { passive: !0 }), r = u(() => a.keyboard), i = u(() => a.rideReverse), d = u(() => a.noHoverPause), y = u(() => a.fade), b = u(() => a.controls), c = u(() => a.indicators), h = u(() => a.noTouch), S = u(() => a.noWrap), B = Be(() => a.touchThreshold), F = Be(() => a.interval), w = M(!1), V = M(!1), T = M(!0), $ = M(null), m = M(null), k = M(s.value), f = Za(m), _ = C(
      () => Zl(a.ride) ? ia(a.ride) : a.ride
    ), L = C(
      () => `carousel-item carousel-item-${T.value ? "prev" : "next"} carousel-item-${T.value ? "end" : "start"}`
    ), v = C(
      () => `carousel-item active carousel-item-${T.value ? "start" : "end"}`
    ), { pause: I, resume: z } = Mo(
      () => {
        i.value ? ee() : pe();
      },
      F,
      { immediate: _.value === "carousel" }
    ), O = C(
      () => _.value === !0 && V.value === !0 || _.value === "carousel"
    ), q = C(() => Ca(o.default, "BCarouselSlide")), Y = C(() => ({ "carousel-fade": y.value })), U = (le) => {
      var N;
      return new Ql(le, {
        componentId: n.value,
        cancelable: !1,
        target: m.value,
        direction: T.value ? "right" : "left",
        from: k.value,
        to: s.value,
        relatedTarget: ((N = $.value) == null ? void 0 : N.children[s.value]) ?? null
      });
    }, ue = (le) => {
      if (w.value !== !0) {
        if (_.value === !0 && (V.value = !0), O.value === !0 && z(), T.value = !(le < s.value), le >= q.value.length) {
          if (S.value)
            return;
          s.value = 0;
          return;
        }
        if (le < 0) {
          if (S.value)
            return;
          s.value = q.value.length - 1;
          return;
        }
        k.value = s.value, s.value = le;
      }
    }, ee = () => {
      ue(s.value - 1);
    }, pe = () => {
      ue(s.value + 1);
    }, te = (le) => {
      r.value !== !1 && le();
    }, ie = () => {
      d.value || I();
    }, me = () => {
      O.value && z();
    }, { lengthX: G } = Hr(m, {
      passive: !0,
      onSwipeStart() {
        h.value !== !0 && I();
      },
      onSwipeEnd() {
        if (h.value === !0)
          return;
        const le = () => {
          O.value !== !1 && z();
        };
        if (G.value >= B.value) {
          pe(), le();
          return;
        }
        G.value <= -B.value && (ee(), le());
      }
    }), W = () => {
      l("slide", U("slide")), w.value = !0;
    }, de = () => {
      l("slid", U("slid")), w.value = !1;
    }, ge = (le) => {
      s.value !== 0 && le.classList.add("carousel-item");
    };
    return At(
      "ArrowLeft",
      () => {
        te(ee);
      },
      { target: m }
    ), At(
      "ArrowRight",
      () => {
        te(pe);
      },
      { target: m }
    ), se(
      () => a.ride,
      () => {
        V.value = !1;
      }
    ), se(f, (le) => {
      if (le) {
        ie();
        return;
      }
      me();
    }), t({
      pause: I,
      resume: z,
      prev: ee,
      next: pe
    }), We(uo, {
      background: P(() => a.background),
      width: P(() => a.imgWidth),
      height: P(() => a.imgHeight)
    }), (le, N) => (p(), E("div", {
      id: g(n),
      ref_key: "element",
      ref: m,
      class: H(["carousel slide pointer-event", Y.value])
    }, [
      g(c) ? (p(), E("div", Ai, [
        (p(!0), E(fe, null, he(q.value.length, (j, X) => (p(), E("button", {
          key: X,
          type: "button",
          "data-bs-target": "",
          class: H(X === g(s) ? "active" : ""),
          "aria-current": X === g(s) ? !0 : void 0,
          "aria-label": `${le.indicatorsButtonLabel} ${X}`,
          onClick: (ce) => ue(X)
        }, null, 10, Oi))), 128))
      ])) : K("", !0),
      Z("div", {
        ref_key: "relatedTarget",
        ref: $,
        class: "carousel-inner"
      }, [
        be(jn, {
          "enter-from-class": L.value,
          "enter-active-class": L.value,
          "enter-to-class": L.value,
          "leave-from-class": v.value,
          "leave-active-class": v.value,
          "leave-to-class": v.value,
          onBeforeLeave: W,
          onAfterLeave: de,
          onAfterEnter: ge
        }, {
          default: D(() => [
            (p(!0), E(fe, null, he(q.value, (j, X) => ft((p(), x(oe(j), {
              key: X,
              class: H({ active: X === g(s) && w.value === !1 })
            }, null, 8, ["class"])), [
              [ra, X === g(s)]
            ])), 128))
          ]),
          _: 1
        }, 8, ["enter-from-class", "enter-active-class", "enter-to-class", "leave-from-class", "leave-active-class", "leave-to-class"])
      ], 512),
      g(b) ? (p(), E(fe, { key: 1 }, [
        Z("button", {
          class: "carousel-control-prev",
          type: "button",
          onClick: ee
        }, [
          Fi,
          Z("span", Ei, J(le.controlsPrevText), 1)
        ]),
        Z("button", {
          class: "carousel-control-next",
          type: "button",
          onClick: pe
        }, [
          Ni,
          Z("span", Pi, J(le.controlsNextText), 1)
        ])
      ], 64)) : K("", !0)
    ], 10, Vi));
  }
}), Ii = ["innerHTML"], zi = { key: 1 }, Hi = ["innerHTML"], Ri = { key: 1 }, xi = /* @__PURE__ */ R({
  __name: "BCarouselSlide",
  props: {
    imgSrc: { default: void 0 },
    imgHeight: { default: void 0 },
    imgWidth: { default: void 0 },
    interval: { default: void 0 },
    background: { default: void 0 },
    caption: { default: void 0 },
    captionHtml: { default: void 0 },
    captionTag: { default: "h3" },
    contentTag: { default: "div" },
    contentVisibleUp: { default: void 0 },
    id: { default: void 0 },
    imgSrcset: { default: void 0 },
    imgAlt: { default: void 0 },
    imgBlank: { type: [String, Boolean], default: !1 },
    imgBlankColor: { default: "transparent" },
    text: { default: void 0 },
    textHtml: { default: void 0 },
    textTag: { default: "p" }
  },
  setup(e) {
    const t = e, l = Oe(), a = Pe(uo, null), o = P(() => t.text || t.textHtml || !Ve(l.text)), n = P(() => t.caption || t.captionHtml || !Ve(l.caption)), s = P(() => o.value || n.value || !Ve(l.default)), r = C(() => ({
      background: `${t.background || (a == null ? void 0 : a.background.value) || "rgb(171, 171, 171)"} none repeat scroll 0% 0%`
    })), i = C(() => ({
      "d-none": t.contentVisibleUp !== void 0,
      [`d-${t.contentVisibleUp}-block`]: t.contentVisibleUp !== void 0
    }));
    return (d, y) => (p(), E("div", {
      class: "carousel-item",
      style: Re(r.value)
    }, [
      A(d.$slots, "img", {}, () => {
        var b, c;
        return [
          be(al, {
            class: "d-block w-100",
            alt: d.imgAlt,
            srcset: d.imgSrcset,
            src: d.imgSrc,
            width: d.imgWidth || ((b = g(a)) == null ? void 0 : b.width.value),
            height: d.imgHeight || ((c = g(a)) == null ? void 0 : c.height.value),
            blank: d.imgBlank,
            "blank-color": d.imgBlankColor
          }, null, 8, ["alt", "srcset", "src", "width", "height", "blank", "blank-color"])
        ];
      }),
      s.value ? (p(), x(oe(d.contentTag), {
        key: 0,
        class: H(["carousel-caption", i.value])
      }, {
        default: D(() => [
          n.value ? (p(), x(oe(d.captionTag), { key: 0 }, {
            default: D(() => [
              A(d.$slots, "caption", {}, () => [
                d.captionHtml ? (p(), E("span", {
                  key: 0,
                  innerHTML: d.captionHtml
                }, null, 8, Ii)) : (p(), E("span", zi, J(d.caption), 1))
              ])
            ]),
            _: 3
          })) : K("", !0),
          o.value ? (p(), x(oe(d.textTag), { key: 1 }, {
            default: D(() => [
              A(d.$slots, "text", {}, () => [
                d.textHtml ? (p(), E("span", {
                  key: 0,
                  innerHTML: d.textHtml
                }, null, 8, Hi)) : (p(), E("span", Ri, J(d.text), 1))
              ])
            ]),
            _: 3
          })) : K("", !0),
          A(d.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"])) : K("", !0)
    ], 4));
  }
}), Vl = ua("", [], { type: [Boolean, String, Number], default: !1 }), Al = ua("offset", [""], { type: [String, Number], default: null }), Ol = ua("order", [""], { type: [String, Number], default: null }), Mi = R({
  name: "BCol",
  slots: Object,
  props: {
    col: { type: [Boolean, String], default: !1 },
    // Generic flexbox .col (xs)
    cols: { type: [String, Number], default: null },
    // .col-[1-12]|auto (xs)
    ...Vl,
    offset: { type: [String, Number], default: null },
    ...Al,
    order: { type: [String, Number], default: null },
    ...Ol,
    alignSelf: { type: String, default: null },
    tag: { type: String, default: "div" }
  },
  setup(e) {
    const t = [
      { content: Vl, propPrefix: "cols", classPrefix: "col" },
      { content: Al, propPrefix: "offset" },
      { content: Ol, propPrefix: "order" }
    ], l = u(() => e.col), a = C(
      () => t.flatMap((n) => ro(e, n.content, n.propPrefix, n.classPrefix))
    );
    return {
      computedClasses: C(() => [
        a.value,
        {
          col: l.value || !a.value.some((n) => /^col-/.test(n)) && !e.cols,
          [`col-${e.cols}`]: !!e.cols,
          [`offset-${e.offset}`]: !!e.offset,
          [`order-${e.order}`]: !!e.order,
          [`align-self-${e.alignSelf}`]: !!e.alignSelf
        }
      ])
    };
  }
});
function Di(e, t, l, a, o, n) {
  return p(), x(oe(e.tag), {
    class: H(e.computedClasses)
  }, {
    default: D(() => [
      A(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]);
}
const Lt = /* @__PURE__ */ ma(Mi, [["render", Di]]), ji = /* @__PURE__ */ R({
  __name: "BContainer",
  props: {
    gutterX: { default: void 0 },
    gutterY: { default: void 0 },
    fluid: { type: [String, Boolean], default: !1 },
    tag: { default: "div" }
  },
  setup(e) {
    const t = e, l = Be(
      P(() => t.gutterX ?? NaN),
      { method: "parseInt" }
    ), a = Be(
      P(() => t.gutterY ?? NaN),
      { method: "parseInt" }
    ), o = C(
      () => Zl(t.fluid) ? ia(t.fluid) : t.fluid
    ), n = C(() => ({
      container: o.value === !1,
      "container-fluid": o.value === !0,
      [`container-${o.value}`]: typeof o.value == "string",
      [`gx-${l.value}`]: !Number.isNaN(l.value),
      [`gy-${a.value}`]: !Number.isNaN(a.value)
    }));
    return (s, r) => (p(), x(oe(s.tag), {
      class: H(n.value)
    }, {
      default: D(() => [
        A(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), qi = { class: "visually-hidden" }, Gi = ["aria-labelledby", "role"], fn = /* @__PURE__ */ R({
  __name: "BDropdown",
  props: {
    ariaLabel: { default: void 0 },
    id: { default: void 0 },
    menuClass: { default: void 0 },
    size: { default: "md" },
    splitClass: { default: void 0 },
    splitVariant: { default: void 0 },
    text: { default: void 0 },
    toggleClass: { default: void 0 },
    autoClose: { type: [Boolean, String], default: !0 },
    block: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    isNav: { type: [String, Boolean], default: !1 },
    dropup: { type: [String, Boolean], default: !1 },
    dropend: { type: [String, Boolean], default: !1 },
    dropstart: { type: [String, Boolean], default: !1 },
    center: { type: [String, Boolean], default: !1 },
    end: { type: [String, Boolean], default: !1 },
    noFlip: { type: [String, Boolean], default: !1 },
    noShift: { type: [String, Boolean], default: !1 },
    offset: { default: 0 },
    role: { default: "menu" },
    split: { type: [String, Boolean], default: !1 },
    splitButtonType: { default: "button" },
    splitHref: { default: void 0 },
    splitDisabled: { type: [String, Boolean], default: void 0 },
    noCaret: { type: [String, Boolean], default: !1 },
    toggleText: { default: "Toggle dropdown" },
    variant: { default: "secondary" },
    modelValue: { type: [String, Boolean], default: !1 },
    lazy: { type: [String, Boolean], default: !1 },
    strategy: { default: "absolute" },
    floatingMiddleware: { default: void 0 },
    splitTo: { default: void 0 },
    boundary: { default: "clippingAncestors" },
    container: { default: void 0 }
  },
  emits: ["show", "shown", "hide", "hidden", "hide-prevented", "show-prevented", "click", "toggle", "update:modelValue"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = ke(() => a.id, "dropdown"), n = Se(a, "modelValue", l, { passive: !0 }), s = u(n), r = u(() => a.block), i = u(() => a.dropup), d = u(() => a.dropend), y = u(() => a.isNav), b = u(() => a.dropstart), c = u(() => a.center), h = u(() => a.end), S = u(() => a.split), B = u(() => a.noCaret), F = u(() => a.noFlip), w = u(() => a.noShift), V = u(() => a.lazy), T = u(() => a.splitDisabled), $ = P(
      () => typeof a.offset == "string" || typeof a.offset == "number" ? a.offset : NaN
    ), m = Be($), k = M(null), f = M(null), _ = M(null), L = C(
      () => a.boundary === "document" || a.boundary === "viewport" ? void 0 : a.boundary
    ), v = C(
      () => a.boundary === "document" || a.boundary === "viewport" ? a.boundary : void 0
    );
    At(
      "Escape",
      () => {
        n.value = !s;
      },
      { target: _ }
    );
    const I = P(() => S.value ? f.value : _.value), z = C(
      () => Zr({
        top: i.value,
        start: b.value,
        end: d.value,
        alignCenter: c.value,
        alignEnd: h.value
      })
    ), O = C(() => {
      if (a.floatingMiddleware !== void 0)
        return a.floatingMiddleware;
      const W = typeof a.offset == "string" || typeof a.offset == "number" ? m.value : a.offset, de = [ko(W)];
      return F.value === !1 && de.push(
        wo({
          boundary: L.value,
          rootBoundary: v.value
        })
      ), w.value === !1 && de.push(
        $o({
          boundary: L.value,
          rootBoundary: v.value
        })
      ), de;
    }), { update: q, floatingStyles: Y } = Lo(I, k, {
      placement: z,
      middleware: O,
      strategy: He(P(a, "strategy")),
      whileElementsMounted: No
    }), U = C(() => ({
      "d-grid": r.value,
      dropup: i.value,
      dropend: d.value,
      dropstart: b.value,
      "d-flex": r.value && S.value,
      "position-static": a.boundary !== "clippingAncestors" && !y.value
    })), ue = C(() => [
      S.value ? a.splitClass : a.toggleClass,
      {
        "nav-link": y.value,
        "dropdown-toggle": !S.value,
        "dropdown-toggle-no-caret": B.value && !S.value,
        "w-100": S.value && r.value,
        show: S.value ? void 0 : s.value
      }
    ]), ee = () => {
      G();
    }, pe = (W) => {
      S.value ? l("click", W) : ee();
    };
    Do(
      k,
      () => {
        s.value && (a.autoClose === !0 || a.autoClose === "outside") && G();
      },
      { ignore: [f, _] }
    );
    const te = () => {
      s.value && (a.autoClose === !0 || a.autoClose === "inside") && G();
    }, ie = () => {
      n.value && G();
    }, me = () => {
      n.value || G();
    }, G = () => {
      l("toggle");
      const W = s.value, de = new Et(W ? "hide" : "show");
      if (l(W ? "hide" : "show", de), de.defaultPrevented) {
        l(W ? "hide-prevented" : "show-prevented");
        return;
      }
      n.value = !W, l(W ? "hidden" : "shown");
    };
    return se(s, q), t({
      close: ie,
      open: me,
      toggle: G
    }), We(bo, {
      id: o,
      open: me,
      close: ie,
      toggle: G,
      visible: s,
      isNav: y
    }), (W, de) => (p(), E("div", {
      class: H([U.value, "btn-group"])
    }, [
      be(it, {
        id: g(o),
        ref_key: "splitButton",
        ref: _,
        variant: W.splitVariant || W.variant,
        size: W.size,
        class: H(ue.value),
        disabled: g(T) || W.disabled,
        type: W.splitButtonType,
        "aria-label": W.ariaLabel,
        "aria-expanded": g(S) ? void 0 : g(s),
        "aria-haspopup": g(S) ? void 0 : "menu",
        href: g(S) ? W.splitHref : void 0,
        to: g(S) && W.splitTo ? W.splitTo : void 0,
        onClick: pe
      }, {
        default: D(() => [
          A(W.$slots, "button-content", {}, () => [
            re(J(W.text), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "variant", "size", "class", "disabled", "type", "aria-label", "aria-expanded", "aria-haspopup", "href", "to"]),
      g(S) ? (p(), x(it, {
        key: 0,
        ref_key: "button",
        ref: f,
        variant: W.variant,
        size: W.size,
        disabled: W.disabled,
        class: H([[W.toggleClass, g(s) ? "show" : void 0], "dropdown-toggle-split dropdown-toggle"]),
        "aria-expanded": g(s),
        "aria-haspopup": "menu",
        onClick: ee
      }, {
        default: D(() => [
          Z("span", qi, [
            A(W.$slots, "toggle-text", {}, () => [
              re(J(W.toggleText), 1)
            ])
          ])
        ]),
        _: 3
      }, 8, ["variant", "size", "disabled", "class", "aria-expanded"])) : K("", !0),
      be(va, {
        tag: "Teleport",
        to: W.container,
        skip: !W.container
      }, {
        default: D(() => [
          !g(V) || g(s) ? ft((p(), E("ul", {
            key: 0,
            ref_key: "floating",
            ref: k,
            style: Re(g(Y)),
            class: H(["dropdown-menu show", W.menuClass]),
            "aria-labelledby": g(o),
            role: W.role,
            onClick: te
          }, [
            A(W.$slots, "default", {
              hide: ie,
              show: me
            })
          ], 14, Gi)), [
            [ra, g(V) || g(s)]
          ]) : K("", !0)
        ]),
        _: 3
      }, 8, ["to", "skip"])
    ], 2));
  }
}), Wi = { role: "presentation" }, Ui = /* @__PURE__ */ R({
  __name: "BDropdownDivider",
  props: {
    tag: { default: "hr" }
  },
  setup(e) {
    return (t, l) => (p(), E("li", Wi, [
      (p(), x(oe(t.tag), {
        class: "dropdown-divider",
        role: "separator",
        "aria-orientation": "horizontal"
      }))
    ]));
  }
}), Xi = { role: "presentation" }, Ki = { class: "px-4 py-3" }, Ji = /* @__PURE__ */ R({
  __name: "BDropdownForm",
  setup(e) {
    return (t, l) => (p(), E("li", Xi, [
      Z("form", Ki, [
        A(t.$slots, "default")
      ])
    ]));
  }
}), Yi = { role: "presentation" }, Zi = ["id", "aria-describedby"], Qi = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "BDropdownGroup",
  props: {
    id: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    header: { default: void 0 },
    headerClass: { default: void 0 },
    headerTag: { default: "header" },
    headerVariant: { default: null }
  },
  setup(e) {
    const t = e, l = P(() => t.id ? `${t.id}_group_dd_header` : void 0), a = P(() => t.headerTag === "header" ? void 0 : "heading"), o = C(() => [
      t.headerClass,
      {
        [`text-${t.headerVariant}`]: t.headerVariant !== null
      }
    ]);
    return (n, s) => (p(), E("li", Yi, [
      (p(), x(oe(n.headerTag), {
        id: l.value,
        class: H(["dropdown-header", o.value]),
        role: a.value
      }, {
        default: D(() => [
          A(n.$slots, "header", {}, () => [
            re(J(n.header), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "class", "role"])),
      Z("ul", ae({
        id: n.id,
        role: "group",
        class: "list-unstyled"
      }, n.$attrs, {
        "aria-describedby": n.ariaDescribedby || l.value
      }), [
        A(n.$slots, "default")
      ], 16, Zi)
    ]));
  }
}), eu = { class: "dropdown-header" }, tu = /* @__PURE__ */ R({
  __name: "BDropdownHeader",
  setup(e) {
    return (t, l) => (p(), E("li", null, [
      Z("h6", eu, [
        A(t.$slots, "default")
      ])
    ]));
  }
}), au = { role: "presentation" }, lu = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "BDropdownItem",
  props: {
    linkClass: { default: void 0 },
    active: { type: [String, Boolean], default: void 0 },
    activeClass: { default: void 0 },
    append: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean] },
    href: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: [String, Boolean], default: !1 },
    routerComponentName: { default: "router-link" },
    target: { default: "_self" },
    to: { default: void 0 },
    variant: {},
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    underlineVariant: { default: null },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    icon: { type: [String, Boolean] }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const l = e, a = u(() => l.active), o = u(() => l.disabled), { computedLink: n, computedLinkProps: s } = bt(l), r = C(() => [
      l.linkClass,
      {
        active: a.value,
        disabled: o.value,
        [`text-${l.variant}`]: l.variant !== null
      }
    ]), i = P(() => n.value ? Qe : l.href ? "a" : "button"), d = Pe(ja, null), y = Pe(bo, null), b = Pe(qa, null), c = (h) => {
      var S, B, F;
      t("click", h), b !== null && ((S = b == null ? void 0 : b.autoClose) == null ? void 0 : S.value) === !0 && ((B = d == null ? void 0 : d.close) == null || B.call(d)), (F = y == null ? void 0 : y.close) == null || F.call(y);
    };
    return (h, S) => (p(), E("li", au, [
      (p(), x(oe(i.value), ae({
        class: ["dropdown-item", r.value],
        disabled: g(o),
        "aria-disabled": g(o) ? !0 : null,
        "aria-current": g(a) ? !0 : null,
        href: i.value === "a" ? h.href : null,
        rel: h.rel,
        role: "menuitem",
        type: i.value === "button" ? "button" : null,
        target: h.target
      }, g(s), { onClick: c }), {
        default: D(() => [
          A(h.$slots, "default")
        ]),
        _: 3
      }, 16, ["class", "disabled", "aria-disabled", "aria-current", "href", "rel", "type", "target"]))
    ]));
  }
}), ou = { role: "presentation" }, nu = ["disabled"], su = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "BDropdownItemButton",
  props: {
    buttonClass: { default: void 0 },
    active: { type: [String, Boolean], default: !1 },
    activeClass: { default: "active" },
    disabled: { type: [String, Boolean], default: !1 },
    variant: { default: null }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const l = e, a = u(() => l.active), o = u(() => l.disabled), n = C(() => [
      l.buttonClass,
      {
        [l.activeClass]: a.value,
        disabled: o.value,
        [`text-${l.variant}`]: l.variant !== null
      }
    ]), s = (r) => {
      t("click", r);
    };
    return (r, i) => (p(), E("li", ou, [
      Z("button", {
        role: "menu",
        type: "button",
        class: H(["dropdown-item", n.value]),
        disabled: g(o),
        onClick: s
      }, [
        A(r.$slots, "default")
      ], 10, nu)
    ]));
  }
}), ru = { role: "presentation" }, iu = { class: "px-4 py-1 mb-0 text-body-secondary" }, uu = /* @__PURE__ */ R({
  __name: "BDropdownText",
  props: {
    text: { default: "" }
  },
  setup(e) {
    return (t, l) => (p(), E("li", ru, [
      Z("p", iu, [
        A(t.$slots, "default", {}, () => [
          re(J(t.text), 1)
        ])
      ])
    ]));
  }
}), du = ["id", "novalidate", "onSubmit"], vn = /* @__PURE__ */ R({
  __name: "BForm",
  props: {
    id: { default: void 0 },
    floating: { type: [String, Boolean], default: !1 },
    novalidate: { type: [String, Boolean], default: !1 },
    validated: { type: [String, Boolean], default: !1 }
  },
  emits: ["submit"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = M(null), n = u(() => a.floating), s = u(() => a.novalidate), r = u(() => a.validated), i = C(() => ({
      "form-floating": n.value,
      "was-validated": r.value
    })), d = (y) => {
      l("submit", y);
    };
    return t({
      element: o
    }), (y, b) => (p(), E("form", {
      id: y.id,
      ref_key: "element",
      ref: o,
      novalidate: g(s),
      class: H(i.value),
      onSubmit: za(d, ["prevent"])
    }, [
      A(y.$slots, "default")
    ], 42, du));
  }
}), cu = { class: "form-floating" }, fu = ["for"], vu = /* @__PURE__ */ R({
  __name: "BFormFloatingLabel",
  props: {
    labelFor: { default: void 0 },
    label: { default: void 0 },
    text: { default: void 0 }
  },
  setup(e) {
    return (t, l) => (p(), E("div", cu, [
      A(t.$slots, "default", {}, () => [
        re(J(t.text), 1)
      ]),
      Z("label", { for: t.labelFor }, [
        A(t.$slots, "label", {}, () => [
          re(J(t.label), 1)
        ])
      ], 8, fu)
    ]));
  }
}), Va = /* @__PURE__ */ R({
  __name: "BFormInvalidFeedback",
  props: {
    ariaLive: { default: void 0 },
    forceShow: { type: [String, Boolean], default: !1 },
    text: { default: void 0 },
    id: { default: void 0 },
    role: { default: void 0 },
    state: { type: [String, Boolean, null], default: null },
    tag: { default: "div" },
    tooltip: { type: [String, Boolean], default: !1 }
  },
  setup(e) {
    const t = e, l = u(() => t.forceShow), a = u(() => t.state), o = u(() => t.tooltip), n = P(() => l.value === !0 || a.value === !1), s = C(() => ({
      "d-block": n.value,
      "invalid-feedback": !o.value,
      "invalid-tooltip": o.value
    }));
    return (r, i) => (p(), x(oe(r.tag), {
      id: r.id,
      role: r.role,
      "aria-live": r.ariaLive,
      "aria-atomic": r.ariaLive ? !0 : void 0,
      class: H(s.value)
    }, {
      default: D(() => [
        A(r.$slots, "default", {}, () => [
          re(J(r.text), 1)
        ])
      ]),
      _: 3
    }, 8, ["id", "role", "aria-live", "aria-atomic", "class"]));
  }
}), Jt = /* @__PURE__ */ R({
  __name: "BFormRow",
  props: {
    tag: { default: "div" }
  },
  setup(e) {
    return (t, l) => (p(), x(oe(t.tag), { class: "row d-flex flex-wrap" }, {
      default: D(() => [
        A(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Aa = /* @__PURE__ */ R({
  __name: "BFormText",
  props: {
    id: { default: void 0 },
    inline: { type: [String, Boolean], default: !1 },
    tag: { default: "small" },
    text: { default: void 0 },
    textVariant: { default: "body-secondary" }
  },
  setup(e) {
    const t = e, l = u(() => t.inline), a = C(() => ({
      [`text-${t.textVariant}`]: t.textVariant !== null,
      "form-text": !l.value
    }));
    return (o, n) => (p(), x(oe(o.tag), {
      id: o.id,
      class: H(a.value)
    }, {
      default: D(() => [
        A(o.$slots, "default", {}, () => [
          re(J(o.text), 1)
        ])
      ]),
      _: 3
    }, 8, ["id", "class"]));
  }
}), Oa = /* @__PURE__ */ R({
  __name: "BFormValidFeedback",
  props: {
    ariaLive: { default: void 0 },
    forceShow: { type: [String, Boolean], default: !1 },
    text: { default: void 0 },
    id: { default: void 0 },
    role: { default: void 0 },
    state: { type: [String, Boolean, null], default: null },
    tag: { default: "div" },
    tooltip: { type: [String, Boolean], default: !1 }
  },
  setup(e) {
    const t = e, l = u(() => t.forceShow), a = u(() => t.state), o = u(() => t.tooltip), n = P(() => l.value === !0 || a.value === !0), s = C(() => ({
      "d-block": n.value,
      "valid-feedback": !o.value,
      "valid-tooltip": o.value
    }));
    return (r, i) => (p(), x(oe(r.tag), {
      id: r.id,
      role: r.role,
      "aria-live": r.ariaLive,
      "aria-atomic": r.ariaLive ? !0 : void 0,
      class: H(s.value)
    }, {
      default: D(() => [
        A(r.$slots, "default", {}, () => [
          re(J(r.text), 1)
        ])
      ]),
      _: 3
    }, 8, ["id", "role", "aria-live", "aria-atomic", "class"]));
  }
}), pu = ["id", "disabled", "required", "name", "form", "aria-label", "aria-labelledby", "aria-required", "value", "indeterminate"], mu = ["for"], pn = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "BFormCheckbox",
  props: {
    ariaLabel: { default: void 0 },
    ariaLabelledBy: { default: void 0 },
    form: { default: void 0 },
    indeterminate: { type: [String, Boolean], default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    autofocus: { type: [String, Boolean], default: !1 },
    plain: { type: [String, Boolean], default: !1 },
    button: { type: [String, Boolean], default: !1 },
    buttonGroup: { type: [String, Boolean], default: !1 },
    switch: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    buttonVariant: { default: null },
    inline: { type: [String, Boolean], default: !1 },
    required: { type: [String, Boolean], default: void 0 },
    size: { default: void 0 },
    state: { type: [String, Boolean, null], default: null },
    uncheckedValue: { type: [Array, Set, Boolean, String, Object, Number, null], default: void 0 },
    value: { type: [Array, Set, Boolean, String, Object, Number, null], default: !0 },
    modelValue: { type: [Array, Set, Boolean, String, Object, Number, null], default: void 0 }
  },
  emits: ["update:modelValue", "input", "change"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = Oe(), n = Se(a, "modelValue", l, { passive: !0 }), s = ke(() => a.id, "form-check"), r = u(() => a.indeterminate), i = u(() => a.autofocus), d = u(() => a.plain), y = u(() => a.button), b = u(() => a.buttonGroup), c = u(() => a.switch), h = u(() => a.disabled), S = u(() => a.inline), B = u(() => a.required), F = u(() => a.state), w = Pe(go, null), V = M(null), { focused: T } = Ne(V, {
      initialValue: i.value
    }), $ = P(() => !Ve(o.default));
    let m = !1;
    const k = C({
      get: () => {
        var O;
        return w !== null ? w.modelValue.value.map((q) => JSON.stringify(q)).includes(JSON.stringify(a.value)) : Array.isArray(n.value) ? (O = n.value) == null ? void 0 : O.map((q) => JSON.stringify(q)).includes(JSON.stringify(a.value)) : JSON.stringify(n.value) === JSON.stringify(a.value);
      },
      set: (O) => {
        const q = O ? a.value : a.uncheckedValue === void 0 && a.value !== !1 ? !1 : a.uncheckedValue;
        l("input", q), w === null && Array.isArray(n.value) ? O ? (n.value.push(a.value), a.uncheckedValue !== void 0 && (n.value = n.value.filter(
          (Y) => JSON.stringify(Y) !== JSON.stringify(a.uncheckedValue)
        ))) : (a.uncheckedValue !== void 0 && n.value.push(a.uncheckedValue), n.value = n.value.filter(
          (Y) => JSON.stringify(Y) !== JSON.stringify(a.value)
        )) : w !== null ? (m = !0, n.value = q, O === !1 ? w.remove(a.value) : w.set(a.value)) : n.value = q, Te(() => {
          l("change", q), m = !1;
        });
      }
    });
    se(n, (O) => {
      if (m) {
        m = !1;
        return;
      }
      w !== null && ((O === a.value || O === !0) && k.value !== !0 ? k.value = !0 : (O === a.uncheckedValue || O === !1) && k.value !== !1 && (k.value = !1));
    });
    const f = C(
      () => !!(a.name ?? (w == null ? void 0 : w.name.value)) && (B.value || (w == null ? void 0 : w.required.value))
    ), _ = P(() => b.value || ((w == null ? void 0 : w.buttons.value) ?? !1)), L = C(() => ({
      plain: d.value || ((w == null ? void 0 : w.plain.value) ?? !1),
      button: y.value || ((w == null ? void 0 : w.buttons.value) ?? !1),
      inline: S.value || ((w == null ? void 0 : w.inline.value) ?? !1),
      switch: c.value || ((w == null ? void 0 : w.switch.value) ?? !1),
      state: F.value || (w == null ? void 0 : w.state.value),
      size: a.size !== void 0 ? a.size : (w == null ? void 0 : w.size.value) ?? "md",
      // This is where the true default is made
      buttonVariant: a.buttonVariant !== null ? a.buttonVariant : (w == null ? void 0 : w.buttonVariant.value) ?? "secondary"
      // This is where the true default is made
    })), v = Wo(L), I = Uo(L), z = Xo(L);
    return t({
      element: V,
      focus: () => {
        T.value = !0;
      },
      blur: () => {
        T.value = !1;
      }
    }), (O, q) => (p(), x(va, {
      skip: _.value,
      class: H(g(v))
    }, {
      default: D(() => {
        var Y, U, ue;
        return [
          ft(Z("input", ae({ id: g(s) }, O.$attrs, {
            ref_key: "input",
            ref: V,
            "onUpdate:modelValue": q[0] || (q[0] = (ee) => k.value = ee),
            class: g(I),
            type: "checkbox",
            disabled: g(h) || ((Y = g(w)) == null ? void 0 : Y.disabled.value),
            required: f.value || void 0,
            name: O.name || ((U = g(w)) == null ? void 0 : U.name.value),
            form: O.form || ((ue = g(w)) == null ? void 0 : ue.form.value),
            "aria-label": O.ariaLabel,
            "aria-labelledby": O.ariaLabelledBy,
            "aria-required": f.value || void 0,
            value: O.value,
            indeterminate: g(r)
          }), null, 16, pu), [
            [qn, k.value]
          ]),
          $.value || g(d) === !1 ? (p(), E("label", {
            key: 0,
            for: g(s),
            class: H(g(z))
          }, [
            A(O.$slots, "default")
          ], 10, mu)) : K("", !0)
        ];
      }),
      _: 3
    }, 8, ["skip", "class"]));
  }
}), gu = ["id"], yu = ["innerHTML"], bu = ["textContent"], hu = /* @__PURE__ */ R({
  __name: "BFormCheckboxGroup",
  props: {
    id: { default: void 0 },
    form: { default: void 0 },
    modelValue: { default: () => [] },
    ariaInvalid: { type: [String, Boolean], default: void 0 },
    autofocus: { type: [String, Boolean], default: !1 },
    buttonVariant: { default: "secondary" },
    buttons: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    disabledField: { default: "disabled" },
    htmlField: { default: "html" },
    name: { default: void 0 },
    options: { default: () => [] },
    plain: { type: [String, Boolean], default: !1 },
    required: { type: [String, Boolean], default: !1 },
    size: { default: "md" },
    stacked: { type: [String, Boolean], default: !1 },
    state: { type: [String, Boolean, null], default: null },
    switches: { type: [String, Boolean], default: !1 },
    textField: { default: "text" },
    validated: { type: [String, Boolean], default: !1 },
    valueField: { default: "value" }
  },
  emits: ["input", "update:modelValue", "change"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = Se(a, "modelValue", l), n = ke(() => a.id, "checkbox"), s = ke(() => a.name, "checkbox"), r = u(() => a.autofocus), i = u(() => a.buttons), d = u(() => a.disabled), y = u(() => a.plain), b = u(() => a.required), c = u(() => a.stacked), h = u(() => a.state), S = u(() => a.switches), B = u(() => a.validated), F = M(null), { focused: w } = Ne(F, {
      initialValue: r.value
    });
    We(go, {
      set: (k) => {
        let f = [...o.value];
        f = f.filter((_) => JSON.stringify(_) !== JSON.stringify(k)), f.push(k), l("input", f), o.value = f, Te(() => {
          l("change", f);
        });
      },
      remove: (k) => {
        let f = [...o.value];
        f = f.filter((_) => JSON.stringify(_) !== JSON.stringify(k)), l("input", f), o.value = f, Te(() => {
          l("change", f);
        });
      },
      modelValue: P(() => o.value),
      switch: S,
      buttonVariant: P(() => a.buttonVariant),
      form: P(() => a.form),
      name: s,
      state: h,
      plain: y,
      size: P(() => a.size),
      inline: P(() => !c.value),
      required: b,
      buttons: i,
      disabled: d
    });
    const V = C(
      () => a.options.map(
        (k, f) => typeof k == "string" || typeof k == "number" ? {
          props: {
            value: k,
            disabled: d.value
          },
          text: k.toString(),
          html: void 0,
          self: Symbol(`checkboxGroupOptionItem${f}`)
        } : {
          props: {
            value: k[a.valueField],
            disabled: k[a.disabledField],
            ...k.props ? k.props : {}
          },
          text: k[a.textField],
          html: k[a.htmlField],
          self: Symbol(`checkboxGroupOptionItem${f}`)
        }
      )
    ), T = C(() => ({
      required: b.value,
      ariaInvalid: a.ariaInvalid,
      state: h.value,
      validated: B.value,
      buttons: i.value,
      stacked: c.value,
      size: a.size
    })), $ = Ko(T), m = Jo(T);
    return t({
      focus: () => {
        w.value = !0;
      },
      blur: () => {
        w.value = !1;
      }
    }), (k, f) => (p(), E("div", ae(g($), {
      id: g(n),
      ref_key: "element",
      ref: F,
      role: "group",
      class: [g(m), "bv-no-focus-ring"],
      tabindex: "-1"
    }), [
      A(k.$slots, "first"),
      (p(!0), E(fe, null, he(V.value, (_) => (p(), x(pn, ae({
        key: _.self
      }, _.props), {
        default: D(() => [
          _.html ? (p(), E("span", {
            key: 0,
            innerHTML: _.html
          }, null, 8, yu)) : (p(), E("span", {
            key: 1,
            textContent: J(_.text)
          }, null, 8, bu))
        ]),
        _: 2
      }, 1040))), 128)),
      A(k.$slots, "default")
    ], 16, gu));
  }
}), Bu = ["for"], Su = ["id", "form", "name", "multiple", "disabled", "capture", "accept", "required", "aria-required", "directory", "webkitdirectory"], wu = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "BFormFile",
  props: {
    accept: { default: "" },
    autofocus: { type: [String, Boolean], default: !1 },
    capture: { type: [Boolean, String], default: !1 },
    directory: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    form: { default: void 0 },
    id: { default: void 0 },
    multiple: { type: [String, Boolean], default: !1 },
    name: { default: void 0 },
    noDrop: { type: [String, Boolean], default: !1 },
    noTraverse: { type: [String, Boolean], default: !1 },
    required: { type: [String, Boolean], default: !1 },
    size: { default: void 0 },
    state: { type: [String, Boolean, null], default: null },
    modelValue: { default: null },
    label: { default: "" },
    labelClass: { default: void 0 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = Oe(), n = Se(a, "modelValue", l), s = ke(() => a.id), r = u(() => a.autofocus), i = u(() => a.directory), d = u(() => a.disabled), y = u(() => a.multiple), b = u(() => a.noDrop);
    u(() => a.noTraverse);
    const c = u(() => a.required), h = u(() => a.state), S = ht(h), B = M(null), { focused: F } = Ne(B, { initialValue: r.value }), w = P(() => !Ve(o.label)), V = P(
      () => typeof a.accept == "string" ? a.accept : a.accept.join(",")
    ), T = C(
      () => a.capture === "user" || a.capture === "environment" ? a.capture : ia(a.capture)
    ), $ = C(() => [
      S.value,
      {
        [`form-control-${a.size}`]: a.size !== void 0
      }
    ]), m = (_) => {
      var v, I;
      const L = ((v = B.value) == null ? void 0 : v.files) === null || ((I = B.value) == null ? void 0 : I.files) === void 0 ? null : [...B.value.files];
      n.value = L === null ? null : y.value === !0 ? L : L[0], l("change", _);
    }, k = (_) => {
      b.value === !0 && _.preventDefault();
    }, f = () => {
      n.value = null;
    };
    return se(n, (_) => {
      _ === null && B.value !== null && (B.value.value = "");
    }), t({
      element: B,
      focus: () => {
        F.value = !0;
      },
      blur: () => {
        F.value = !1;
      },
      reset: f
    }), (_, L) => (p(), E(fe, null, [
      w.value || _.label ? (p(), E("label", {
        key: 0,
        for: g(s),
        class: H(["form-label", _.labelClass])
      }, [
        A(_.$slots, "label", {}, () => [
          re(J(_.label), 1)
        ])
      ], 10, Bu)) : K("", !0),
      Z("input", ae({ id: g(s) }, _.$attrs, {
        ref_key: "input",
        ref: B,
        type: "file",
        class: ["form-control", $.value],
        form: _.form,
        name: _.name,
        multiple: g(y),
        disabled: g(d),
        capture: T.value,
        accept: V.value || void 0,
        required: g(c) || void 0,
        "aria-required": g(c) || void 0,
        directory: g(i),
        webkitdirectory: g(i),
        onChange: m,
        onDrop: k
      }), null, 16, Su)
    ], 64));
  }
}), mn = ["input", "select", "textarea"], Cu = mn.map((e) => `${e}:not([disabled])`).join(), ku = [...mn, "a", "button", "label"], $u = "label", _u = "invalid-feedback", Tu = "valid-feedback", Vu = "description", Au = "default", Ou = R({
  components: { BCol: Lt, BFormInvalidFeedback: Va, BFormRow: Jt, BFormText: Aa, BFormValidFeedback: Oa },
  props: {
    contentCols: { type: [Boolean, String, Number], default: void 0 },
    contentColsLg: { type: [Boolean, String, Number], default: void 0 },
    contentColsMd: { type: [Boolean, String, Number], default: void 0 },
    contentColsSm: { type: [Boolean, String, Number], default: void 0 },
    contentColsXl: { type: [Boolean, String, Number], default: void 0 },
    description: { type: [String], default: void 0 },
    disabled: { type: [Boolean, String], default: !1 },
    feedbackAriaLive: { type: String, default: "assertive" },
    id: { type: String, default: void 0 },
    invalidFeedback: { type: String, default: void 0 },
    label: { type: String, default: void 0 },
    labelAlign: { type: [Boolean, String, Number], default: void 0 },
    labelAlignLg: { type: [Boolean, String, Number], default: void 0 },
    labelAlignMd: { type: [Boolean, String, Number], default: void 0 },
    labelAlignSm: { type: [Boolean, String, Number], default: void 0 },
    labelAlignXl: { type: [Boolean, String, Number], default: void 0 },
    labelClass: { type: [Array, Object, String], default: void 0 },
    labelCols: { type: [Boolean, String, Number], default: void 0 },
    labelColsLg: { type: [Boolean, String, Number], default: void 0 },
    labelColsMd: { type: [Boolean, String, Number], default: void 0 },
    labelColsSm: { type: [Boolean, String, Number], default: void 0 },
    labelColsXl: { type: [Boolean, String, Number], default: void 0 },
    labelFor: { type: String, default: void 0 },
    labelSize: { type: String, default: void 0 },
    labelSrOnly: { type: [Boolean, String], default: !1 },
    state: { type: [Boolean, String], default: null },
    tooltip: { type: [Boolean, String], default: !1 },
    validFeedback: { type: String, default: void 0 },
    validated: { type: [Boolean, String], default: !1 },
    floating: { type: [Boolean, String], default: !1 }
  },
  setup(e, { attrs: t }) {
    const l = u(() => e.disabled), a = u(() => e.labelSrOnly), o = u(() => e.state), n = u(() => e.tooltip), s = u(() => e.validated), r = u(() => e.floating), i = null, d = ["xs", "sm", "md", "lg", "xl"], y = (m, k) => d.reduce((f, _) => {
      const L = vl(_ === "xs" ? "" : _, `${k}Align`), v = m[L] || null;
      return v && (_ === "xs" ? f.push(`text-${v}`) : f.push(`text-${_}-${v}`)), f;
    }, []), b = (m, k) => d.reduce((f, _) => {
      const L = vl(_ === "xs" ? "" : _, `${k}Cols`);
      let v = m[L];
      return v = v === "" ? !0 : v || !1, typeof v != "boolean" && v !== "auto" && (v = _s(v, 0), v = v > 0 ? v : !1), v && (_ === "xs" ? f[typeof v == "boolean" ? "col" : "cols"] = v : f[_ || (typeof v == "boolean" ? "col" : "cols")] = v), f;
    }, {}), c = M(), h = (m, k = null) => {
      if (xa && e.labelFor) {
        const f = no(`#${ns(e.labelFor)}`, c);
        if (f) {
          const _ = "aria-describedby", L = (m || "").split(Xt), v = (k || "").split(Xt), I = (Ma(f, _) || "").split(Xt).filter((z) => !v.includes(z)).concat(L).filter((z, O, q) => q.indexOf(z) === O).filter((z) => z).join(" ").trim();
          I ? Ss(f, _, I) : ws(f, _);
        }
      }
    }, S = C(() => b(e, "content")), B = C(() => y(e, "label")), F = C(() => b(e, "label")), w = C(
      () => (
        // Determine if the form group will be rendered horizontal
        // based on the existence of 'content-col' or 'label-col' props
        Object.keys(S.value).length > 0 || Object.keys(F.value).length > 0
      )
    ), V = ht(o), T = C(
      () => da(t.ariaInvalid, o.value)
    );
    return se(
      () => i,
      (m, k) => {
        m !== k && h(m, k);
      }
    ), Ye(() => {
      Te(() => {
        h(i);
      });
    }), {
      disabledBoolean: l,
      labelSrOnlyBoolean: a,
      stateBoolean: o,
      tooltipBoolean: n,
      validatedBoolean: s,
      floatingBoolean: r,
      ariaDescribedby: i,
      computedAriaInvalid: T,
      contentColProps: S,
      isHorizontal: w,
      labelAlignClasses: B,
      labelColProps: F,
      onLegendClick: (m) => {
        if (e.labelFor)
          return;
        const { target: k } = m, f = k ? k.tagName : "";
        if (ku.indexOf(f) !== -1)
          return;
        const _ = hs(Cu, c).filter(bs);
        _.length === 1 && gs(_[0]);
      },
      stateClass: V
    };
  },
  render() {
    const e = this.$props, t = this.$slots, l = ke(), a = !e.labelFor;
    let o = null;
    const n = et($u, {}, t) || e.label, s = n ? pt("_BV_label_") : null;
    if (n || this.isHorizontal) {
      const $ = a ? "legend" : "label";
      if (this.labelSrOnlyBoolean)
        n && (o = ye(
          $,
          {
            class: "visually-hidden",
            id: s,
            for: e.labelFor || null
          },
          n
        )), this.isHorizontal ? o = ye(Lt, this.labelColProps, { default: () => o }) : o = ye("div", {}, [o]);
      else {
        const m = {
          onClick: a ? this.onLegendClick : null,
          ...this.isHorizontal ? this.labelColProps : {},
          tag: this.isHorizontal ? $ : null,
          id: s,
          for: e.labelFor || null,
          tabIndex: a ? "-1" : null,
          class: [
            this.isHorizontal ? "col-form-label" : "form-label",
            {
              "bv-no-focus-ring": a,
              "col-form-label": this.isHorizontal || a,
              "pt-0": !this.isHorizontal && a,
              "d-block": !this.isHorizontal && !a,
              [`col-form-label-${e.labelSize}`]: !!e.labelSize
            },
            this.labelAlignClasses,
            e.labelClass
          ]
        };
        this.isHorizontal ? o = ye(Lt, m, { default: () => n }) : o = ye($, m, n);
      }
    }
    let r = null;
    const i = et(_u, {}, t) || this.invalidFeedback, d = i ? pt("_BV_feedback_invalid_") : void 0;
    i && (r = ye(
      Va,
      {
        ariaLive: e.feedbackAriaLive,
        id: d,
        state: this.stateBoolean,
        tooltip: this.tooltipBoolean
      },
      { default: () => i }
    ));
    let y = null;
    const b = et(Tu, {}, t) || this.validFeedback, c = b ? pt("_BV_feedback_valid_") : void 0;
    b && (y = ye(
      Oa,
      {
        ariaLive: e.feedbackAriaLive,
        id: c,
        state: this.stateBoolean,
        tooltip: this.tooltipBoolean
      },
      { default: () => b }
      // validFeedbackContent
    ));
    let h = null;
    const S = et(Vu, {}, t) || this.description, B = S ? pt("_BV_description_") : void 0;
    S && (h = ye(
      Aa,
      {
        id: B
      },
      { default: () => S }
    ));
    const F = this.ariaDescribedby = [
      B,
      this.stateBoolean === !1 ? d : null,
      this.stateBoolean === !0 ? c : null
    ].filter(($) => $).join(" ") || null, w = [
      et(Au, { ariaDescribedby: F, descriptionId: B, id: l, labelId: s }, t) || "",
      r,
      y,
      h
    ];
    !this.isHorizontal && this.floatingBoolean && w.push(o);
    let V = ye(
      "div",
      {
        ref: "content",
        class: [
          {
            "form-floating": !this.isHorizontal && this.floatingBoolean
          }
        ]
      },
      w
    );
    this.isHorizontal && (V = ye(Lt, { ref: "content", ...this.contentColProps }, { default: () => w }));
    const T = {
      class: [
        this.stateClass,
        {
          "was-validated": this.validatedBoolean
        }
      ],
      id: ke(() => e.id).value,
      disabled: a ? this.disabledBoolean : null,
      role: a ? null : "group",
      "aria-invalid": this.computedAriaInvalid,
      // Only apply `aria-labelledby` if we are a horizontal fieldset
      // as the legend is no longer a direct child of fieldset
      "aria-labelledby": a && this.isHorizontal ? s : null
    };
    return this.isHorizontal && !a ? ye(Jt, T, { default: () => [o, V] }) : ye(
      a ? "fieldset" : "div",
      T,
      this.isHorizontal && a ? [ye(Jt, null, { default: () => [o, V] })] : this.isHorizontal || !this.floatingBoolean ? [o, V] : [V]
    );
  }
}), Fu = ["id", "name", "form", "type", "disabled", "placeholder", "required", "autocomplete", "readonly", "min", "max", "step", "list", "aria-required", "aria-invalid"], Eu = /* @__PURE__ */ R({
  __name: "BFormInput",
  props: {
    max: { default: void 0 },
    min: { default: void 0 },
    step: { default: void 0 },
    type: { default: "text" },
    ariaInvalid: { type: [String, Boolean], default: void 0 },
    autocomplete: { default: void 0 },
    autofocus: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    form: { default: void 0 },
    debounce: { default: 0 },
    debounceMaxWait: { default: void 0 },
    formatter: { type: Function, default: void 0 },
    id: { default: void 0 },
    lazy: { type: [String, Boolean], default: !1 },
    lazyFormatter: { type: [String, Boolean], default: !1 },
    list: { default: void 0 },
    modelValue: { default: "" },
    name: { default: void 0 },
    number: { type: [String, Boolean], default: !1 },
    placeholder: { default: void 0 },
    plaintext: { type: [String, Boolean], default: !1 },
    readonly: { type: [String, Boolean], default: !1 },
    required: { type: [String, Boolean], default: !1 },
    size: { default: void 0 },
    state: { type: [String, Boolean, null], default: null },
    trim: { type: [String, Boolean], default: !1 }
  },
  emits: ["update:modelValue", "change", "blur", "input"],
  setup(e, { expose: t, emit: l }) {
    const a = e, { input: o, computedId: n, computedAriaInvalid: s, onInput: r, onChange: i, onBlur: d, focus: y, blur: b } = Yo(a, l), c = u(() => a.disabled), h = u(() => a.required), S = u(() => a.readonly), B = u(() => a.plaintext), F = u(() => a.state), w = ht(F), V = M(!1), T = C(() => {
      const $ = a.type === "range", m = a.type === "color";
      return [
        w.value,
        {
          "form-control-highlighted": V.value,
          "form-range": $,
          "form-control": m || !a.plaintext && !$,
          "form-control-color": m,
          "form-control-plaintext": a.plaintext && !$ && !m,
          [`form-control-${a.size}`]: !!a.size
        }
      ];
    });
    return t({
      element: o,
      focus: y,
      blur: b
    }), ($, m) => (p(), E("input", {
      id: g(n),
      ref_key: "input",
      ref: o,
      class: H(T.value),
      name: $.name || void 0,
      form: $.form || void 0,
      type: $.type,
      disabled: g(c),
      placeholder: $.placeholder,
      required: g(h) || void 0,
      autocomplete: $.autocomplete || void 0,
      readonly: g(S) || g(B),
      min: $.min,
      max: $.max,
      step: $.step,
      list: $.type !== "password" ? $.list : void 0,
      "aria-required": g(h) || void 0,
      "aria-invalid": g(s),
      onInput: m[0] || (m[0] = (k) => g(r)(k)),
      onChange: m[1] || (m[1] = (k) => g(i)(k)),
      onBlur: m[2] || (m[2] = (k) => g(d)(k))
    }, null, 42, Fu));
  }
}), Nu = ["id", "checked", "disabled", "required", "name", "form", "aria-label", "aria-labelledby", "value", "aria-required"], Pu = ["for"], gn = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "BFormRadio",
  props: {
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    form: { default: void 0 },
    id: { default: void 0 },
    name: { default: void 0 },
    size: { default: void 0 },
    autofocus: { type: [String, Boolean], default: !1 },
    modelValue: { type: [Boolean, String, Array, Object, Number, null], default: void 0 },
    plain: { type: [String, Boolean], default: !1 },
    button: { type: [String, Boolean], default: !1 },
    buttonGroup: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    buttonVariant: { default: null },
    inline: { type: [String, Boolean], default: !1 },
    required: { type: [String, Boolean], default: !1 },
    state: { type: [String, Boolean, null], default: null },
    value: { type: [Boolean, String, Array, Object, Number, null], default: !0 }
  },
  emits: ["input", "change", "update:modelValue"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = Oe(), n = Se(a, "modelValue", l, { passive: !0 }), s = ke(() => a.id, "form-check"), r = u(() => a.autofocus), i = u(() => a.plain), d = u(() => a.button), y = u(() => a.buttonGroup), b = u(() => a.disabled), c = u(() => a.inline), h = u(() => a.required), S = u(() => a.state), B = Pe(yo, null), F = M(null), { focused: w } = Ne(F, {
      initialValue: r.value
    }), V = P(() => !Ve(o.default)), T = C({
      get: () => B !== null ? JSON.stringify(B.modelValue.value) === JSON.stringify(a.value) : JSON.stringify(n.value) === JSON.stringify(a.value),
      set: (v) => {
        const I = v || v === "" || v === 0 || JSON.stringify(v) === JSON.stringify(a.value) ? a.value : !1;
        l("input", I), n.value = I, Te(() => {
          l("change", I);
        }), B !== null && B.set(a.value);
      }
    });
    se(n, (v) => {
      B === null || v === !1 || B.set(a.value);
    });
    const $ = C(
      () => !!(a.name ?? (B == null ? void 0 : B.name.value)) && (h.value || (B == null ? void 0 : B.required.value))
    ), m = P(() => y.value || ((B == null ? void 0 : B.buttons.value) ?? !1)), k = C(() => ({
      plain: i.value || ((B == null ? void 0 : B.plain.value) ?? !1),
      button: d.value || ((B == null ? void 0 : B.buttons.value) ?? !1),
      inline: c.value || ((B == null ? void 0 : B.inline.value) ?? !1),
      state: S.value || (B == null ? void 0 : B.state.value),
      size: a.size !== void 0 ? a.size : (B == null ? void 0 : B.size.value) ?? "md",
      // This is where the true default is made
      buttonVariant: a.buttonVariant !== null ? a.buttonVariant : (B == null ? void 0 : B.buttonVariant.value) ?? "secondary"
      // This is where the true default is made
    })), f = Wo(k), _ = Uo(k), L = Xo(k);
    return t({
      element: F,
      focus: () => {
        w.value = !0;
      },
      blur: () => {
        w.value = !1;
      }
    }), (v, I) => (p(), x(va, {
      skip: m.value,
      class: H(g(f))
    }, {
      default: D(() => {
        var z, O, q;
        return [
          ft(Z("input", ae({ id: g(s) }, v.$attrs, {
            ref_key: "input",
            ref: F,
            "onUpdate:modelValue": I[0] || (I[0] = (Y) => T.value = Y),
            checked: T.value,
            class: g(_),
            type: "radio",
            disabled: g(b) || ((z = g(B)) == null ? void 0 : z.disabled.value),
            required: $.value || void 0,
            name: v.name || ((O = g(B)) == null ? void 0 : O.name.value),
            form: v.form || ((q = g(B)) == null ? void 0 : q.form.value),
            "aria-label": v.ariaLabel,
            "aria-labelledby": v.ariaLabelledby,
            value: v.value,
            "aria-required": $.value || void 0
          }), null, 16, Nu), [
            [Gn, T.value]
          ]),
          V.value || g(i) === !1 ? (p(), E("label", {
            key: 0,
            for: g(s),
            class: H(g(L))
          }, [
            A(v.$slots, "default")
          ], 10, Pu)) : K("", !0)
        ];
      }),
      _: 3
    }, 8, ["skip", "class"]));
  }
}), Lu = ["id"], Iu = ["innerHTML"], zu = ["textContent"], Hu = /* @__PURE__ */ R({
  __name: "BFormRadioGroup",
  props: {
    size: { default: "md" },
    form: { default: void 0 },
    id: { default: void 0 },
    name: { default: void 0 },
    modelValue: { type: [String, Boolean, Array, Object, Number, null], default: null },
    ariaInvalid: { type: [String, Boolean], default: void 0 },
    autofocus: { type: [String, Boolean], default: !1 },
    buttonVariant: { default: "secondary" },
    buttons: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    disabledField: { default: "disabled" },
    htmlField: { default: "html" },
    options: { default: () => [] },
    plain: { type: [String, Boolean], default: !1 },
    required: { type: [String, Boolean], default: !1 },
    stacked: { type: [String, Boolean], default: !1 },
    state: { type: [String, Boolean, null], default: null },
    textField: { default: "text" },
    validated: { type: [String, Boolean], default: !1 },
    valueField: { default: "value" }
  },
  emits: ["input", "update:modelValue", "change"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = Se(a, "modelValue", l), n = ke(() => a.id, "radio"), s = ke(() => a.name, "checkbox"), r = u(() => a.autofocus), i = u(() => a.buttons), d = u(() => a.disabled), y = u(() => a.plain), b = u(() => a.required), c = u(() => a.stacked), h = u(() => a.state), S = u(() => a.validated), B = M(null), { focused: F } = Ne(B, {
      initialValue: r.value
    });
    We(yo, {
      set: (m) => {
        l("input", m), o.value = m, Te(() => {
          l("change", m);
        });
      },
      modelValue: P(() => o.value),
      buttonVariant: P(() => a.buttonVariant),
      form: P(() => a.form),
      name: s,
      buttons: i,
      state: h,
      plain: y,
      size: P(() => a.size),
      inline: P(() => !c.value),
      required: b,
      disabled: d
    });
    const w = C(
      () => a.options.map(
        (m, k) => typeof m == "string" || typeof m == "number" ? {
          props: {
            value: m,
            disabled: d.value
          },
          text: m.toString(),
          html: void 0,
          self: Symbol(`radioGroupOptionItem${k}`)
        } : {
          props: {
            value: m[a.valueField],
            disabled: m[a.disabledField],
            ...m.props ? m.props : {}
          },
          text: m[a.textField],
          html: m[a.htmlField],
          self: Symbol(`radioGroupOptionItem${k}`)
        }
      )
    ), V = C(() => ({
      required: b.value,
      ariaInvalid: a.ariaInvalid,
      state: h.value,
      validated: S.value,
      buttons: i.value,
      stacked: c.value,
      size: a.size
    })), T = Ko(V), $ = Jo(V);
    return t({
      focus: () => {
        F.value = !0;
      },
      blur: () => {
        F.value = !1;
      }
    }), (m, k) => (p(), E("div", ae(g(T), {
      id: g(n),
      ref_key: "element",
      ref: B,
      role: "radiogroup",
      class: [g($), "bv-no-focus-ring"],
      tabindex: "-1"
    }), [
      A(m.$slots, "first"),
      (p(!0), E(fe, null, he(w.value, (f) => (p(), x(gn, ae({
        key: f.self
      }, f.props), {
        default: D(() => [
          f.html ? (p(), E("span", {
            key: 0,
            innerHTML: f.html
          }, null, 8, Iu)) : (p(), E("span", {
            key: 1,
            textContent: J(f.text)
          }, null, 8, zu))
        ]),
        _: 2
      }, 1040))), 128)),
      A(m.$slots, "default")
    ], 16, Lu));
  }
}), Ru = ["value", "disabled"], ll = /* @__PURE__ */ R({
  __name: "BFormSelectOption",
  props: {
    value: { default: void 0 },
    disabled: { type: [String, Boolean], default: !1 }
  },
  setup(e) {
    const t = e, l = u(() => t.disabled);
    return (a, o) => (p(), E("option", {
      value: a.value,
      disabled: g(l)
    }, [
      A(a.$slots, "default")
    ], 8, Ru));
  }
}), xu = ["label"], yn = /* @__PURE__ */ R({
  __name: "BFormSelectOptionGroup",
  props: {
    label: { default: void 0 },
    disabledField: { default: "disabled" },
    htmlField: { default: "html" },
    options: { default: () => [] },
    textField: { default: "text" },
    valueField: { default: "value" }
  },
  setup(e) {
    const t = e, l = C(
      () => Qa(t.options, "BFormSelectOptionGroup", t)
    );
    return (a, o) => (p(), E("optgroup", { label: a.label }, [
      A(a.$slots, "first"),
      (p(!0), E(fe, null, he(l.value, (n, s) => (p(), x(ll, ae({
        key: s,
        value: n.value,
        disabled: n.disabled
      }, a.$attrs, {
        innerHTML: n.html || n.text
      }), null, 16, ["value", "disabled", "innerHTML"]))), 128)),
      A(a.$slots, "default")
    ], 8, xu));
  }
}), Mu = ["id", "name", "form", "multiple", "size", "disabled", "required", "aria-required", "aria-invalid"], Du = /* @__PURE__ */ R({
  __name: "BFormSelect",
  props: {
    ariaInvalid: { type: [String, Boolean], default: void 0 },
    autofocus: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    disabledField: { default: "disabled" },
    form: { default: void 0 },
    htmlField: { default: "html" },
    id: { default: void 0 },
    labelField: { default: "label" },
    multiple: { type: [String, Boolean], default: !1 },
    name: { default: void 0 },
    options: { default: () => [] },
    optionsField: { default: "options" },
    plain: { type: [String, Boolean], default: !1 },
    required: { type: [String, Boolean], default: !1 },
    selectSize: { default: 0 },
    size: { default: "md" },
    state: { type: [String, Boolean, null], default: null },
    textField: { default: "text" },
    valueField: { default: "value" },
    modelValue: { default: "" }
  },
  emits: ["input", "update:modelValue", "change"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = Se(a, "modelValue", l), n = ke(() => a.id, "input"), s = u(() => a.autofocus), r = u(() => a.disabled), i = u(() => a.multiple), d = u(() => a.plain), y = u(() => a.required), b = u(() => a.state), c = Be(() => a.selectSize), h = ht(b), S = M(), { focused: B } = Ne(S, {
      initialValue: s.value
    }), F = C(() => [
      h.value,
      {
        "form-control": d.value,
        [`form-control-${a.size}`]: a.size !== "md" && d.value,
        "form-select": !d.value,
        [`form-select-${a.size}`]: a.size !== "md" && !d.value
      }
    ]), w = P(
      () => c.value || d.value ? c.value : void 0
    ), V = C(
      () => da(a.ariaInvalid, b.value)
    ), T = C(() => Qa(a.options, "BFormSelect", a)), $ = C({
      get: () => o.value,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set: (m) => {
        l("input", m), o.value = m, Te(() => {
          l("change", m);
        });
      }
    });
    return t({
      element: S,
      focus: () => {
        B.value = !0;
      },
      blur: () => {
        B.value = !1;
      }
    }), (m, k) => ft((p(), E("select", {
      id: g(n),
      ref_key: "input",
      ref: S,
      "onUpdate:modelValue": k[0] || (k[0] = (f) => $.value = f),
      class: H(F.value),
      name: m.name,
      form: m.form || void 0,
      multiple: g(i) || void 0,
      size: w.value,
      disabled: g(r),
      required: g(y) || void 0,
      "aria-required": g(y) || void 0,
      "aria-invalid": V.value
    }, [
      A(m.$slots, "first"),
      (p(!0), E(fe, null, he(T.value, (f, _) => (p(), E(fe, { key: _ }, [
        Array.isArray(f.options) ? (p(), x(yn, {
          key: 0,
          label: f.label,
          options: f.options
        }, null, 8, ["label", "options"])) : (p(), x(ll, {
          key: 1,
          value: f.value,
          disabled: f.disabled,
          innerHTML: f.html || f.text
        }, null, 8, ["value", "disabled", "innerHTML"]))
      ], 64))), 128)),
      A(m.$slots, "default")
    ], 10, Mu)), [
      [Wn, $.value]
    ]);
  }
}), Fl = [
  "ar",
  "az",
  "ckb",
  "fa",
  "he",
  "ks",
  "lrc",
  "mzn",
  "ps",
  "sd",
  "te",
  "ug",
  "ur",
  "yi"
].map((e) => e.toLowerCase()), ju = (e) => {
  const t = Yt(e).toLowerCase().replace(Qn, "").split("-"), l = t.slice(0, 2).join("-"), [a] = t;
  return Fl.includes(l) || Fl.includes(a);
}, qu = (e) => cs ? Sa(e) ? e : { capture: !!e || !1 } : !!(Sa(e) ? e.capture : e), Gu = (e, t, l, a) => {
  e && e.addEventListener && e.addEventListener(t, l, qu(a));
}, Wu = (e, t, l, a) => {
  e && e.removeEventListener && e.removeEventListener(t, l, a);
}, El = (e, t) => {
  (e ? Gu : Wu)(...t);
}, Wt = (e, { preventDefault: t = !0, propagation: l = !0, immediatePropagation: a = !1 } = {}) => {
  t && e.preventDefault(), l && e.stopPropagation(), a && e.stopImmediatePropagation();
}, Fa = "ArrowDown", bn = "End", hn = "Home", Bn = "PageDown", Sn = "PageUp", Ea = "ArrowUp", Nl = 1, Pl = 100, Ll = 1, Il = 500, zl = 100, Hl = 10, Rl = 4, xl = [Ea, Fa, hn, bn, Sn, Bn], Uu = R({
  props: {
    ariaControls: { type: String, default: void 0 },
    ariaLabel: { type: String, default: void 0 },
    labelIncrement: { type: String, default: "Increment" },
    labelDecrement: { type: String, default: "Decrement" },
    modelValue: { type: Number, default: null },
    // V-model prop
    name: { type: String, default: "BFormSpinbutton" },
    disabled: { type: [Boolean, String], default: !1 },
    placeholder: { type: String, default: void 0 },
    locale: { type: String, default: "locale" },
    form: { type: String, default: void 0 },
    inline: { type: Boolean, default: !1 },
    size: { type: String, default: void 0 },
    formatterFn: {
      type: Function,
      default: void 0
    },
    readonly: { type: Boolean, default: !1 },
    vertical: { type: Boolean, default: !1 },
    repeatDelay: {
      type: [String, Number],
      default: Il
    },
    repeatInterval: {
      type: [String, Number],
      default: zl
    },
    repeatStepMultiplier: {
      type: [String, Number],
      default: Rl
    },
    repeatThreshold: {
      type: [String, Number],
      default: Hl
    },
    required: { type: [Boolean, String], default: !1 },
    step: { type: [String, Number], default: Ll },
    min: { type: [String, Number], default: Nl },
    max: { type: [String, Number], default: Pl },
    wrap: { type: Boolean, default: !1 },
    state: { type: [Boolean, String], default: null }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const l = Se(e, "modelValue", t), a = M(!1), o = C(() => 1), n = () => {
      t("change", r.value);
    }, s = M(null), r = C({
      get: () => l.value === null ? s.value : l.value,
      set: (G) => {
        l.value === null ? s.value = G : l.value = G;
      }
    });
    let i, d, y = !1;
    const b = C(() => Kt(e.step, Ll)), c = C(() => Kt(e.min, Nl)), h = C(() => {
      const G = Kt(e.max, Pl), W = b.value, de = c.value;
      return Math.floor((G - de) / W) * W + de;
    }), S = C(() => {
      const G = mt(e.repeatDelay, 0);
      return G > 0 ? G : Il;
    }), B = C(() => {
      const G = mt(e.repeatInterval, 0);
      return G > 0 ? G : zl;
    }), F = C(
      () => Math.max(mt(e.repeatThreshold, Hl), 1)
    ), w = C(
      () => Math.max(mt(e.repeatStepMultiplier, Rl), 1)
    ), V = C(() => {
      const G = b.value;
      return Math.floor(G) === G ? 0 : (G.toString().split(".")[1] || "").length;
    }), T = C(() => Math.pow(10, V.value || 0)), $ = C(() => {
      const { value: G } = r;
      return G === null ? "" : G.toFixed(V.value);
    }), m = C(() => {
      const G = [e.locale];
      return new Intl.NumberFormat(G).resolvedOptions().locale;
    }), k = C(
      () => (
        //todo
        ju(m.value)
      )
    ), f = () => {
      const G = V.value;
      return new Intl.NumberFormat(m.value, {
        style: "decimal",
        useGrouping: !1,
        minimumIntegerDigits: 1,
        minimumFractionDigits: G,
        maximumFractionDigits: G,
        notation: "standard"
      }).format;
    }, _ = C(() => e.formatterFn ?? f()), L = C(() => ({
      role: "group",
      lang: m.value,
      tabindex: e.disabled ? null : "-1",
      title: e.ariaLabel
    })), v = C(() => l.value !== null || s.value !== null), I = C(() => ({
      dir: k.value,
      spinId: o.value,
      tabindex: e.disabled ? null : "0",
      role: "spinbutton",
      "aria-live": "off",
      "aria-label": e.ariaLabel || null,
      "aria-controls": e.ariaControls || null,
      "aria-invalid": e.state === !1 || !v.value && e.required ? !0 : null,
      "aria-required": e.required ? !0 : null,
      "aria-valuemin": c.value,
      "aria-valuemax": h.value,
      "aria-valuenow": r.value !== null ? r.value : null,
      "aria-valuetext": r.value !== null ? _.value(r.value) : null
    })), z = (G) => {
      let { value: W } = r;
      if (!e.disabled && W !== null) {
        const de = b.value * G, ge = c.value, le = h.value, N = T.value, { wrap: j } = e;
        W = Math.round((W - ge) / de) * de + ge + de, W = Math.round(W * N) / N, r.value = W > le ? j ? ge : le : W < ge ? j ? le : ge : W;
      }
    }, O = (G = 1) => {
      r.value === null ? r.value = c.value : z(1 * G);
    }, q = (G = 1) => {
      r.value === null ? r.value = e.wrap ? h.value : c.value : z(-1 * G);
    }, Y = (G) => {
      const { code: W, altKey: de, ctrlKey: ge, metaKey: le } = G;
      if (!(e.disabled || e.readonly || de || ge || le) && xl.includes(W)) {
        if (Wt(G, { propagation: !1 }), y)
          return;
        ie(), [Ea, Fa].includes(W) ? (y = !0, W === Ea ? ue(G, O) : W === Fa && ue(G, q)) : W === Sn ? O(w.value) : W === Bn ? q(w.value) : W === hn ? r.value = c.value : W === bn && (r.value = h.value);
      }
    }, U = (G) => {
      const { code: W, altKey: de, ctrlKey: ge, metaKey: le } = G;
      e.disabled || e.readonly || de || ge || le || xl.includes(W) && (Wt(G, { propagation: !1 }), ie(), y = !1, n());
    }, ue = (G, W) => {
      const { type: de } = G || {};
      if (!e.disabled && !e.readonly) {
        if (ee(G) && de === "mousedown" && G.button)
          return;
        ie(), W(1);
        const ge = F.value, le = w.value, N = S.value, j = B.value;
        i = setTimeout(() => {
          let X = 0;
          d = setInterval(() => {
            W(X < ge ? 1 : le), X++;
          }, j);
        }, N);
      }
    }, ee = (G) => G.type === "mouseup" || G.type === "mousedown", pe = (G) => {
      ee(G) && G.type === "mouseup" && G.button || (Wt(G, { propagation: !1 }), ie(), te(!1), n());
    }, te = (G) => {
      try {
        El(G, [document.body, "mouseup", pe, !1]), El(G, [document.body, "touchend", pe, !1]);
      } catch {
        return 0;
      }
    }, ie = () => {
      clearTimeout(i), clearInterval(d), i = void 0, d = void 0;
    }, me = (G, W, de, ge, le, N, j) => {
      const X = ye(de, {
        props: { scale: a.value ? 1.5 : 1.25 },
        attrs: { "aria-hidden": !0 }
      }), ce = { hasFocus: a.value }, Q = (ne) => {
        !e.disabled && !e.readonly && (Wt(ne, { propagation: !1 }), te(!0), ue(ne, G));
      };
      return ye(
        "button",
        {
          class: [{ "py-0": !e.vertical }, "btn", "btn-sm", "border-0", "rounded-0"],
          tabindex: "-1",
          type: "button",
          disabled: e.disabled || e.readonly || N,
          "aria-disabled": e.disabled || e.readonly || N ? !0 : null,
          "aria-controls": o.value,
          "aria-label": W || null,
          "aria-keyshortcuts": le || null,
          onmousedown: Q,
          ontouchstart: Q
          // 'ref': keyRef,
        },
        [et(j, ce) || X]
      );
    };
    return () => {
      const G = me(
        O,
        e.labelIncrement,
        ye(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "currentColor",
            class: "bi bi-plus",
            viewBox: "0 0 16 16"
          },
          ye("path", {
            d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
          })
        ),
        "inc",
        "ArrowUp",
        !1,
        "increment"
      ), W = me(
        q,
        e.labelDecrement,
        ye(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "currentColor",
            class: "bi bi-dash",
            viewBox: "0 0 16 16"
          },
          ye("path", { d: "M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" })
        ),
        "dec",
        "ArrowDown",
        !1,
        "decrement"
      ), de = [];
      e.name && !e.disabled && de.push(
        ye("input", {
          type: "hidden",
          name: e.name,
          form: e.form || null,
          // TODO: Should this be set to '' if value is out of range?
          value: $.value,
          key: "hidden"
        })
      );
      const ge = ye(
        // We use 'output' element to make this accept a `<label for="id">` (Except IE)
        "output",
        {
          class: [
            { "d-flex": e.vertical },
            { "align-self-center": !e.vertical },
            { "align-items-center": e.vertical },
            { "border-top": e.vertical },
            { "border-bottom": e.vertical },
            { "border-start": !e.vertical },
            { "border-end": !e.vertical },
            "flex-grow-1"
          ],
          ...I.value,
          key: "output"
          // ref: 'spinner',
        },
        [
          ye(
            "bdi",
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore How can we narrow this type down
            v.value ? _.value(r.value) : e.placeholder || ""
          )
        ]
      );
      return ye(
        "div",
        {
          class: [
            "b-form-spinbutton form-control",
            { disabled: e.disabled },
            { readonly: e.readonly },
            { focus: a },
            { "d-inline-flex": e.inline || e.vertical },
            { "d-flex": !e.inline && !e.vertical },
            { "align-items-stretch": !e.vertical },
            { "flex-column": e.vertical },
            e.size ? `form-control-${e.size}` : null
            // this.stateClass //TODO
          ],
          ...L.value,
          onkeydown: Y,
          onkeyup: U
          // We use capture phase (`!` prefix) since focus and blur do not bubble
          // 'focus': onFocusBlur, //TODO
          // 'blur': onFocusBlur, //TODO
        },
        e.vertical ? [G, de, ge, W] : [W, de, ge, G]
      );
    };
  }
}), Xu = ["id"], wn = /* @__PURE__ */ R({
  __name: "BFormTag",
  props: {
    id: { default: void 0 },
    title: { default: void 0 },
    disabled: { type: [String, Boolean], default: !1 },
    noRemove: { type: [String, Boolean], default: !1 },
    pill: { type: [String, Boolean], default: !1 },
    removeLabel: { default: "Remove tag" },
    tag: { default: "span" },
    variant: { default: "secondary" }
  },
  emits: ["remove"],
  setup(e, { emit: t }) {
    const l = e, a = Oe(), o = ke(() => l.id), n = u(() => l.disabled), s = u(() => l.noRemove), r = u(() => l.pill), i = C(
      () => {
        var b;
        return ((((b = a.default) == null ? void 0 : b.call(a)[0].children) ?? "").toString() || l.title) ?? "";
      }
    ), d = P(() => `${o.value}taglabel__`), y = C(() => ({
      [`text-bg-${l.variant}`]: l.variant !== null,
      "rounded-pill": r.value,
      disabled: n.value
    }));
    return (b, c) => (p(), x(oe(b.tag), {
      id: g(o),
      title: i.value,
      class: H(["badge b-form-tag d-inline-flex align-items-center mw-100", y.value]),
      "aria-labelledby": d.value
    }, {
      default: D(() => [
        Z("span", {
          id: d.value,
          class: "b-form-tag-content flex-grow-1 text-truncate"
        }, [
          A(b.$slots, "default", {}, () => [
            re(J(i.value), 1)
          ])
        ], 8, Xu),
        !g(n) && !g(s) ? (p(), x(Pt, {
          key: 0,
          "aria-keyshortcuts": "Delete",
          "aria-label": b.removeLabel,
          class: "b-form-tag-remove",
          "aria-describedby": d.value,
          "aria-controls": b.id,
          onClick: c[0] || (c[0] = (h) => t("remove", i.value))
        }, null, 8, ["aria-label", "aria-describedby", "aria-controls"])) : K("", !0)
      ]),
      _: 3
    }, 8, ["id", "title", "class", "aria-labelledby"]));
  }
}), Ku = ["id"], Ju = ["id", "for", "aria-live"], Yu = ["id", "aria-live"], Zu = ["id"], Qu = ["aria-controls"], ed = {
  role: "group",
  class: "d-flex"
}, td = ["id", "disabled", "value", "type", "placeholder", "form", "required", "aria-required"], ad = ["disabled"], ld = {
  "aria-live": "polite",
  "aria-atomic": "true"
}, od = {
  key: 0,
  class: "d-block invalid-feedback"
}, nd = {
  key: 1,
  class: "form-text text-body-secondary"
}, sd = {
  key: 2,
  class: "form-text text-body-secondary"
}, rd = ["name", "value"], id = /* @__PURE__ */ R({
  __name: "BFormTags",
  props: {
    addButtonText: { default: "Add" },
    addButtonVariant: { default: "outline-secondary" },
    addOnChange: { type: [String, Boolean], default: !1 },
    autofocus: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    duplicateTagText: { default: "Duplicate tag(s)" },
    inputAttrs: { default: void 0 },
    inputClass: { default: void 0 },
    inputId: { default: void 0 },
    inputType: { default: "text" },
    invalidTagText: { default: "Invalid tag(s)" },
    form: { default: void 0 },
    limit: { default: void 0 },
    limitTagsText: { default: "Tag limit reached" },
    modelValue: { default: () => [] },
    name: { default: void 0 },
    noAddOnEnter: { type: [String, Boolean], default: !1 },
    noOuterFocus: { type: [String, Boolean], default: !1 },
    noTagRemove: { type: [String, Boolean], default: !1 },
    placeholder: { default: "Add tag..." },
    removeOnDelete: { type: [String, Boolean], default: !1 },
    required: { type: [String, Boolean], default: !1 },
    separator: { default: void 0 },
    state: { type: [String, Boolean, null], default: null },
    size: { default: "md" },
    tagClass: { default: void 0 },
    tagPills: { type: [String, Boolean], default: !1 },
    tagRemoveLabel: { default: void 0 },
    tagRemovedLabel: { default: "Tag removed" },
    tagValidator: { type: Function, default: () => !0 },
    tagVariant: { default: "secondary" }
  },
  emits: ["update:modelValue", "input", "tag-state", "focus", "focusin", "focusout", "blur"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = Se(a, "modelValue", l), n = ke(), s = u(() => a.addOnChange), r = u(() => a.autofocus), i = u(() => a.disabled), d = u(() => a.noAddOnEnter), y = u(() => a.noOuterFocus), b = u(() => a.noTagRemove), c = u(() => a.removeOnDelete), h = u(() => a.required), S = u(() => a.state), B = u(() => a.tagPills), F = Be(P(() => a.limit ?? NaN)), w = ht(S), V = M(null), { focused: T } = Ne(V, {
      initialValue: r.value
    }), $ = P(() => a.inputId || `${n.value}input__`), m = M(o.value), k = M(""), f = M(o.value.length > 0), _ = M(""), L = M([]), v = M([]), I = M([]), z = C(() => [
      w.value,
      {
        [`form-control-${a.size}`]: a.size !== "md",
        disabled: i.value,
        focus: T.value
      }
    ]), O = C(() => m.value.includes(k.value)), q = C(
      () => k.value === "" ? !1 : !a.tagValidator(k.value)
    ), Y = P(() => m.value.length === F.value), U = P(() => !q.value && !O.value), ue = C(() => ({
      addButtonText: a.addButtonText,
      addButtonVariant: a.addButtonVariant,
      addTag: ge,
      disableAddButton: U.value,
      disabled: i.value,
      duplicateTagText: a.duplicateTagText,
      duplicateTags: I.value,
      form: a.form,
      inputAttrs: {
        ...a.inputAttrs,
        disabled: i.value,
        form: a.form,
        id: $,
        value: k
      },
      inputHandlers: {
        input: ie,
        keydown: G,
        change: me
      },
      inputId: $,
      inputType: a.inputType,
      invalidTagText: a.invalidTagText,
      invalidTags: v.value,
      isDuplicate: O.value,
      isInvalid: q.value,
      isLimitReached: Y.value,
      limitTagsText: a.limitTagsText,
      limit: F.value,
      noTagRemove: b.value,
      placeholder: a.placeholder,
      removeTag: le,
      required: h.value,
      separator: a.separator,
      size: a.size,
      state: S.value,
      tagClass: a.tagClass,
      tagPills: B.value,
      tagRemoveLabel: a.tagRemoveLabel,
      tagVariant: a.tagVariant,
      tags: m.value
    }));
    se(o, (N) => {
      m.value = N;
    });
    const ee = (N) => {
      if (i.value) {
        N.target.blur();
        return;
      }
      l("focusin", N);
    }, pe = (N) => {
      i.value || y.value || (T.value = !0, l("focus", N));
    }, te = (N) => {
      T.value = !1, l("blur", N);
    }, ie = (N) => {
      var X, ce;
      const j = typeof N == "string" ? N : N.target.value;
      if (f.value = !1, (X = a.separator) != null && X.includes(j.charAt(0)) && j.length > 0) {
        V.value && (V.value.value = "");
        return;
      }
      if (k.value = j, (ce = a.separator) != null && ce.includes(j.charAt(j.length - 1))) {
        ge(j.slice(0, j.length - 1));
        return;
      }
      L.value = a.tagValidator(j) && !O.value ? [j] : [], v.value = a.tagValidator(j) ? [] : [j], I.value = O.value ? [j] : [], l("tag-state", L.value, v.value, I.value);
    }, me = (N) => {
      s.value && (ie(N), O.value || ge(k.value));
    }, G = (N) => {
      if (N.key === "Enter" && !d.value) {
        ge(k.value);
        return;
      }
      (N.key === "Backspace" || N.key === "Delete") && c.value && k.value === "" && f.value && m.value.length > 0 ? le(m.value[m.value.length - 1]) : f.value = !0;
    };
    At(G, { target: V });
    const W = C(() => {
      if (a.separator)
        return typeof a.separator == "string" ? a.separator : a.separator.join("");
    }), de = C(() => {
      if (W.value)
        return new RegExp(`[${os(W.value)}]+`);
    }), ge = (N) => {
      N = (N ?? k.value).trim();
      const j = de.value ? N.split(de.value).map((Q) => Q.trim()) : [N], X = [];
      for (const Q of j)
        if (!(Q === "" || O.value || !a.tagValidator(Q))) {
          if (F.value && Y.value)
            break;
          X.push(Q);
        }
      const ce = [...o.value, ...X];
      k.value = "", f.value = !0, o.value = ce, l("input", ce), T.value = !0;
    }, le = (N) => {
      const j = m.value.indexOf((N == null ? void 0 : N.toString()) ?? "");
      _.value = m.value.splice(j, 1).toString(), o.value = m.value;
    };
    return t({
      element: V,
      focus: () => {
        T.value = !0;
      },
      blur: () => {
        T.value = !1;
      }
    }), (N, j) => (p(), E("div", {
      id: g(n),
      class: H(["b-form-tags form-control h-auto", z.value]),
      role: "group",
      tabindex: "-1",
      onFocusin: ee,
      onFocusout: j[1] || (j[1] = (X) => l("focusout", X))
    }, [
      Z("output", {
        id: `${g(n)}selected_tags__`,
        class: "visually-hidden",
        for: $.value,
        "aria-live": g(T) ? "polite" : "off",
        "aria-atomic": "true",
        "aria-relevant": "additions text"
      }, J(m.value.join(", ")), 9, Ju),
      Z("div", {
        id: `${g(n)}removed_tags__`,
        role: "status",
        "aria-live": g(T) ? "assertive" : "off",
        "aria-atomic": "true",
        class: "visually-hidden"
      }, " (" + J(N.tagRemovedLabel) + ") " + J(_.value), 9, Yu),
      A(N.$slots, "default", _e(Ee(ue.value)), () => [
        Z("ul", {
          id: `${g(n)}tag_list__`,
          class: "b-form-tags-list list-unstyled mb-0 d-flex flex-wrap align-items-center"
        }, [
          (p(!0), E(fe, null, he(m.value, (X, ce) => A(N.$slots, "tag", {
            key: ce,
            tag: X,
            tagClass: N.tagClass,
            tagVariant: N.tagVariant,
            tagPills: g(B),
            removeTag: le
          }, () => [
            (p(), x(wn, {
              key: X,
              class: H(N.tagClass),
              tag: "li",
              variant: N.tagVariant,
              pill: N.tagPills,
              onRemove: le
            }, {
              default: D(() => [
                re(J(X), 1)
              ]),
              _: 2
            }, 1032, ["class", "variant", "pill"]))
          ])), 128)),
          Z("li", {
            role: "none",
            "aria-live": "off",
            class: "b-from-tags-field flex-grow-1",
            "aria-controls": `${g(n)}tag_list__`
          }, [
            Z("div", ed, [
              Z("input", ae({
                id: $.value,
                ref_key: "input",
                ref: V,
                disabled: g(i),
                value: k.value,
                type: N.inputType,
                placeholder: N.placeholder,
                class: "b-form-tags-input w-100 flex-grow-1 p-0 m-0 bg-transparent border-0",
                style: { outline: "currentcolor none 0px", "min-width": "5rem" }
              }, N.inputAttrs, {
                form: N.form,
                required: g(h) || void 0,
                "aria-required": g(h) || void 0,
                onInput: ie,
                onChange: me,
                onFocus: pe,
                onBlur: te
              }), null, 16, td),
              U.value ? (p(), E("button", {
                key: 0,
                type: "button",
                class: H(["btn b-form-tags-button py-0", [
                  N.inputClass,
                  {
                    [`btn-${N.addButtonVariant}`]: N.addButtonVariant !== null,
                    "disabled invisible": k.value.length === 0
                  }
                ]]),
                style: { "font-size": "90%" },
                disabled: g(i) || k.value.length === 0 || Y.value,
                onClick: j[0] || (j[0] = (X) => ge(k.value))
              }, [
                A(N.$slots, "add-button-text", {}, () => [
                  re(J(N.addButtonText), 1)
                ])
              ], 10, ad)) : K("", !0)
            ])
          ], 8, Qu)
        ], 8, Zu),
        Z("div", ld, [
          q.value ? (p(), E("div", od, J(N.invalidTagText) + ": " + J(k.value), 1)) : K("", !0),
          O.value ? (p(), E("small", nd, J(N.duplicateTagText) + ": " + J(k.value), 1)) : K("", !0),
          m.value.length === N.limit ? (p(), E("small", sd, "Tag limit reached")) : K("", !0)
        ])
      ]),
      N.name ? (p(!0), E(fe, { key: 0 }, he(m.value, (X, ce) => (p(), E("input", {
        key: ce,
        type: "hidden",
        name: N.name,
        value: X
      }, null, 8, rd))), 128)) : K("", !0)
    ], 42, Ku));
  }
}), ud = ["id", "name", "form", "disabled", "placeholder", "required", "autocomplete", "readonly", "aria-required", "aria-invalid", "rows", "wrap"], dd = /* @__PURE__ */ R({
  __name: "BFormTextarea",
  props: {
    noResize: { type: [String, Boolean], default: !1 },
    rows: { default: 2 },
    wrap: { default: "soft" },
    ariaInvalid: { type: [String, Boolean], default: void 0 },
    autocomplete: { default: void 0 },
    autofocus: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    form: { default: void 0 },
    debounce: { default: 0 },
    debounceMaxWait: { default: void 0 },
    formatter: { type: Function, default: void 0 },
    id: { default: void 0 },
    lazy: { type: [String, Boolean], default: !1 },
    lazyFormatter: { type: [String, Boolean], default: !1 },
    list: { default: void 0 },
    modelValue: { default: "" },
    name: { default: void 0 },
    number: { type: [String, Boolean], default: !1 },
    placeholder: { default: void 0 },
    plaintext: { type: [String, Boolean], default: !1 },
    readonly: { type: [String, Boolean], default: !1 },
    required: { type: [String, Boolean], default: !1 },
    size: { default: void 0 },
    state: { type: [String, Boolean, null], default: null },
    trim: { type: [String, Boolean], default: !1 }
  },
  emits: ["update:modelValue", "change", "blur", "input"],
  setup(e, { expose: t, emit: l }) {
    const a = e, { input: o, computedId: n, computedAriaInvalid: s, onInput: r, onChange: i, onBlur: d, focus: y, blur: b } = Yo(a, l), c = u(() => a.disabled), h = u(() => a.required), S = u(() => a.readonly), B = u(() => a.plaintext), F = u(() => a.noResize), w = u(() => a.state), V = ht(w), T = C(() => [
      V.value,
      {
        "form-control": !a.plaintext,
        "form-control-plaintext": a.plaintext,
        [`form-control-${a.size}`]: !!a.size
      }
    ]), $ = C(() => ({
      resize: F.value ? "none" : void 0
    }));
    return t({
      element: o,
      focus: y,
      blur: b
    }), (m, k) => (p(), E("textarea", {
      id: g(n),
      ref_key: "input",
      ref: o,
      class: H(T.value),
      name: m.name || void 0,
      form: m.form || void 0,
      disabled: g(c),
      placeholder: m.placeholder,
      required: g(h) || void 0,
      autocomplete: m.autocomplete || void 0,
      readonly: g(S) || g(B),
      "aria-required": m.required || void 0,
      "aria-invalid": g(s),
      rows: m.rows,
      style: Re($.value),
      wrap: m.wrap || void 0,
      onInput: k[0] || (k[0] = (f) => g(r)(f)),
      onChange: k[1] || (k[1] = (f) => g(i)(f)),
      onBlur: k[2] || (k[2] = (f) => g(d)(f))
    }, null, 46, ud));
  }
}), cd = {
  key: 0,
  class: "input-group-text"
}, fd = ["innerHTML"], vd = { key: 1 }, pd = {
  key: 0,
  class: "input-group-text"
}, md = ["innerHTML"], gd = { key: 1 }, yd = /* @__PURE__ */ R({
  __name: "BInputGroup",
  props: {
    append: { default: void 0 },
    appendHtml: { default: void 0 },
    id: { default: void 0 },
    prepend: { default: void 0 },
    prependHtml: { default: void 0 },
    size: { default: "md" },
    tag: { default: "div" }
  },
  setup(e) {
    const t = e, l = C(() => ({
      [`input-group-${t.size}`]: t.size !== "md"
    })), a = P(() => !!t.append || !!t.appendHtml), o = P(() => !!t.prepend || !!t.prependHtml);
    return (n, s) => (p(), x(oe(n.tag), {
      id: n.id,
      class: H(["input-group", l.value]),
      role: "group"
    }, {
      default: D(() => [
        A(n.$slots, "prepend", {}, () => [
          o.value ? (p(), E("span", cd, [
            n.prependHtml ? (p(), E("span", {
              key: 0,
              innerHTML: n.prependHtml
            }, null, 8, fd)) : (p(), E("span", vd, J(n.prepend), 1))
          ])) : K("", !0)
        ]),
        A(n.$slots, "default"),
        A(n.$slots, "append", {}, () => [
          a.value ? (p(), E("span", pd, [
            n.appendHtml ? (p(), E("span", {
              key: 0,
              innerHTML: n.appendHtml
            }, null, 8, md)) : (p(), E("span", gd, J(n.append), 1))
          ])) : K("", !0)
        ])
      ]),
      _: 3
    }, 8, ["id", "class"]));
  }
}), Cn = /* @__PURE__ */ R({
  __name: "BInputGroupText",
  props: {
    tag: { default: "div" },
    text: { default: void 0 }
  },
  setup(e) {
    return (t, l) => (p(), x(oe(t.tag), { class: "input-group-text" }, {
      default: D(() => [
        A(t.$slots, "default", {}, () => [
          re(J(t.text), 1)
        ])
      ]),
      _: 3
    }));
  }
}), ol = /* @__PURE__ */ R({
  __name: "BInputGroupAddon",
  props: {
    isText: { type: [String, Boolean], default: !1 }
  },
  setup(e) {
    const t = e, l = u(() => t.isText);
    return (a, o) => g(l) ? (p(), x(Cn, { key: 0 }, {
      default: D(() => [
        A(a.$slots, "default")
      ]),
      _: 3
    })) : A(a.$slots, "default", { key: 1 });
  }
}), bd = /* @__PURE__ */ R({
  __name: "BInputGroupAppend",
  props: {
    isText: { type: [String, Boolean], default: !1 }
  },
  setup(e) {
    return (t, l) => (p(), x(ol, _e(Ee(t.$props)), {
      default: D(() => [
        A(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), hd = /* @__PURE__ */ R({
  __name: "BInputGroupPrepend",
  props: {
    isText: { type: [String, Boolean], default: !1 }
  },
  setup(e) {
    return (t, l) => (p(), x(ol, _e(Ee(t.$props)), {
      default: D(() => [
        A(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Bd = /* @__PURE__ */ R({
  __name: "BListGroup",
  props: {
    flush: { type: [String, Boolean], default: !1 },
    horizontal: { type: [Boolean, String], default: !1 },
    numbered: { type: [String, Boolean], default: !1 },
    tag: { default: "div" }
  },
  setup(e) {
    const t = e, l = u(() => t.flush), a = u(() => t.numbered), o = C(() => {
      const s = l.value ? !1 : t.horizontal;
      return {
        "list-group-flush": l.value,
        "list-group-horizontal": s === !0,
        [`list-group-horizontal-${s}`]: typeof s == "string",
        "list-group-numbered": a.value
      };
    }), n = P(() => a.value === !0 ? "ol" : t.tag);
    return We(vo, {
      numbered: a
    }), (s, r) => (p(), x(oe(n.value), {
      class: H(["list-group", o.value])
    }, {
      default: D(() => [
        A(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Sd = /* @__PURE__ */ R({
  __name: "BListGroupItem",
  props: {
    action: { type: [String, Boolean], default: !1 },
    button: { type: [String, Boolean], default: !1 },
    tag: { default: "div" },
    active: { type: [String, Boolean], default: !1 },
    activeClass: { default: void 0 },
    append: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    href: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: [String, Boolean], default: !1 },
    routerComponentName: { default: "router-link" },
    target: { default: "_self" },
    to: { default: void 0 },
    variant: { default: null },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    underlineVariant: { default: null },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    icon: { type: [String, Boolean] }
  },
  setup(e) {
    const t = e, l = Yl(), a = Pe(vo, null), o = u(() => t.action), n = u(() => t.active), s = u(() => t.button), r = u(() => t.disabled), { computedLink: i } = bt(t), d = P(() => !s.value && i.value), y = C(
      () => a != null && a.numbered.value ? "li" : s.value ? "button" : d.value ? Qe : t.tag
    ), b = C(
      () => o.value || d.value || s.value || ["a", "router-link", "button", "b-link"].includes(t.tag)
    ), c = C(() => ({
      [`list-group-item-${t.variant}`]: t.variant !== null,
      "list-group-item-action": b.value,
      active: n.value,
      disabled: r.value
    })), h = C(() => {
      const S = {};
      return s.value && ((!l || !l.type) && (S.type = "button"), r.value && (S.disabled = !0)), S;
    });
    return (S, B) => (p(), x(oe(y.value), ae({
      class: ["list-group-item", c.value],
      "aria-current": g(n) ? !0 : void 0,
      "aria-disabled": g(r) ? !0 : void 0,
      target: d.value ? S.target : void 0,
      href: g(s) ? void 0 : S.href,
      to: g(s) ? void 0 : S.to
    }, h.value), {
      default: D(() => [
        A(S.$slots, "default")
      ]),
      _: 3
    }, 16, ["class", "aria-current", "aria-disabled", "target", "href", "to"]));
  }
}), nl = /* @__PURE__ */ R({
  __name: "BOverlay",
  props: {
    bgColor: { default: void 0 },
    blur: { default: "2px" },
    fixed: { type: [String, Boolean], default: !1 },
    noCenter: { type: [String, Boolean], default: !1 },
    noFade: { type: [String, Boolean], default: !1 },
    noWrap: { type: [String, Boolean], default: !1 },
    opacity: { default: 0.85 },
    overlayTag: { default: "div" },
    rounded: { type: [Boolean, String], default: !1 },
    show: { type: [String, Boolean], default: !1 },
    spinnerSmall: { type: [String, Boolean], default: !1 },
    spinnerType: { default: "border" },
    spinnerVariant: { default: void 0 },
    noSpinner: { type: [String, Boolean], default: !1 },
    variant: { default: "light" },
    wrapTag: { default: "div" },
    zIndex: { default: 10 }
  },
  emits: ["click", "hidden", "shown"],
  setup(e, { emit: t }) {
    const l = e, a = { top: 0, left: 0, bottom: 0, right: 0 }, o = u(() => l.fixed), n = u(() => l.noSpinner), s = u(() => l.noCenter), r = u(() => l.noWrap), i = u(() => l.show), d = u(() => l.spinnerSmall), y = P(
      () => l.rounded === !0 || l.rounded === "" ? "rounded" : l.rounded === !1 ? "" : `rounded-${l.rounded}`
    ), b = P(
      () => l.variant !== null && !l.bgColor ? `bg-${l.variant}` : ""
    ), c = P(() => i.value ? !0 : null), h = C(() => ({
      type: l.spinnerType,
      variant: l.spinnerVariant,
      small: d.value
    })), S = C(() => ({
      ...a,
      zIndex: l.zIndex || 10
    })), B = C(() => ({
      "position-absolute": !r.value || !o.value,
      "position-fixed": r.value && o.value
    })), F = C(() => [b.value, y.value]), w = C(() => ({
      ...a,
      opacity: l.opacity,
      backgroundColor: l.bgColor || void 0,
      backdropFilter: l.blur ? `blur(${l.blur})` : void 0
    })), V = C(
      () => s.value ? a : {
        top: "50%",
        left: "50%",
        transform: "translateX(-50%) translateY(-50%)"
      }
    );
    return (T, $) => (p(), x(oe(T.wrapTag), {
      class: "b-overlay-wrap position-relative",
      "aria-busy": c.value
    }, {
      default: D(() => [
        A(T.$slots, "default"),
        be(Nt, {
          "no-fade": T.noFade,
          "trans-props": { enterToClass: "show" },
          name: "fade",
          onOnAfterEnter: $[1] || ($[1] = (m) => t("shown")),
          onOnAfterLeave: $[2] || ($[2] = (m) => t("hidden"))
        }, {
          default: D(() => [
            g(i) ? (p(), x(oe(T.overlayTag), {
              key: 0,
              class: H(["b-overlay", B.value]),
              style: Re(S.value),
              onClick: $[0] || ($[0] = (m) => t("click", m))
            }, {
              default: D(() => [
                Z("div", {
                  class: H(["position-absolute", F.value]),
                  style: Re(w.value)
                }, null, 6),
                Z("div", {
                  class: "position-absolute",
                  style: Re(V.value)
                }, [
                  A(T.$slots, "overlay", _e(Ee(h.value)), () => [
                    g(n) ? K("", !0) : (p(), x(pa, _e(ae({ key: 0 }, h.value)), null, 16))
                  ])
                ], 4)
              ]),
              _: 3
            }, 8, ["class", "style"])) : K("", !0)
          ]),
          _: 3
        }, 8, ["no-fade"])
      ]),
      _: 3
    }, 8, ["aria-busy"]));
  }
}), wd = ["id", "aria-labelledby", "aria-describedby"], Cd = ["id"], kd = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "BModal",
  props: {
    bodyVariant: { default: null },
    bodyBgVariant: { default: null },
    bodyClass: { default: void 0 },
    bodyTextVariant: { default: null },
    busy: { type: [String, Boolean], default: !1 },
    lazy: { type: [String, Boolean], default: !1 },
    buttonSize: { default: "md" },
    cancelDisabled: { type: [String, Boolean], default: !1 },
    cancelTitle: { default: "Cancel" },
    cancelVariant: { default: "secondary" },
    centered: { type: [String, Boolean], default: !1 },
    contentClass: { default: void 0 },
    dialogClass: { default: void 0 },
    footerVariant: { default: null },
    footerBgVariant: { default: null },
    footerBorderVariant: { default: null },
    footerClass: { default: void 0 },
    footerTextVariant: { default: null },
    fullscreen: { type: [Boolean, String], default: !1 },
    headerBgVariant: { default: null },
    headerBorderVariant: { default: null },
    headerClass: { default: void 0 },
    headerCloseClass: { default: void 0 },
    headerCloseLabel: { default: "Close" },
    headerCloseVariant: { default: "secondary" },
    headerVariant: { default: null },
    headerTextVariant: { default: null },
    hideBackdrop: { type: [String, Boolean], default: !1 },
    hideFooter: { type: [String, Boolean], default: !1 },
    hideHeader: { type: [String, Boolean], default: !1 },
    hideHeaderClose: { type: [String, Boolean], default: !1 },
    id: { default: void 0 },
    modalClass: { default: void 0 },
    modelValue: { type: [String, Boolean], default: !1 },
    noCloseOnBackdrop: { type: [String, Boolean], default: !1 },
    noCloseOnEsc: { type: [String, Boolean], default: !1 },
    noFade: { type: [String, Boolean], default: !1 },
    autoFocus: { type: [String, Boolean], default: !0 },
    okDisabled: { type: [String, Boolean], default: !1 },
    okOnly: { type: [String, Boolean], default: !1 },
    okTitle: { default: "Ok" },
    okVariant: { default: "primary" },
    scrollable: { type: [String, Boolean], default: !1 },
    show: { type: [String, Boolean], default: !1 },
    size: { default: "md" },
    title: { default: void 0 },
    titleClass: { default: void 0 },
    titleSrOnly: { type: [String, Boolean], default: !1 },
    titleTag: { default: "h5" },
    autoFocusButton: { default: void 0 },
    teleportDisabled: { type: [String, Boolean], default: !1 },
    teleportTo: { default: "body" },
    bodyScrolling: { type: [String, Boolean], default: !1 },
    backdropVariant: { default: void 0 }
  },
  emits: ["update:modelValue", "show", "shown", "hide", "hidden", "hide-prevented", "show-prevented", "ok", "cancel", "close"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = Oe(), n = ke(() => a.id, "modal"), s = Se(a, "modelValue", l, { passive: !0 }), r = u(() => a.busy), i = u(() => a.lazy), d = u(() => a.cancelDisabled), y = u(() => a.centered), b = u(() => a.hideBackdrop), c = u(() => a.hideFooter), h = u(() => a.hideHeader), S = u(() => a.hideHeaderClose), B = u(s), F = u(() => a.noCloseOnBackdrop), w = u(() => a.noCloseOnEsc), V = u(() => a.noFade), T = u(() => a.autoFocus), $ = u(() => a.okDisabled), m = u(() => a.okOnly), k = u(() => a.scrollable), f = u(() => a.titleSrOnly), _ = u(() => a.teleportDisabled), L = u(() => a.bodyScrolling), v = M(null), I = M(null), z = M(null), O = M(null), q = M(B.value), Y = M(!1);
    At(
      "Escape",
      () => {
        Ce("esc");
      },
      { target: v }
    ), Qo(B, L);
    const { focused: U } = Ne(v, {
      initialValue: B.value && a.autoFocusButton === void 0
    }), { focused: ue } = Ne(I, {
      initialValue: B.value && a.autoFocusButton === "ok"
    }), { focused: ee } = Ne(z, {
      initialValue: B.value && a.autoFocusButton === "cancel"
    }), { focused: pe } = Ne(O, {
      initialValue: B.value && a.autoFocusButton === "close"
    }), te = C(() => [
      a.modalClass,
      {
        fade: !V.value,
        show: q.value
      }
    ]), ie = P(
      () => i.value === !1 || i.value === !0 && Y.value === !0 || i.value === !0 && B.value === !0
    ), me = P(
      () => a.backdropVariant !== void 0 ? a.backdropVariant : b.value ? "transparent" : "dark"
    ), G = P(() => !Ve(o["header-close"])), W = C(() => [
      a.dialogClass,
      {
        "modal-fullscreen": a.fullscreen === !0,
        [`modal-fullscreen-${a.fullscreen}-down`]: typeof a.fullscreen == "string",
        [`modal-${a.size}`]: a.size !== "md",
        "modal-dialog-centered": y.value,
        "modal-dialog-scrollable": k.value
      }
    ]), de = je(() => ({
      bgVariant: a.bodyBgVariant,
      textVariant: a.bodyTextVariant,
      variant: a.bodyVariant
    })), ge = C(() => [a.bodyClass, de.value]), le = je(() => ({
      bgVariant: a.headerBgVariant,
      textVariant: a.headerTextVariant,
      variant: a.headerVariant
    })), N = C(() => [
      a.headerClass,
      le.value,
      {
        [`border-${a.headerBorderVariant}`]: a.headerBorderVariant !== null
      }
    ]), j = C(() => [a.headerCloseClass]), X = C(() => ({
      variant: G.value ? a.headerCloseVariant : void 0,
      class: j.value
    })), ce = je(() => ({
      bgVariant: a.footerBgVariant,
      textVariant: a.footerTextVariant,
      variant: a.footerVariant
    })), Q = C(() => [
      a.footerClass,
      ce.value,
      {
        [`border-${a.footerBorderVariant}`]: a.footerBorderVariant !== null
      }
    ]), ne = C(() => [
      a.titleClass,
      {
        "visually-hidden": f.value
      }
    ]), Ae = P(() => d.value || r.value), rt = P(() => $.value || r.value), De = (ve, $e = {}) => new Et(ve, {
      cancelable: !1,
      target: v.value || null,
      relatedTarget: null,
      trigger: null,
      ...$e,
      componentId: n.value
    }), Ce = (ve = "") => {
      const $e = De("hide", { cancelable: ve !== "", trigger: ve });
      if (ve === "ok" && l(ve, $e), ve === "cancel" && l(ve, $e), ve === "close" && l(ve, $e), l("hide", $e), $e.defaultPrevented || ve === "backdrop" && F.value || ve === "esc" && w.value) {
        l("hide-prevented");
        return;
      }
      s.value = !1;
    }, ga = () => {
      const ve = De("show", { cancelable: !0 });
      if (l("show", ve), ve.defaultPrevented) {
        s.value = !1, l("show-prevented");
        return;
      }
      s.value = !0;
    }, En = () => {
      T.value !== !1 && (a.autoFocusButton === "ok" ? ue.value = !0 : a.autoFocusButton === "close" ? pe.value = !0 : a.autoFocusButton === "cancel" ? ee.value = !0 : U.value = !0);
    }, Nn = () => ga(), Pn = () => {
      q.value = !0, En(), l("shown", De("shown")), i.value === !0 && (Y.value = !0);
    }, Ln = () => {
      q.value = !1;
    }, In = () => {
      l("hidden", De("hidden")), i.value === !0 && (Y.value = !1);
    };
    Mr(q), we(v, "bv-toggle", () => {
      B.value ? Ce() : ga();
    });
    const Bt = It({
      cancel: () => Ce("cancel"),
      close: () => Ce("close"),
      hide: Ce,
      ok: () => Ce("ok"),
      visible: B
    });
    return t({
      hide: Ce,
      show: ga,
      id: n.value
    }), (ve, $e) => (p(), x(sa, {
      to: ve.teleportTo,
      disabled: g(_)
    }, [
      be(Nt, {
        "no-fade": !0,
        "trans-props": { enterToClass: "show" },
        onBeforeEnter: Nn,
        onAfterEnter: Pn,
        onLeave: Ln,
        onAfterLeave: In
      }, {
        default: D(() => [
          ft(Z("div", ae({
            id: g(n),
            ref_key: "element",
            ref: v,
            class: ["modal", te.value],
            role: "dialog",
            "aria-labelledby": g(h) ? void 0 : `${g(n)}-label`,
            "aria-describedby": `${g(n)}-body`,
            tabindex: "-1"
          }, ve.$attrs), [
            Z("div", {
              class: H(["modal-dialog", W.value])
            }, [
              ie.value ? (p(), E("div", {
                key: 0,
                class: H(["modal-content", ve.contentClass])
              }, [
                g(h) ? K("", !0) : (p(), E("div", {
                  key: 0,
                  class: H(["modal-header", N.value])
                }, [
                  A(ve.$slots, "header", _e(Ee(Bt)), () => [
                    (p(), x(oe(ve.titleTag), {
                      id: `${g(n)}-label`,
                      class: H(["modal-title", ne.value])
                    }, {
                      default: D(() => [
                        A(ve.$slots, "title", _e(Ee(Bt)), () => [
                          re(J(ve.title), 1)
                        ], !0)
                      ]),
                      _: 3
                    }, 8, ["id", "class"])),
                    g(S) ? K("", !0) : (p(), E(fe, { key: 0 }, [
                      G.value ? (p(), x(it, ae({ key: 0 }, X.value, {
                        onClick: $e[0] || ($e[0] = (Dt) => Ce("close"))
                      }), {
                        default: D(() => [
                          A(ve.$slots, "header-close", {}, void 0, !0)
                        ]),
                        _: 3
                      }, 16)) : (p(), x(Pt, ae({
                        key: 1,
                        "aria-label": ve.headerCloseLabel
                      }, X.value, {
                        onClick: $e[1] || ($e[1] = (Dt) => Ce("close"))
                      }), null, 16, ["aria-label"]))
                    ], 64))
                  ], !0)
                ], 2)),
                Z("div", {
                  id: `${g(n)}-body`,
                  class: H(["modal-body", ge.value])
                }, [
                  A(ve.$slots, "default", _e(Ee(Bt)), void 0, !0)
                ], 10, Cd),
                g(c) ? K("", !0) : (p(), E("div", {
                  key: 1,
                  class: H(["modal-footer", Q.value])
                }, [
                  A(ve.$slots, "footer", _e(Ee(Bt)), () => [
                    A(ve.$slots, "cancel", _e(Ee(Bt)), () => [
                      g(m) ? K("", !0) : (p(), x(it, {
                        key: 0,
                        ref_key: "cancelButton",
                        ref: z,
                        disabled: Ae.value,
                        size: ve.buttonSize,
                        variant: ve.cancelVariant,
                        onClick: $e[2] || ($e[2] = (Dt) => Ce("cancel"))
                      }, {
                        default: D(() => [
                          re(J(ve.cancelTitle), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "size", "variant"]))
                    ], !0),
                    A(ve.$slots, "ok", _e(Ee(Bt)), () => [
                      be(it, {
                        ref_key: "okButton",
                        ref: I,
                        disabled: rt.value,
                        size: ve.buttonSize,
                        variant: ve.okVariant,
                        onClick: $e[3] || ($e[3] = (Dt) => Ce("ok"))
                      }, {
                        default: D(() => [
                          re(J(ve.okTitle), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "size", "variant"])
                    ], !0)
                  ], !0)
                ], 2))
              ], 2)) : K("", !0)
            ], 2),
            A(ve.$slots, "backdrop", {}, () => [
              be(nl, {
                variant: me.value,
                show: g(B),
                "no-spinner": "",
                fixed: "",
                "no-wrap": "",
                blur: null,
                onClick: $e[4] || ($e[4] = (Dt) => Ce("backdrop"))
              }, null, 8, ["variant", "show"])
            ], !0)
          ], 16, wd), [
            [ra, g(B)]
          ])
        ]),
        _: 3
      })
    ], 8, ["to", "disabled"]));
  }
});
const $d = /* @__PURE__ */ ma(kd, [["__scopeId", "data-v-079b865c"]]), _d = /* @__PURE__ */ R({
  __name: "BNav",
  props: {
    align: { default: void 0 },
    cardHeader: { type: [String, Boolean], default: !1 },
    fill: { type: [String, Boolean], default: !1 },
    justified: { type: [String, Boolean], default: !1 },
    pills: { type: [String, Boolean], default: !1 },
    small: { type: [String, Boolean], default: !1 },
    tabs: { type: [String, Boolean], default: !1 },
    tag: { default: "ul" },
    vertical: { type: [String, Boolean], default: !1 },
    underline: { type: [String, Boolean], default: !1 }
  },
  setup(e) {
    const t = e, l = u(() => t.cardHeader), a = u(() => t.fill), o = u(() => t.justified), n = u(() => t.pills), s = u(() => t.small), r = u(() => t.tabs), i = u(() => t.vertical), d = Mt(() => t.align), y = u(() => t.underline), b = C(() => ({
      "nav-tabs": r.value,
      "nav-pills": n.value && !r.value,
      "card-header-tabs": !i.value && l.value && r.value,
      "card-header-pills": !i.value && l.value && n.value && !r.value,
      "flex-column": i.value,
      "nav-fill": !i.value && a.value,
      "nav-justified": !i.value && o.value,
      [d.value]: !i.value && t.align !== void 0,
      small: s.value,
      "nav-underline": y.value
    }));
    return (c, h) => (p(), x(oe(c.tag), {
      class: H(["nav", b.value])
    }, {
      default: D(() => [
        A(c.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Td = { class: "d-flex flex-row align-items-center flex-wrap" }, Vd = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "BNavForm",
  props: {
    role: { default: void 0 },
    id: { default: void 0 },
    floating: { type: [String, Boolean], default: !1 },
    novalidate: { type: [String, Boolean], default: !1 },
    validated: { type: [String, Boolean], default: !1 }
  },
  emits: ["submit"],
  setup(e, { emit: t }) {
    const l = (a) => {
      t("submit", a);
    };
    return (a, o) => (p(), E("li", Td, [
      be(vn, ae(a.$attrs, {
        id: a.id,
        floating: a.floating,
        role: a.role,
        novalidate: a.novalidate,
        validated: a.validated,
        class: "d-flex",
        onSubmit: za(l, ["prevent"])
      }), {
        default: D(() => [
          A(a.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "floating", "role", "novalidate", "validated", "onSubmit"])
    ]));
  }
}), Ad = { class: "nav-item" }, Od = /* @__PURE__ */ R({
  __name: "BNavItem",
  props: {
    linkClass: { default: void 0 },
    linkAttrs: { default: void 0 },
    active: { type: [String, Boolean], default: void 0 },
    activeClass: { default: void 0 },
    append: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    href: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: [String, Boolean], default: !1 },
    routerComponentName: { default: "router-link" },
    target: { default: "_self" },
    to: { default: void 0 },
    variant: { default: void 0 },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    underlineVariant: { default: null },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    icon: { type: [String, Boolean], default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const l = e, a = u(() => l.disabled), o = C(
      () => Da(l, [
        "active",
        "activeClass",
        "append",
        "disabled",
        "href",
        "icon",
        "opacity",
        "opacityHover",
        "rel",
        "replace",
        "routerComponentName",
        "target",
        "to",
        "underlineOffset",
        "underlineOffsetHover",
        "underlineOpacity",
        "underlineOpacityHover",
        "underlineVariant",
        "variant"
      ])
    );
    return (n, s) => (p(), E("li", Ad, [
      be(Qe, ae({
        class: ["nav-link", n.linkClass]
      }, { ...o.value, ...n.linkAttrs }, {
        "active-class": n.activeClass,
        tabindex: g(a) ? -1 : void 0,
        "aria-disabled": g(a) ? !0 : void 0,
        onClick: s[0] || (s[0] = (r) => t("click", r))
      }), {
        default: D(() => [
          A(n.$slots, "default")
        ]),
        _: 3
      }, 16, ["class", "active-class", "tabindex", "aria-disabled"])
    ]));
  }
}), Fd = { class: "nav-item dropdown" }, Ed = /* @__PURE__ */ R({
  __name: "BNavItemDropdown",
  props: {
    ariaLabel: { default: void 0 },
    id: { default: void 0 },
    menuClass: { default: void 0 },
    size: { default: "md" },
    splitClass: { default: void 0 },
    splitVariant: { default: void 0 },
    text: { default: void 0 },
    toggleClass: { default: void 0 },
    autoClose: { type: [Boolean, String], default: !0 },
    block: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    isNav: { type: [String, Boolean], default: !0 },
    dropup: { type: [String, Boolean], default: !1 },
    dropend: { type: [String, Boolean], default: !1 },
    dropstart: { type: [String, Boolean], default: !1 },
    center: { type: [String, Boolean], default: !1 },
    end: { type: [String, Boolean], default: !1 },
    noFlip: { type: [String, Boolean], default: !1 },
    noShift: { type: [String, Boolean], default: !1 },
    offset: { default: 0 },
    role: { default: "menu" },
    split: { type: [String, Boolean], default: !1 },
    splitButtonType: { default: "button" },
    splitHref: { default: void 0 },
    splitDisabled: { type: [String, Boolean], default: void 0 },
    noCaret: { type: [String, Boolean], default: !1 },
    toggleText: { default: "Toggle dropdown" },
    variant: { default: "link" },
    modelValue: { type: [String, Boolean], default: !1 },
    lazy: { type: [String, Boolean], default: !1 },
    strategy: { default: "absolute" },
    floatingMiddleware: { default: void 0 },
    splitTo: { default: void 0 },
    boundary: { default: "clippingAncestors" },
    container: {}
  },
  emits: ["show", "shown", "hide", "hidden", "hide-prevented", "show-prevented", "click", "toggle", "update:modelValue"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = M(null), n = () => {
      var i;
      (i = o.value) == null || i.close();
    }, s = () => {
      var i;
      (i = o.value) == null || i.open();
    };
    return t({
      close: n,
      open: s,
      toggle: () => {
        var i;
        (i = o.value) == null || i.toggle();
      }
    }), (i, d) => (p(), E("li", Fd, [
      be(fn, ae({
        ref_key: "dropdown",
        ref: o
      }, a, {
        "is-nav": "",
        onShow: d[0] || (d[0] = (y) => l("show", y)),
        onShown: d[1] || (d[1] = (y) => l("shown")),
        onHide: d[2] || (d[2] = (y) => l("hide", y)),
        onHidden: d[3] || (d[3] = (y) => l("hidden")),
        onHidePrevented: d[4] || (d[4] = (y) => l("hide-prevented")),
        onShowPrevented: d[5] || (d[5] = (y) => l("show-prevented")),
        onClick: d[6] || (d[6] = (y) => l("click", y)),
        onToggle: d[7] || (d[7] = (y) => l("toggle")),
        "onUpdate:modelValue": d[8] || (d[8] = (y) => l("update:modelValue", y))
      }), {
        "button-content": D(() => [
          A(i.$slots, "button-content")
        ]),
        "toggle-text": D(() => [
          A(i.$slots, "toggle-text")
        ]),
        default: D(() => [
          A(i.$slots, "default", {
            hide: n,
            show: s
          })
        ]),
        _: 3
      }, 16)
    ]));
  }
}), Nd = { class: "navbar-text" }, Pd = /* @__PURE__ */ R({
  __name: "BNavText",
  props: {
    text: { default: void 0 }
  },
  setup(e) {
    return (t, l) => (p(), E("li", Nd, [
      A(t.$slots, "default", {}, () => [
        re(J(t.text), 1)
      ])
    ]));
  }
}), Ld = /* @__PURE__ */ R({
  __name: "BNavbar",
  props: {
    fixed: { default: void 0 },
    print: { type: [String, Boolean], default: !1 },
    sticky: { default: void 0 },
    tag: { default: "nav" },
    toggleable: { type: [Boolean, String], default: !1 },
    variant: { default: null },
    container: { type: [String, Boolean], default: "fluid" },
    autoClose: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, l = u(() => t.print), a = P(() => t.tag === "nav" ? void 0 : "navigation"), o = C(
      () => typeof t.toggleable == "string" ? `navbar-expand-${t.toggleable}` : t.toggleable === !1 ? "navbar-expand" : void 0
    ), n = P(() => t.container === !0 ? "container" : "container-fluid"), s = C(() => ({
      "d-print": l.value,
      [`sticky-${t.sticky}`]: t.sticky !== void 0,
      [`bg-${t.variant}`]: t.variant !== null,
      [`fixed-${t.fixed}`]: t.fixed !== void 0,
      [`${o.value}`]: o.value !== void 0
    }));
    return We(qa, {
      tag: P(() => t.tag),
      autoClose: P(() => t.autoClose)
    }), (r, i) => (p(), x(oe(r.tag), {
      class: H(["navbar", s.value]),
      role: a.value
    }, {
      default: D(() => [
        r.container !== !1 ? (p(), E("div", {
          key: 0,
          class: H(n.value)
        }, [
          A(r.$slots, "default")
        ], 2)) : A(r.$slots, "default", { key: 1 })
      ]),
      _: 3
    }, 8, ["class", "role"]));
  }
}), Id = /* @__PURE__ */ R({
  __name: "BNavbarBrand",
  props: {
    tag: { default: "div" },
    active: { type: [String, Boolean], default: void 0 },
    activeClass: { default: void 0 },
    append: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    href: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: [String, Boolean], default: !1 },
    routerComponentName: { default: "router-link" },
    target: { default: "_self" },
    to: { default: void 0 },
    variant: { default: void 0 },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    underlineVariant: { default: null },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    icon: { type: [String, Boolean], default: !1 }
  },
  setup(e) {
    const t = e, { computedLink: l, computedLinkProps: a } = bt(t, [
      "active",
      "activeClass",
      "append",
      "disabled",
      "href",
      "rel",
      "replace",
      "routerComponentName",
      "target",
      "to",
      "variant",
      "opacity",
      "opacityHover",
      "underlineVariant",
      "underlineOffset",
      "underlineOffsetHover",
      "underlineOpacity",
      "underlineOpacityHover",
      "icon"
    ]), o = P(() => l.value ? Qe : t.tag);
    return (n, s) => (p(), x(oe(o.value), ae({ class: "navbar-brand" }, g(a)), {
      default: D(() => [
        A(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), zd = /* @__PURE__ */ R({
  __name: "BNavbarNav",
  props: {
    align: { default: void 0 },
    fill: { type: [String, Boolean], default: !1 },
    justified: { type: [String, Boolean], default: !1 },
    small: { type: [String, Boolean], default: !1 },
    tag: { default: "ul" }
  },
  setup(e) {
    const t = e, l = u(() => t.fill), a = u(() => t.justified), o = u(() => t.small), n = Mt(() => t.align), s = C(() => ({
      "nav-fill": l.value,
      "nav-justified": a.value,
      [n.value]: t.align !== void 0,
      small: o.value
    }));
    return (r, i) => (p(), E("ul", {
      class: H(["navbar-nav", s.value])
    }, [
      A(r.$slots, "default")
    ], 2));
  }
}), Ml = (e, t) => e.setAttribute("data-bs-theme", t), Hd = {
  mounted(e, t) {
    Ml(e, t.value);
  },
  updated(e, t) {
    Ml(e, t.value);
  }
}, Rd = (e, t) => {
  const { modifiers: l, arg: a, value: o } = e, n = Object.keys(l || {}), s = typeof o == "string" ? o.split(Xt) : o;
  if (Cs(t.tagName, "a")) {
    const r = Ma(t, "href") || "";
    Zn.test(r) && n.push(r.replace(Yn, ""));
  }
  return Array.prototype.concat.apply([], [a, s]).forEach((r) => typeof r == "string" && n.push(r)), n.filter((r, i, d) => r && d.indexOf(r) === i);
}, xd = (e, t) => {
  e.forEach((l) => {
    const a = document.getElementById(l);
    a !== null && a.dispatchEvent(new Event("bv-toggle"));
  }), setTimeout(() => kn(e, t), 50);
}, kn = (e, t) => {
  let l = !1;
  e.forEach((a) => {
    const o = document.getElementById(a);
    o != null && o.classList.contains("show") && (l = !0), o != null && o.classList.contains("closing") && (l = !1);
  }), t.setAttribute("aria-expanded", l ? "true" : "false"), t.classList.remove(l ? "collapsed" : "not-collapsed"), t.classList.add(l ? "not-collapsed" : "collapsed");
}, Dl = (e, t) => {
  const l = Rd(t, e);
  e.__toggle && e.removeEventListener("click", e.__toggle), e.__toggle = () => xd(l, e), e.addEventListener("click", e.__toggle), e.setAttribute("aria-controls", l.join(" ")), kn(l, e);
}, Na = {
  mounted: Dl,
  updated: Dl,
  unmounted(e) {
    e.removeEventListener("click", e.__toggle), e.removeAttribute("aria-controls"), e.removeAttribute("aria-expanded");
  }
}, Md = {
  mounted(e, t) {
    if (!Ht(t.value))
      return;
    const a = la(t.value, e);
    !a.content && !a.title || (e.$__state = M({
      ..._t(t, e),
      ...a
    }), oa(e, t));
  },
  updated(e, t) {
    if (!Ht(t.value))
      return;
    const a = la(t.value, e);
    if (!(!a.content && !a.title)) {
      if (!e.$__state) {
        e.$__state = M({
          ..._t(t, e),
          ...a
        }), oa(e, t);
        return;
      }
      e.$__state.value = {
        ..._t(t, e),
        ...a
      };
    }
  },
  beforeUnmount(e) {
    tn(e);
  }
}, Dd = {
  mounted(e, t) {
    const l = Ht(t.value);
    if (!l)
      return;
    const a = la(t.value, e);
    !a.content && !a.title || (e.$__state = M({
      ..._t(t, e),
      title: a.title ?? a.content ?? "",
      tooltip: l
    }), oa(e, t));
  },
  updated(e, t) {
    const l = Ht(t.value);
    if (!l)
      return;
    const a = la(t.value, e);
    if (!(!a.content && !a.title)) {
      if (!e.$__state) {
        e.$__state = M({
          ..._t(t, e),
          title: a.title ?? a.content ?? "",
          tooltip: l
        }), oa(e, t);
        return;
      }
      e.$__state.value = {
        ..._t(t, e),
        title: a.title ?? a.content ?? "",
        tooltip: l
      };
    }
  },
  beforeUnmount(e) {
    tn(e);
  }
}, jl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  vBColorMode: Hd,
  vBModal: Na,
  vBPopover: Md,
  vBToggle: Na,
  vBTooltip: Dd
}, Symbol.toStringTag, { value: "Module" })), jd = ["disabled", "aria-label"], qd = /* @__PURE__ */ Z("span", { class: "navbar-toggler-icon" }, null, -1), Gd = /* @__PURE__ */ R({
  __name: "BNavbarToggle",
  props: {
    disabled: { type: [String, Boolean], default: !1 },
    label: { default: "Toggle navigation" },
    target: { default: void 0 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const l = e, a = u(() => l.disabled), o = C(() => ({
      disabled: a.value
    })), n = (s) => {
      a.value || t("click", s);
    };
    return (s, r) => ft((p(), E("button", {
      class: H(["navbar-toggler", o.value]),
      type: "button",
      disabled: g(a),
      "aria-label": s.label,
      onClick: n
    }, [
      A(s.$slots, "default", {}, () => [
        qd
      ])
    ], 10, jd)), [
      [g(Na), g(a) ? void 0 : s.target]
    ]);
  }
}), Wd = ["id", "aria-labelledby"], Ud = ["id"], Xd = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "BOffcanvas",
  props: {
    modelValue: { type: [String, Boolean], default: !1 },
    bodyScrolling: { type: [String, Boolean], default: !1 },
    backdrop: { type: [String, Boolean], default: !0 },
    noCloseOnBackdrop: { type: [String, Boolean], default: !1 },
    noCloseOnEsc: { type: [String, Boolean], default: !1 },
    placement: { default: "start" },
    title: { default: void 0 },
    noHeaderClose: { type: [String, Boolean], default: !1 },
    noHeader: { type: [String, Boolean], default: !1 },
    lazy: { type: [String, Boolean], default: !1 },
    id: { default: void 0 },
    noFocus: { type: [String, Boolean], default: !1 },
    backdropVariant: { default: "dark" },
    headerClass: { default: void 0 },
    headerCloseClass: { default: void 0 },
    headerCloseLabel: { default: "Close" },
    headerCloseVariant: { default: "secondary" },
    bodyClass: { default: void 0 },
    footerClass: { default: void 0 },
    teleportDisabled: { type: [String, Boolean], default: !1 },
    teleportTo: { default: "body" }
  },
  emits: ["update:modelValue", "show", "shown", "hide", "hidden", "hide-prevented", "show-prevented", "esc", "close"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = Oe(), n = Se(a, "modelValue", l, { passive: !0 }), s = u(n), r = u(() => a.bodyScrolling), i = u(() => a.backdrop), d = u(() => a.noHeaderClose), y = u(() => a.noHeader), b = u(() => a.noFocus), c = u(() => a.noCloseOnBackdrop), h = u(() => a.noCloseOnEsc), S = u(() => a.lazy), B = u(() => a.teleportDisabled), F = ke(() => a.id, "offcanvas");
    Qo(s, r);
    const w = M(null);
    At(
      "Escape",
      () => {
        O("esc");
      },
      { target: w }
    );
    const { focused: V } = Ne(w, {
      initialValue: s.value && b.value === !1
    }), T = M(s.value), $ = M(!1), m = P(() => i.value === !0 && s.value === !0), k = P(
      () => S.value === !1 || S.value === !0 && $.value === !0 || S.value === !0 && s.value === !0
    ), f = P(() => !Ve(o["header-close"])), _ = C(() => [
      { "text-reset": !f.value },
      a.headerCloseClass
    ]), L = C(() => ({
      variant: f.value ? a.headerCloseVariant : void 0,
      class: _.value
    })), v = P(() => !Ve(o.footer)), I = C(() => [
      // props.responsive === undefined ? 'offcanvas' : `offcanvas-${props.responsive}`,
      "offcanvas",
      // Remove when above check is fixed
      `offcanvas-${a.placement}`,
      {
        show: s.value && T.value === !0
      }
    ]), z = (te, ie = {}) => new Et(te, {
      cancelable: !1,
      target: w.value || null,
      relatedTarget: null,
      trigger: null,
      ...ie,
      componentId: F.value
    }), O = (te = "") => {
      const ie = z("hide", { cancelable: te !== "", trigger: te });
      if (te === "close" && l(te, ie), te === "esc" && l(te, ie), l("hide", ie), ie.defaultPrevented || te === "backdrop" && c.value || te === "esc" && h.value) {
        l("hide-prevented");
        return;
      }
      n.value = !1;
    }, q = () => {
      const te = z("show", { cancelable: !0 });
      if (l("show", te), te.defaultPrevented) {
        n.value = !1, l("show-prevented");
        return;
      }
      n.value = !0;
    }, Y = () => {
      Te(() => {
        b.value === !1 && (V.value = !0);
      });
    }, U = () => q(), ue = () => {
      T.value = !0, Y(), l("shown", z("shown")), S.value === !0 && ($.value = !0);
    }, ee = () => {
      T.value = !1;
    }, pe = () => {
      l("hidden", z("hidden")), S.value === !0 && ($.value = !1);
    };
    return we(w, "bv-toggle", () => {
      s.value ? O() : q();
    }), t({
      hide: O,
      show: q
    }), (te, ie) => (p(), x(sa, {
      to: te.teleportTo,
      disabled: g(B)
    }, [
      be(Nt, {
        "no-fade": !0,
        "trans-props": {
          enterToClass: "showing",
          enterFromClass: "",
          leaveToClass: "hiding show",
          leaveFromClass: "show"
        },
        onBeforeEnter: U,
        onAfterEnter: ue,
        onLeave: ee,
        onAfterLeave: pe
      }, {
        default: D(() => [
          ft(Z("div", ae({
            id: g(F),
            ref_key: "element",
            ref: w,
            "aria-modal": "true",
            role: "dialog",
            class: I.value,
            tabindex: "-1",
            "aria-labelledby": `${g(F)}-offcanvas-label`,
            "data-bs-backdrop": "false"
          }, te.$attrs), [
            k.value ? (p(), E(fe, { key: 0 }, [
              g(y) ? K("", !0) : (p(), E("div", {
                key: 0,
                class: H(["offcanvas-header", te.headerClass])
              }, [
                A(te.$slots, "header", {
                  visible: g(s),
                  placement: te.placement,
                  hide: O
                }, () => [
                  Z("h5", {
                    id: `${g(F)}-offcanvas-label`,
                    class: "offcanvas-title"
                  }, [
                    A(te.$slots, "title", {
                      visible: g(s),
                      placement: te.placement,
                      hide: O
                    }, () => [
                      re(J(te.title), 1)
                    ])
                  ], 8, Ud),
                  g(d) ? K("", !0) : (p(), E(fe, { key: 0 }, [
                    f.value ? (p(), x(it, ae({ key: 0 }, L.value, {
                      onClick: ie[0] || (ie[0] = (me) => O("close"))
                    }), {
                      default: D(() => [
                        A(te.$slots, "header-close")
                      ]),
                      _: 3
                    }, 16)) : (p(), x(Pt, ae({
                      key: 1,
                      "aria-label": te.headerCloseLabel
                    }, L.value, {
                      onClick: ie[1] || (ie[1] = (me) => O("close"))
                    }), null, 16, ["aria-label"]))
                  ], 64))
                ])
              ], 2)),
              Z("div", {
                class: H(["offcanvas-body", te.bodyClass])
              }, [
                A(te.$slots, "default", {
                  visible: g(s),
                  placement: te.placement,
                  hide: O
                })
              ], 2),
              v.value ? (p(), E("div", {
                key: 1,
                class: H(te.footerClass)
              }, [
                A(te.$slots, "footer", {
                  visible: g(s),
                  placement: te.placement,
                  hide: O
                })
              ], 2)) : K("", !0)
            ], 64)) : K("", !0)
          ], 16, Wd), [
            [ra, g(n)]
          ])
        ]),
        _: 3
      }),
      A(te.$slots, "backdrop", {}, () => [
        be(nl, {
          variant: te.backdropVariant,
          show: m.value,
          fixed: "",
          "no-wrap": "",
          "no-spinner": "",
          onClick: ie[2] || (ie[2] = (me) => O("backdrop"))
        }, null, 8, ["variant", "show"])
      ])
    ], 8, ["to", "disabled"]));
  }
}), Kd = 5, $n = 20, _n = 0, Ue = 3, Jd = "ellipsis-text", Yd = "first-text", Zd = "last-text", Qd = "next-text", ec = "page", tc = "prev-text", ql = (e) => Math.max(mt(e) || $n, 1), Gl = (e) => Math.max(mt(e) || _n, 0), ac = (e, t) => {
  const l = mt(e) || 1;
  return l > t ? t : l < 1 ? 1 : l;
}, lc = R({
  name: "BPagination",
  props: {
    align: { type: String, default: "start" },
    ariaControls: { type: String, default: void 0 },
    ariaLabel: { type: String, default: "Pagination" },
    disabled: { type: [Boolean, String], default: !1 },
    ellipsisClass: { type: [Array, String], default: () => [] },
    ellipsisText: { type: String, default: "…" },
    firstClass: { type: [Array, String], default: () => [] },
    firstNumber: { type: [Boolean, String], default: !1 },
    firstText: { type: String, default: "«" },
    hideEllipsis: { type: [Boolean, String], default: !1 },
    hideGotoEndButtons: { type: [Boolean, String], default: !1 },
    labelFirstPage: { type: String, default: "Go to first page" },
    labelLastPage: { type: String, default: "Go to last page" },
    labelNextPage: { type: String, default: "Go to next page" },
    labelPage: { type: String, default: "Go to page" },
    labelPrevPage: { type: String, default: "Go to previous page" },
    lastClass: { type: [Array, String], default: () => [] },
    lastNumber: { type: [Boolean, String], default: !1 },
    lastText: { type: String, default: "»" },
    limit: { type: Number, default: Kd },
    modelValue: { type: Number, default: 1 },
    // V-model prop
    nextClass: { type: [Array, String], default: () => [] },
    nextText: { type: String, default: "›" },
    pageClass: { type: [Array, String], default: () => [] },
    perPage: { type: Number, default: $n },
    pills: { type: [Boolean, String], default: !1 },
    prevClass: { type: [Array, String], default: () => [] },
    prevText: { type: String, default: "‹" },
    size: { type: String, default: "md" },
    totalRows: { type: Number, default: _n }
  },
  emits: ["update:modelValue", "page-click"],
  setup(e, { emit: t, slots: l }) {
    const a = Se(e, "modelValue", t), o = u(() => e.disabled), n = u(() => e.firstNumber), s = u(() => e.hideEllipsis), r = u(() => e.hideGotoEndButtons), i = u(() => e.lastNumber), d = u(() => e.pills), y = P(() => e.align === "fill" ? "start" : e.align), b = Mt(y), c = P(
      () => Math.ceil(Gl(e.totalRows) / ql(e.perPage))
    ), h = C(() => {
      let k;
      return c.value - a.value + 2 < e.limit && e.limit > Ue ? k = c.value - B.value + 1 : k = a.value - Math.floor(B.value / 2), k < 1 ? k = 1 : k > c.value - B.value && (k = c.value - B.value + 1), e.limit <= Ue && i.value && c.value === k + B.value - 1 && (k = Math.max(k - 1, 1)), k;
    }), S = C(() => {
      const k = c.value - a.value;
      let f = !1;
      return k + 2 < e.limit && e.limit > Ue ? e.limit > Ue && (f = !0) : e.limit > Ue && (f = !!(!s.value || n.value)), h.value <= 1 && (f = !1), f && n.value && h.value < 4 && (f = !1), f;
    }), B = C(() => {
      let k = e.limit;
      return c.value <= e.limit ? k = c.value : a.value < e.limit - 1 && e.limit > Ue ? ((!s.value || i.value) && (k = e.limit - (n.value ? 0 : 1)), k = Math.min(k, e.limit)) : c.value - a.value + 2 < e.limit && e.limit > Ue ? (!s.value || n.value) && (k = e.limit - (i.value ? 0 : 1)) : e.limit > Ue && (k = e.limit - (s.value ? 0 : 2)), k;
    }), F = C(() => {
      const k = c.value - B.value;
      let f = !1;
      a.value < e.limit - 1 && e.limit > Ue ? (!s.value || i.value) && (f = !0) : e.limit > Ue && (f = !!(!s.value || i.value)), h.value > k && (f = !1);
      const _ = h.value + B.value - 1;
      return f && i.value && _ > c.value - 3 && (f = !1), f;
    }), w = It({
      pageSize: ql(e.perPage),
      totalRows: Gl(e.totalRows),
      numberOfPages: c.value
    }), V = (k, f) => {
      if (f === a.value)
        return;
      const { target: _ } = k, L = new at("page-click", {
        cancelable: !0,
        target: _
      });
      t("page-click", L, f), !L.defaultPrevented && (a.value = f);
    }, T = P(() => e.size ? `pagination-${e.size}` : ""), $ = P(() => d.value ? "b-pagination-pills" : "");
    se(a, (k) => {
      const f = ac(k, c.value);
      f !== a.value && (a.value = f);
    }), se(w, (k, f) => {
      k != null && (f.pageSize !== k.pageSize && f.totalRows === k.totalRows || f.numberOfPages !== k.numberOfPages && a.value > f.numberOfPages) && (a.value = 1);
    });
    const m = C(() => {
      const k = [];
      for (let f = 0; f < B.value; f++)
        k.push({ number: h.value + f, classes: null });
      return k;
    });
    return () => {
      const k = [], f = m.value.map((U) => U.number), _ = (U) => U === a.value, L = a.value < 1, v = e.align === "fill", I = (U, ue, ee, pe, te, ie) => {
        const me = o.value || _(ie) || L || U < 1 || U > c.value, G = U < 1 ? 1 : U > c.value ? c.value : U, W = { disabled: me, page: G, index: G - 1 }, de = et(ee, W, l) || pe || "";
        return ye(
          "li",
          {
            class: [
              "page-item",
              {
                disabled: me,
                "flex-fill": v,
                "d-flex": v && !me
              },
              te
            ]
          },
          // render inner content
          ye(
            me ? "span" : "button",
            {
              class: ["page-link", { "flex-grow-1": !me && v }],
              "aria-label": ue,
              "aria-controls": e.ariaControls || null,
              "aria-disabled": me ? !0 : null,
              role: "menuitem",
              type: me ? null : "button",
              tabindex: me ? null : "-1",
              onClick: (ge) => {
                me || V(ge, G);
              }
            },
            de
          )
        );
      }, z = (U) => ye(
        "li",
        {
          class: [
            "page-item",
            "disabled",
            "bv-d-xs-down-none",
            v ? "flex-fill" : "",
            e.ellipsisClass
          ],
          role: "separator",
          key: `ellipsis-${U ? "last" : "first"}`
        },
        [
          ye(
            "span",
            { class: ["page-link"] },
            et(Jd, {}, l) || e.ellipsisText || "..."
          )
        ]
      ), O = (U, ue) => {
        const ee = _(U.number) && !L, pe = o.value ? null : ee || L && ue === 0 ? "0" : "-1", te = {
          active: ee,
          disabled: o.value,
          page: U.number,
          index: U.number - 1,
          content: U.number
        }, ie = et(ec, te, l) || U.number, me = ye(
          o.value ? "span" : "button",
          {
            class: ["page-link", { "flex-grow-1": !o.value && v }],
            "aria-controls": e.ariaControls || null,
            "aria-disabled": o.value ? !0 : null,
            "aria-label": e.labelPage ? `${e.labelPage} ${U.number}` : null,
            role: "menuitemradio",
            type: o.value ? null : "button",
            tabindex: pe,
            onClick: (G) => {
              o.value || V(G, U.number);
            }
          },
          ie
        );
        return ye(
          "li",
          {
            class: [
              "page-item",
              {
                disabled: o.value,
                active: ee,
                "flex-fill": v,
                "d-flex": v && !o.value
              },
              e.pageClass
            ],
            role: "presentation",
            key: `page-${U.number}`
          },
          me
        );
      };
      if (!r.value && !n.value) {
        const U = I(
          1,
          e.labelFirstPage,
          Yd,
          e.firstText,
          e.firstClass,
          1
        );
        k.push(U);
      }
      const q = I(
        a.value - 1,
        e.labelFirstPage,
        tc,
        e.prevText,
        e.prevClass,
        1
      );
      k.push(q), n.value && f[0] !== 1 && k.push(O({ number: 1 }, 0)), S.value && k.push(z(!1)), m.value.forEach((U, ue) => {
        const ee = S.value && n.value && f[0] !== 1 ? 1 : 0;
        k.push(O(U, ue + ee));
      }), F.value && k.push(z(!0)), i.value && f[f.length - 1] !== c.value && k.push(O({ number: c.value }, -1));
      const Y = I(
        a.value + 1,
        e.labelNextPage,
        Qd,
        e.nextText,
        e.nextClass,
        c.value
      );
      if (k.push(Y), !i.value && !r.value) {
        const U = I(
          c.value,
          e.labelLastPage,
          Zd,
          e.lastText,
          e.lastClass,
          c.value
        );
        k.push(U);
      }
      return ye(
        "ul",
        {
          class: ["pagination", T.value, b.value, $.value],
          role: "menubar",
          "aria-disabled": o.value,
          "aria-label": e.ariaLabel || null
        },
        k
      );
    };
  }
}), ze = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "BPlaceholder",
  props: {
    tag: { default: "span" },
    wrapperTag: { default: "span" },
    width: { default: void 0 },
    cols: { default: 12 },
    variant: { default: null },
    size: { default: "md" },
    animation: { default: void 0 }
  },
  setup(e) {
    const t = e, l = C(
      () => t.width === void 0 ? void 0 : typeof t.width == "number" ? t.width.toString() : t.width.replace("%", "")
    ), a = C(
      () => t.cols === void 0 ? void 0 : typeof t.cols == "number" ? t.cols.toString() : t.cols
    ), o = C(() => ({
      [`col-${a.value}`]: a.value !== void 0 && l.value === void 0,
      [`bg-${t.variant}`]: t.variant !== null,
      [`placeholder-${t.size}`]: t.size !== "md"
    })), n = C(() => ({
      [`placeholder-${t.animation}`]: t.animation !== void 0
    })), s = C(() => ({
      width: l.value === void 0 ? void 0 : `${l.value}%`
    }));
    return (r, i) => (p(), x(oe(r.wrapperTag), {
      class: H(n.value)
    }, {
      default: D(() => [
        (p(), x(oe(r.tag), ae(r.$attrs, {
          class: ["placeholder", o.value],
          style: s.value
        }), null, 16, ["class", "style"]))
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Tn = /* @__PURE__ */ R({
  __name: "BPlaceholderButton",
  props: {
    tag: { default: "div" },
    width: { default: void 0 },
    cols: { default: void 0 },
    variant: { default: "primary" },
    animation: { default: void 0 }
  },
  setup(e) {
    const t = e, l = C(() => ({
      [`btn-${t.variant}`]: t.variant !== null
    }));
    return (a, o) => (p(), x(ze, {
      class: H(["btn disabled", l.value]),
      animation: a.animation,
      width: a.width,
      cols: a.cols,
      tag: a.tag
    }, null, 8, ["class", "animation", "width", "cols", "tag"]));
  }
}), oc = /* @__PURE__ */ R({
  __name: "BPlaceholderCard",
  props: {
    noHeader: { type: [String, Boolean], default: !1 },
    headerWidth: { default: 100 },
    headerVariant: { default: void 0 },
    headerAnimation: { default: void 0 },
    headerSize: { default: "md" },
    noFooter: { type: [String, Boolean], default: !1 },
    footerWidth: { default: 100 },
    footerVariant: { default: void 0 },
    footerAnimation: { default: void 0 },
    footerSize: { default: "md" },
    animation: { default: void 0 },
    size: { default: "md" },
    variant: { default: void 0 },
    noButton: { type: [String, Boolean], default: !1 },
    imgBottom: { type: [String, Boolean], default: !1 },
    imgSrc: { default: void 0 },
    imgBlankColor: { default: "#868e96" },
    imgHeight: { default: 100 },
    noImg: { type: [String, Boolean], default: !1 }
  },
  setup(e) {
    const t = e, l = u(() => t.noButton), a = u(() => t.noHeader), o = u(() => t.noFooter), n = u(() => t.noImg), s = C(() => ({
      width: t.footerWidth,
      animation: t.footerAnimation,
      size: l.value ? t.footerSize : void 0,
      variant: t.footerVariant
    })), r = C(() => ({
      animation: t.animation,
      size: t.size,
      variant: t.variant
    }));
    return (i, d) => (p(), x(cn, { "img-bottom": i.imgBottom }, Ha({
      default: D(() => [
        A(i.$slots, "default", {}, () => [
          be(ze, ae({ cols: "7" }, r.value), null, 16),
          be(ze, ae({ cols: "4" }, r.value), null, 16),
          be(ze, ae({ cols: "4" }, r.value), null, 16),
          be(ze, ae({ cols: "6" }, r.value), null, 16),
          be(ze, ae({ cols: "8" }, r.value), null, 16)
        ])
      ]),
      _: 2
    }, [
      g(n) ? void 0 : {
        name: "img",
        fn: D(() => [
          A(i.$slots, "img", {}, () => [
            be(na, {
              blank: !i.imgSrc,
              "blank-color": i.imgBlankColor,
              height: i.imgSrc ? void 0 : i.imgHeight,
              src: i.imgSrc,
              top: !i.imgBottom,
              bottom: i.imgBottom
            }, null, 8, ["blank", "blank-color", "height", "src", "top", "bottom"])
          ])
        ]),
        key: "0"
      },
      g(a) ? void 0 : {
        name: "header",
        fn: D(() => [
          A(i.$slots, "header", {}, () => [
            be(ze, {
              width: i.headerWidth,
              variant: i.headerVariant,
              animation: i.headerAnimation,
              size: i.headerSize
            }, null, 8, ["width", "variant", "animation", "size"])
          ])
        ]),
        key: "1"
      },
      g(o) ? void 0 : {
        name: "footer",
        fn: D(() => [
          A(i.$slots, "footer", {}, () => [
            g(l) ? (p(), x(ze, _e(ae({ key: 1 }, s.value)), null, 16)) : (p(), x(Tn, _e(ae({ key: 0 }, s.value)), null, 16))
          ])
        ]),
        key: "2"
      }
    ]), 1032, ["img-bottom"]));
  }
}), sl = /* @__PURE__ */ R({
  __name: "BTableSimple",
  props: {
    bordered: { type: [String, Boolean], default: !1 },
    borderless: { type: [String, Boolean], default: !1 },
    borderVariant: { default: null },
    captionTop: { type: [String, Boolean], default: !1 },
    dark: { type: [String, Boolean], default: !1 },
    hover: { type: [String, Boolean], default: !1 },
    responsive: { type: [Boolean, String], default: !1 },
    stacked: { type: [Boolean, String], default: !1 },
    striped: { type: [String, Boolean], default: !1 },
    stripedColumns: { type: [String, Boolean], default: !1 },
    small: { type: [String, Boolean], default: !1 },
    tableClass: { default: void 0 },
    tableVariant: { default: null },
    stickyHeader: { type: [String, Boolean], default: !1 }
  },
  setup(e) {
    const t = e, l = u(() => t.captionTop), a = u(() => t.borderless), o = u(() => t.bordered), n = u(() => t.dark), s = u(() => t.hover), r = u(() => t.small), i = u(() => t.striped), d = u(() => t.stickyHeader), y = u(() => t.stripedColumns), b = C(() => [
      t.tableClass,
      "table",
      "b-table",
      {
        "table-bordered": o.value,
        "table-borderless": a.value,
        [`border-${t.borderVariant}`]: t.borderVariant !== null,
        "caption-top": l.value,
        "table-dark": n.value,
        "table-hover": s.value,
        "b-table-stacked": typeof t.stacked == "boolean" && t.stacked,
        [`b-table-stacked-${t.stacked}`]: typeof t.stacked == "string",
        "table-striped": i.value,
        "table-sm": r.value,
        [`table-${t.tableVariant}`]: t.tableVariant !== null,
        "table-striped-columns": y.value
      }
    ]), c = C(() => ({
      "table-responsive": t.responsive === !0,
      [`table-responsive-${t.responsive}`]: typeof t.responsive == "string",
      "b-table-sticky-header": d.value
    }));
    return (h, S) => h.responsive ? (p(), E("div", {
      key: 1,
      class: H(c.value)
    }, [
      Z("table", {
        class: H(b.value)
      }, [
        A(h.$slots, "default")
      ], 2)
    ], 2)) : (p(), E("table", {
      key: 0,
      class: H(b.value)
    }, [
      A(h.$slots, "default")
    ], 2));
  }
}), nc = /* @__PURE__ */ R({
  __name: "BPlaceholderTable",
  props: {
    rows: { default: 3 },
    columns: { default: 5 },
    cellWidth: { default: 100 },
    size: { default: "md" },
    animation: { default: void 0 },
    variant: { default: void 0 },
    headerColumns: { default: void 0 },
    hideHeader: { type: [String, Boolean], default: !1 },
    headerCellWidth: { default: 100 },
    headerSize: { default: "md" },
    headerAnimation: { default: void 0 },
    headerVariant: { default: void 0 },
    footerColumns: { default: void 0 },
    showFooter: { type: [String, Boolean], default: !1 },
    footerCellWidth: { default: 100 },
    footerSize: { default: "md" },
    footerAnimation: { default: void 0 },
    footerVariant: { default: void 0 }
  },
  setup(e) {
    const t = e, l = Be(() => t.columns), a = Be(() => t.rows), o = P(() => t.headerColumns ?? NaN), n = P(() => t.footerColumns ?? NaN), s = Be(o), r = Be(n), i = P(() => l.value || 5), d = P(() => a.value || 3), y = P(
      () => t.headerColumns === void 0 ? i.value : s.value
    ), b = P(
      () => t.footerColumns === void 0 ? i.value : r.value
    ), c = u(() => t.hideHeader), h = u(() => t.showFooter);
    return (S, B) => (p(), x(sl, null, {
      default: D(() => [
        g(c) ? K("", !0) : A(S.$slots, "thead", { key: 0 }, () => [
          Z("thead", null, [
            Z("tr", null, [
              (p(!0), E(fe, null, he(y.value, (F, w) => (p(), E("th", { key: w }, [
                be(ze, {
                  size: S.headerSize,
                  variant: S.headerVariant,
                  animation: S.headerAnimation,
                  width: S.headerCellWidth
                }, null, 8, ["size", "variant", "animation", "width"])
              ]))), 128))
            ])
          ])
        ]),
        A(S.$slots, "default", {}, () => [
          Z("tbody", null, [
            (p(!0), E(fe, null, he(d.value, (F, w) => (p(), E("tr", { key: w }, [
              (p(!0), E(fe, null, he(i.value, (V, T) => (p(), E("td", { key: T }, [
                be(ze, {
                  size: S.size,
                  variant: S.variant,
                  animation: S.animation,
                  width: S.cellWidth
                }, null, 8, ["size", "variant", "animation", "width"])
              ]))), 128))
            ]))), 128))
          ])
        ]),
        g(h) ? A(S.$slots, "tfoot", { key: 1 }, () => [
          Z("tfoot", null, [
            Z("tr", null, [
              (p(!0), E(fe, null, he(b.value, (F, w) => (p(), E("th", { key: w }, [
                be(ze, {
                  size: S.footerSize,
                  variant: S.footerVariant,
                  animation: S.footerAnimation,
                  width: S.footerCellWidth
                }, null, 8, ["size", "variant", "animation", "width"])
              ]))), 128))
            ])
          ])
        ]) : K("", !0)
      ]),
      _: 3
    }));
  }
}), sc = /* @__PURE__ */ R({
  __name: "BPlaceholderWrapper",
  props: {
    loading: { type: [String, Boolean], default: !1 }
  },
  setup(e) {
    const t = e, l = u(() => t.loading);
    return (a, o) => g(l) ? A(a.$slots, "loading", { key: 0 }) : A(a.$slots, "default", { key: 1 });
  }
}), rc = ["aria-valuenow", "aria-valuemax"], Vn = /* @__PURE__ */ R({
  __name: "BProgressBar",
  props: {
    animated: { type: [String, Boolean], default: !1 },
    label: { default: void 0 },
    labelHtml: { default: void 0 },
    max: { default: void 0 },
    precision: { default: 0 },
    showProgress: { type: [String, Boolean], default: !1 },
    showValue: { type: [String, Boolean], default: !1 },
    striped: { type: [String, Boolean], default: !1 },
    value: { default: 0 },
    variant: { default: null },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  setup(e) {
    const t = e, l = Pe(fo, null), a = u(() => t.animated), o = u(() => t.showProgress), n = u(() => t.showValue), s = u(() => t.striped), r = je(t), i = C(() => [
      r.value,
      {
        "progress-bar-animated": a.value || (l == null ? void 0 : l.animated.value),
        "progress-bar-striped": s.value || (l == null ? void 0 : l.striped.value) || a.value || (l == null ? void 0 : l.animated.value)
      }
    ]), d = Be(() => t.precision), y = Be(() => t.value), b = Be(P(() => t.max ?? NaN)), c = Be(P(() => (l == null ? void 0 : l.max.value) ?? NaN)), h = C(
      () => t.labelHtml !== void 0 ? t.labelHtml : n.value || l != null && l.showValue.value ? y.value.toFixed(d.value) : o.value || l != null && l.showProgress.value ? (y.value * 100 / (b.value || 100)).toFixed(d.value) : t.label !== void 0 ? t.label : ""
    ), S = C(
      () => c.value ? `${y.value * 100 / c.value}%` : b.value ? `${y.value * 100 / b.value}%` : typeof t.value == "string" ? t.value : `${t.value}%`
    );
    return (B, F) => (p(), E("div", {
      class: H(["progress-bar", i.value]),
      role: "progressbar",
      "aria-valuenow": B.value,
      "aria-valuemin": "0",
      "aria-valuemax": B.max,
      style: Re({ width: S.value })
    }, [
      A(B.$slots, "default", {}, () => [
        re(J(h.value), 1)
      ])
    ], 14, rc));
  }
}), An = /* @__PURE__ */ R({
  __name: "BProgress",
  props: {
    height: { default: void 0 },
    animated: { type: [String, Boolean], default: !1 },
    max: { default: 100 },
    precision: { default: 0 },
    showProgress: { type: [String, Boolean], default: !1 },
    showValue: { type: [String, Boolean], default: !1 },
    striped: { type: [String, Boolean], default: !1 },
    value: { default: 0 },
    variant: { default: void 0 },
    bgVariant: { default: void 0 },
    textVariant: { default: void 0 }
  },
  setup(e) {
    const t = e, l = u(() => t.animated), a = u(() => t.showProgress), o = u(() => t.showValue), n = u(() => t.striped);
    return We(fo, {
      animated: l,
      max: P(() => t.max),
      showProgress: a,
      showValue: o,
      striped: n
    }), (s, r) => (p(), E("div", {
      class: "progress",
      style: Re({ height: s.height })
    }, [
      A(s.$slots, "default", {}, () => [
        be(Vn, {
          animated: s.animated,
          max: s.max,
          precision: s.precision,
          "show-progress": s.showProgress,
          "show-value": s.showValue,
          striped: s.striped,
          value: s.value,
          variant: s.variant,
          "text-variant": s.textVariant,
          "bg-variant": s.bgVariant
        }, null, 8, ["animated", "max", "precision", "show-progress", "show-value", "striped", "value", "variant", "text-variant", "bg-variant"])
      ])
    ], 4));
  }
}), Wl = ua("cols", [""], { type: [String, Number], default: null }), ic = R({
  name: "BRow",
  slots: Object,
  props: {
    tag: { type: String, default: "div" },
    gutterX: { type: String, default: null },
    gutterY: { type: String, default: null },
    noGutters: { type: [Boolean, String], default: !1 },
    alignV: { type: String, default: null },
    alignH: { type: String, default: null },
    alignContent: { type: String, default: null },
    ...Wl
  },
  setup(e) {
    const t = u(() => e.noGutters), l = Mt(() => e.alignH), a = C(() => ro(e, Wl, "cols", "row-cols"));
    return {
      computedClasses: C(() => [
        a.value,
        {
          [`gx-${e.gutterX}`]: e.gutterX !== null,
          [`gy-${e.gutterY}`]: e.gutterY !== null,
          "g-0": t.value,
          [`align-items-${e.alignV}`]: e.alignV !== null,
          [l.value]: e.alignH !== null,
          [`align-content-${e.alignContent}`]: e.alignContent !== null
        }
      ])
    };
  }
});
function uc(e, t, l, a, o, n) {
  return p(), x(oe(e.tag), {
    class: H(["row", e.computedClasses])
  }, {
    default: D(() => [
      A(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]);
}
const dc = /* @__PURE__ */ ma(ic, [["render", uc]]), cc = ["TD", "TH", "TR"], fc = [
  "a",
  "a *",
  // Include content inside links
  "button",
  "button *",
  // Include content inside buttons
  "input:not(.disabled):not([disabled])",
  "select:not(.disabled):not([disabled])",
  "textarea:not(.disabled):not([disabled])",
  '[role="link"]',
  '[role="link"] *',
  '[role="button"]',
  '[role="button"] *',
  "[tabindex]:not(.disabled):not([disabled])"
].join(","), Ut = (e) => {
  if (!e || !e.target)
    return !1;
  const t = e.target;
  if ("disabled" in t && t.disabled || cc.indexOf(t.tagName) !== -1)
    return !1;
  if (cl(".dropdown-menu", t))
    return !0;
  const l = t.tagName === "LABEL" ? t : cl("label", t);
  if (l) {
    const a = Ma(l, "for"), o = a ? Bs(a) : no("input, select, textarea", l);
    if (o && !o.disabled)
      return !0;
  }
  return so(t, fc);
}, vc = ["title", "abbr", "onClick"], pc = { class: "d-inline-flex flex-nowrap align-items-center gap-1" }, mc = { key: 1 }, gc = { key: 0 }, yc = ["onClick", "onDblclick", "onMouseenter", "onMouseleave"], bc = {
  key: 0,
  class: "b-table-stacked-label"
}, hc = ["colspan"], Bc = {
  key: 1,
  class: "b-table-empty-slot"
}, Sc = ["colspan"], wc = { key: 2 }, Cc = { key: 0 }, kc = ["title", "abbr", "onClick"], $c = { key: 1 }, _c = { key: 2 }, Tc = { key: 3 }, On = /* @__PURE__ */ R({
  __name: "BTableLite",
  props: {
    align: { default: void 0 },
    caption: { default: void 0 },
    fields: { default: () => [] },
    footClone: { type: [String, Boolean], default: !1 },
    items: { default: () => [] },
    labelStacked: { type: Boolean, default: !1 },
    variant: { default: void 0 },
    showEmpty: { type: [String, Boolean], default: !1 },
    emptyText: { default: "There are no records to show" },
    emptyFilteredText: { default: "There are no records matching your request" },
    fieldColumnClass: { type: Function, default: void 0 },
    tbodyTrClass: { type: Function, default: void 0 },
    virtualFields: { default: 0 },
    bordered: { type: [String, Boolean], default: !1 },
    borderless: { type: [String, Boolean], default: !1 },
    borderVariant: { default: void 0 },
    captionTop: { type: [String, Boolean], default: !1 },
    dark: { type: [String, Boolean], default: !1 },
    hover: { type: [String, Boolean], default: !1 },
    responsive: { type: [Boolean, String], default: !1 },
    stacked: { type: [Boolean, String], default: !1 },
    striped: { type: [String, Boolean], default: !1 },
    stripedColumns: { type: [String, Boolean], default: !1 },
    small: { type: [String, Boolean], default: !1 },
    tableClass: { default: void 0 },
    stickyHeader: { type: [String, Boolean], default: !1 }
  },
  emits: ["head-clicked", "row-clicked", "row-dbl-clicked", "row-hovered", "row-unhovered"],
  setup(e, { emit: t }) {
    const l = e, a = u(() => l.footClone), o = u(() => l.labelStacked), n = u(() => l.showEmpty), s = Be(() => l.virtualFields), r = C(() => [
      l.tableClass,
      {
        [`align-${l.align}`]: l.align !== void 0
      }
    ]), i = C(() => b(l.fields, l.items)), d = P(() => i.value.length + s.value), y = (f) => typeof f == "string" ? il(f) : f.label !== void 0 ? f.label : typeof f.key == "string" ? il(f.key) : f.key, b = (f, _) => {
      const L = [];
      return !(f != null && f.length) && (_ != null && _.length) ? (Object.keys(_[0]).forEach((v) => L.push({ key: v, label: rl(v) })), L) : (Array.isArray(f) && f.forEach((v) => {
        typeof v == "string" ? L.push({ key: v, label: rl(v) }) : Sa(v) && v.key && typeof v.key == "string" && L.push({ ...v });
      }), L);
    }, c = (f, _, L) => {
      const v = fl(f, _);
      return L && typeof L == "function" ? L(v, _, f) : v;
    }, h = (f, _) => c(f, _.key, _.formatter), S = (f, _, L = !1) => {
      const v = typeof f == "string" ? f : f.key;
      t("head-clicked", v, f, _, L);
    }, B = (f, _, L) => {
      t("row-clicked", f, _, L);
    }, F = (f, _, L) => t("row-dbl-clicked", f, _, L), w = (f, _, L) => t("row-hovered", f, _, L), V = (f, _, L) => t("row-unhovered", f, _, L), T = (f) => {
      f._showDetails = !f._showDetails;
    }, $ = (f) => [
      f.class,
      f.thClass,
      {
        [`table-${f.variant}`]: f.variant !== null,
        "b-table-sticky-column": f.stickyColumn
      },
      ...l.fieldColumnClass ? l.fieldColumnClass(f) : []
    ], m = (f, _) => [
      f.class,
      f.tdClass,
      _ != null && _._cellVariants && (_ != null && _._cellVariants[f.key]) ? `table-${_ == null ? void 0 : _._cellVariants[f.key]}` : void 0,
      {
        [`table-${f.variant}`]: f.variant !== null,
        "b-table-sticky-column": f.stickyColumn
      }
    ], k = (f, _ = "row") => {
      const L = [
        f._rowVariant ? `table-${f._rowVariant}` : null,
        f._rowVariant ? `table-${f._rowVariant}` : null
      ];
      if (l.tbodyTrClass) {
        const v = l.tbodyTrClass(f, _);
        v && L.push(...typeof v == "string" ? [v] : v);
      }
      return L;
    };
    return (f, _) => (p(), x(sl, {
      bordered: f.bordered,
      borderless: f.borderless,
      "border-variant": f.borderVariant,
      "caption-top": f.captionTop,
      dark: f.dark,
      hover: f.hover,
      responsive: f.responsive,
      striped: f.striped,
      stacked: f.stacked,
      small: f.small,
      "table-class": r.value,
      "table-variant": f.variant,
      "sticky-header": f.stickyHeader,
      "striped-columns": f.stripedColumns
    }, {
      default: D(() => {
        var L;
        return [
          Z("thead", null, [
            f.$slots["thead-top"] ? A(f.$slots, "thead-top", { key: 0 }) : K("", !0),
            Z("tr", null, [
              A(f.$slots, "thead-tr-prefix"),
              (p(!0), E(fe, null, he(i.value, (v) => (p(), E("th", ae({
                key: v.key,
                scope: "col",
                class: $(v),
                title: v.headerTitle,
                abbr: v.headerAbbr,
                style: v.thStyle
              }, v.thAttr, {
                onClick: (I) => S(v, I)
              }), [
                Z("div", pc, [
                  A(f.$slots, "field-prefix", { field: v }),
                  Z("div", null, [
                    f.$slots[`head(${v.key})`] || f.$slots["head()"] ? A(f.$slots, f.$slots[`head(${v.key})`] ? `head(${v.key})` : "head()", {
                      key: 0,
                      label: v.label,
                      column: v.key,
                      field: v,
                      isFoot: !1
                    }) : (p(), E(fe, { key: 1 }, [
                      re(J(y(v)), 1)
                    ], 64))
                  ])
                ])
              ], 16, vc))), 128))
            ]),
            f.$slots["thead-sub"] ? (p(), E("tr", mc, [
              (p(!0), E(fe, null, he(i.value, (v) => (p(), E("td", {
                key: v.key,
                scope: "col",
                class: H([v.class, v.thClass, v.variant ? `table-${v.variant}` : ""])
              }, [
                f.$slots["thead-sub"] ? A(f.$slots, "thead-sub", ae({
                  key: 0,
                  items: i.value
                }, v)) : (p(), E(fe, { key: 1 }, [
                  re(J(v.label), 1)
                ], 64))
              ], 2))), 128))
            ])) : K("", !0)
          ]),
          Z("tbody", null, [
            !f.stacked && f.$slots["top-row"] ? (p(), E("tr", gc, [
              A(f.$slots, "top-row")
            ])) : K("", !0),
            (p(!0), E(fe, null, he(f.items, (v, I) => (p(), E(fe, { key: I }, [
              Z("tr", {
                class: H(k(v, "row")),
                onClick: (z) => !g(Ut)(z) && B(v, I, z),
                onDblclick: (z) => !g(Ut)(z) && F(v, I, z),
                onMouseenter: (z) => !g(Ut)(z) && w(v, I, z),
                onMouseleave: (z) => !g(Ut)(z) && V(v, I, z)
              }, [
                A(f.$slots, "tbody-tr-prefix", { item: v }),
                (p(!0), E(fe, null, he(i.value, (z) => (p(), E("td", ae({
                  key: z.key
                }, z.tdAttr, {
                  class: m(z, v)
                }), [
                  f.stacked && g(o) ? (p(), E("label", bc, J(y(z)), 1)) : K("", !0),
                  f.$slots[`cell(${z.key})`] || f.$slots["cell()"] ? A(f.$slots, f.$slots[`cell(${z.key})`] ? `cell(${z.key})` : "cell()", {
                    key: 1,
                    value: g(fl)(v, z.key),
                    index: I,
                    item: v,
                    field: z,
                    items: f.items,
                    toggleDetails: () => T(v),
                    detailsShowing: v._showDetails
                  }) : (p(), E(fe, { key: 2 }, [
                    re(J(h(v, z)), 1)
                  ], 64))
                ], 16))), 128))
              ], 42, yc),
              v._showDetails === !0 && f.$slots["row-details"] ? (p(), E("tr", {
                key: 0,
                class: H(k(v, "row-details"))
              }, [
                Z("td", { colspan: d.value }, [
                  A(f.$slots, "row-details", {
                    item: v,
                    toggleDetails: () => T(v)
                  })
                ], 8, hc)
              ], 2)) : K("", !0)
            ], 64))), 128)),
            A(f.$slots, "tbody-prefix", { fieldsTotal: d.value }),
            g(n) && f.items.length === 0 ? (p(), E("tr", Bc, [
              Z("td", { colspan: d.value }, [
                A(f.$slots, "empty", { items: f.items }, () => [
                  re(J(f.emptyText), 1)
                ])
              ], 8, Sc)
            ])) : K("", !0),
            !f.stacked && f.$slots["bottom-row"] ? (p(), E("tr", wc, [
              A(f.$slots, "bottom-row")
            ])) : K("", !0)
          ]),
          g(a) ? (p(), E("tfoot", Cc, [
            Z("tr", null, [
              (p(!0), E(fe, null, he(i.value, (v) => (p(), E("th", ae({
                key: v.key
              }, v.thAttr, {
                scope: "col",
                class: [v.class, v.thClass, v.variant ? `table-${v.variant}` : ""],
                title: v.headerTitle,
                abbr: v.headerAbbr,
                style: v.thStyle,
                onClick: (I) => S(v, I, !0)
              }), J(v.label), 17, kc))), 128))
            ])
          ])) : f.$slots["custom-foot"] ? (p(), E("tfoot", $c, [
            A(f.$slots, "custom-foot", {
              fields: i.value,
              items: f.items,
              columns: (L = i.value) == null ? void 0 : L.length
            })
          ])) : K("", !0),
          f.$slots["table-caption"] ? (p(), E("caption", _c, [
            A(f.$slots, "table-caption")
          ])) : f.caption ? (p(), E("caption", Tc, J(f.caption), 1)) : K("", !0)
        ];
      }),
      _: 3
    }, 8, ["bordered", "borderless", "border-variant", "caption-top", "dark", "hover", "responsive", "striped", "stacked", "small", "table-class", "table-variant", "sticky-header", "striped-columns"]));
  }
}), Vc = ["colspan"], Ac = { class: "d-flex align-items-center justify-content-center gap-2" }, Oc = /* @__PURE__ */ R({
  __name: "BTable",
  props: {
    provider: { type: Function, default: void 0 },
    sortCompare: { type: Function, default: void 0 },
    noProvider: { default: void 0 },
    noProviderPaging: { type: [String, Boolean], default: !1 },
    noProviderSorting: { type: [String, Boolean], default: !1 },
    noProviderFiltering: { type: [String, Boolean], default: !1 },
    sortBy: { default: void 0 },
    sortDesc: { type: [String, Boolean], default: !1 },
    sortInternal: { type: [String, Boolean], default: !0 },
    selectable: { type: [String, Boolean], default: !1 },
    stickySelect: { type: [String, Boolean], default: !1 },
    selectHead: { type: [Boolean, String], default: !0 },
    selectMode: { default: "single" },
    selectionVariant: { default: "primary" },
    busy: { type: [String, Boolean], default: !1 },
    busyLoadingText: { default: "Loading..." },
    perPage: { default: void 0 },
    currentPage: { default: 1 },
    filter: { default: void 0 },
    filterable: { default: void 0 },
    bordered: { type: [String, Boolean], default: !1 },
    borderless: { type: [String, Boolean], default: !1 },
    borderVariant: { default: void 0 },
    captionTop: { type: [String, Boolean], default: !1 },
    dark: { type: [String, Boolean], default: !1 },
    hover: { type: [String, Boolean], default: !1 },
    responsive: { type: [Boolean, String], default: !1 },
    stacked: { type: [Boolean, String], default: !1 },
    striped: { type: [String, Boolean], default: !1 },
    stripedColumns: { type: [String, Boolean], default: !1 },
    small: { type: [String, Boolean], default: !1 },
    stickyHeader: { type: [String, Boolean], default: !1 },
    align: { default: void 0 },
    caption: { default: void 0 },
    fields: { default: () => [] },
    footClone: { type: [String, Boolean], default: !1 },
    items: { default: () => [] },
    labelStacked: { type: Boolean, default: !1 },
    variant: { default: void 0 },
    showEmpty: { type: [String, Boolean], default: !1 },
    emptyText: { default: "There are no records to show" },
    emptyFilteredText: { default: "There are no records matching your request" },
    fieldColumnClass: { type: Function, default: void 0 },
    tbodyTrClass: { type: Function, default: void 0 }
  },
  emits: ["head-clicked", "row-clicked", "row-dbl-clicked", "row-hovered", "row-unhovered", "row-selected", "row-unselected", "selection", "update:busy", "update:sortBy", "update:sortDesc", "sorted", "filtered"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = Se(a, "sortBy", l, { passive: !0 }), n = Se(a, "busy", l, { passive: !0 }), s = Se(a, "sortDesc", l, { passive: !0 }), r = Oe(), i = M(null), d = u(s), y = u(() => a.sortInternal), b = u(n), c = u(() => a.noProviderPaging), h = u(() => a.noProviderSorting), S = u(() => a.noProviderFiltering), B = u(() => a.selectable), F = u(() => a.stickySelect), w = P(() => a.filter !== void 0 && a.filter !== ""), V = M(/* @__PURE__ */ new Set([])), T = P(() => V.value.size > 0), $ = C(() => a.fields.filter((j) => typeof j == "string" ? !1 : j.sortable).length > 0 || a.sortBy !== void 0), m = P(() => a.provider !== void 0), k = C(() => ({
      "b-table-sortable": $.value,
      "b-table-sort-desc": $.value && d.value === !0,
      "b-table-sort-asc": $.value && d.value === !1,
      "b-table-busy": b.value,
      "b-table-selectable": B.value,
      [`b-table-select-${a.selectMode}`]: B.value,
      "b-table-selecting user-select-none": B.value && T.value
    })), f = P(
      () => $.value && y.value === !0 || $.value && m.value || w.value
    ), _ = P(
      () => B.value && (!!a.selectHead || r.selectHead !== void 0)
    ), {
      computedItems: L,
      computedDisplayItems: v,
      updateInternalItems: I,
      filteredHandler: z,
      notifyFilteredItems: O
    } = Ur(
      a,
      {
        sortInternalBoolean: y,
        isFilterableTable: w,
        noProviderFilteringBoolean: S,
        noProviderPagingBoolean: c,
        noProviderSortingBoolean: h,
        isSortable: $,
        requireItemsMapping: f,
        sortDescBoolean: d
      },
      m,
      o
    );
    z.value = async (N) => {
      if (m.value) {
        await ue();
        return;
      }
      l("filtered", N);
    };
    const q = (N, j, X) => {
      me(N, j, X.shiftKey, X.ctrlKey, X.metaKey), l("row-clicked", N, j, X);
    }, Y = (N, j, X, ce = !1) => {
      l("head-clicked", N, j, X, ce), U(j);
    }, U = (N) => {
      if (!$.value)
        return;
      const j = typeof N == "string" ? N : N.key, X = typeof N == "string" ? !1 : N.sortable;
      if ($.value === !0 && X === !0) {
        const ce = !d.value;
        o.value = j, s.value = ce, l("sorted", j, ce);
      }
    }, ue = async () => {
      if (!m.value || !a.provider || b.value)
        return;
      n.value = !0;
      const N = new Proxy(
        {
          currentPage: a.currentPage,
          filter: a.filter,
          sortBy: a.sortBy,
          sortDesc: a.sortDesc,
          perPage: a.perPage
        },
        {
          get: (X, ce) => ce in X ? X[ce] : void 0,
          set: () => (console.error("BTable provider context is a read-only object."), !0)
        }
      ), j = a.provider(N, I);
      if (j !== void 0) {
        if (j instanceof Promise)
          try {
            const X = await j;
            return Array.isArray(X) ? await I(X) : void 0;
          } finally {
            b.value && (n.value = !1);
          }
        try {
          return await I(j);
        } finally {
          b.value && (n.value = !1);
        }
      }
    }, ee = (N) => [
      {
        "b-table-sortable-column": $.value && N.sortable
      }
    ], pe = (N, j) => {
      const X = [
        B.value && N && V.value.has(N) ? `selected table-${a.selectionVariant}` : null
      ];
      if (a.tbodyTrClass) {
        const ce = a.tbodyTrClass(N, j);
        ce && X.push(...typeof ce == "string" ? [ce] : ce);
      }
      return X;
    }, te = () => {
      const N = [{ "b-table-static-busy": L.value.length === 0 }];
      if (a.tbodyTrClass) {
        const j = a.tbodyTrClass(null, "table-busy");
        j && N.push(...typeof j == "string" ? [j] : j);
      }
      return N;
    }, ie = () => {
      B.value && l("selection", Array.from(V.value));
    }, me = (N, j, X = !1, ce = !1, Q = !1) => {
      if (B.value) {
        if (X && a.selectMode === "range" && V.value.size > 0) {
          const ne = Array.from(V.value).pop(), Ae = a.items.findIndex((Ce) => Ce === ne), rt = Math.min(Ae, j), De = Math.max(Ae, j);
          a.items.slice(rt, De + 1).forEach((Ce) => {
            V.value.has(Ce) || (V.value.add(Ce), l("row-selected", Ce));
          });
        } else
          ce || Q ? V.value.has(N) ? (V.value.delete(N), l("row-unselected", N)) : a.selectMode === "range" || a.selectMode === "multi" ? (V.value.add(N), l("row-selected", N)) : (V.value.forEach((ne) => {
            l("row-unselected", ne);
          }), V.value.clear(), V.value.add(N), l("row-selected", N)) : (V.value.forEach((ne) => {
            l("row-unselected", ne);
          }), V.value.clear(), V.value.add(N), l("row-selected", N));
        ie();
      }
    }, G = () => {
      if (!B.value)
        return;
      const N = V.value.size > 0 ? Array.from(V.value) : [];
      V.value = /* @__PURE__ */ new Set([...a.items]), V.value.forEach((j) => {
        N.includes(j) || l("row-selected", j);
      }), ie();
    }, W = () => {
      B.value && (V.value.forEach((N) => {
        l("row-unselected", N);
      }), V.value = /* @__PURE__ */ new Set([]), ie());
    }, de = (N) => {
      if (!B.value)
        return;
      const j = a.items[N];
      !j || V.value.has(j) || (V.value.add(j), l("row-selected", j), ie());
    }, ge = (N) => {
      if (!B.value)
        return;
      const j = a.items[N];
      !j || !V.value.has(j) || (V.value.delete(j), l("row-unselected", j), ie());
    }, le = async (N, j, X) => {
      if (j === X)
        return;
      const ce = (De) => a.noProvider && a.noProvider.includes(De), Q = !["currentPage", "perPage"].includes(N), ne = ["currentPage", "perPage"].includes(N) && (ce("paging") || c.value === !0), Ae = ["filter"].includes(N) && (ce("filtering") || S.value === !0), rt = ["sortBy", "sortDesc"].includes(N) && (ce("sorting") || h.value === !0);
      ne || Ae || rt || (await ue(), Q && O());
    };
    return se(
      () => a.filter,
      (N, j) => {
        N === j || m.value || N || l("filtered", L.value);
      }
    ), se(
      () => a.filter,
      (N, j) => le("filter", N, j)
    ), se(
      () => a.currentPage,
      (N, j) => le("currentPage", N, j)
    ), se(
      () => a.perPage,
      (N, j) => le("perPage", N, j)
    ), se(
      () => a.sortBy,
      (N, j) => le("sortBy", N, j)
    ), se(
      () => a.sortDesc,
      (N, j) => le("sortDesc", N, j)
    ), Ye(ue), t({
      selectAllRows: G,
      clearSelected: W,
      selectRow: de,
      unselectRow: ge,
      refresh: ue
    }), (N, j) => (p(), x(On, ae({
      ref_key: "liteTable",
      ref: i
    }, a, {
      busy: g(n),
      "onUpdate:busy": j[0] || (j[0] = (X) => La(n) ? n.value = X : null),
      items: g(v),
      "table-class": k.value,
      "tbody-tr-class": pe,
      "field-column-class": ee,
      "virtual-fields": g(B) ? 1 : 0,
      onHeadClicked: Y,
      onRowClicked: q
    }), Ha({
      "field-prefix": D((X) => [
        A(N.$slots, "sort-icon", {
          field: X.field,
          sortBy: g(o),
          selected: X.field.key === g(o),
          isDesc: g(d),
          direction: g(d) ? "desc" : "asc"
        }, () => [
          $.value && X.field.sortable ? (p(), E("span", {
            key: 0,
            class: H(["b-table-sort-icon", {
              sorted: X.field.key === g(o),
              [`sorted-${g(d) ? "desc" : "asc"}`]: X.field.key === g(o)
            }])
          }, null, 2)) : K("", !0)
        ])
      ]),
      "thead-tr-prefix": D(() => [
        _.value ? (p(), E("th", {
          key: 0,
          class: H(["b-table-selection-column", {
            "b-table-sticky-column": g(F)
          }])
        }, [
          A(N.$slots, "select-head", {}, () => [
            re(J(typeof N.selectHead == "boolean" ? "Selected" : N.selectHead), 1)
          ])
        ], 2)) : K("", !0)
      ]),
      "tbody-tr-prefix": D((X) => [
        _.value ? (p(), E("td", {
          key: 0,
          class: H(["b-table-selection-column", {
            "b-table-sticky-column": g(F)
          }])
        }, [
          A(N.$slots, "select-cell", {}, () => [
            Z("span", {
              class: H(["b-table-selection-icon", V.value.has(X.item) ? `text-${a.selectionVariant} selected` : ""])
            }, "🗹", 2)
          ])
        ], 2)) : K("", !0)
      ]),
      "tbody-prefix": D((X) => [
        g(b) ? (p(), E("tr", {
          key: 0,
          class: H(["b-table-busy-slot", te()])
        }, [
          Z("td", {
            colspan: X.fieldsTotal
          }, [
            A(N.$slots, "table-busy", {}, () => [
              Z("div", Ac, [
                be(pa, { class: "align-middle" }),
                Z("strong", null, J(N.busyLoadingText), 1)
              ])
            ])
          ], 8, Vc)
        ], 2)) : K("", !0)
      ]),
      _: 2
    }, [
      he(N.$slots, (X, ce) => ({
        name: ce,
        fn: D((Q) => [
          A(N.$slots, ce, _e(Ee(Q)))
        ])
      }))
    ]), 1040, ["busy", "items", "table-class", "virtual-fields"]));
  }
}), Fc = /* @__PURE__ */ R({
  __name: "BTbody",
  props: {
    variant: { default: null }
  },
  setup(e) {
    const t = e, l = C(() => ({
      [`thead-${t.variant}`]: t.variant !== null
    }));
    return (a, o) => (p(), E("tbody", {
      class: H(l.value)
    }, [
      A(a.$slots, "default")
    ], 2));
  }
}), Ec = ["scope", "colspan", "rowspan", "data-label"], Nc = { key: 0 }, Pc = /* @__PURE__ */ R({
  __name: "BTd",
  props: {
    colspan: { default: void 0 },
    rowspan: { default: void 0 },
    stackedHeading: { default: void 0 },
    stickyColumn: { type: [String, Boolean], default: !1 },
    variant: { default: null }
  },
  setup(e) {
    const t = e, l = u(() => t.stickyColumn), a = C(() => ({
      [`table-${t.variant}`]: t.variant !== null,
      "b-table-sticky-column": l.value,
      "table-b-table-default": l.value && t.variant === null
    })), o = P(() => t.colspan ? "colspan" : t.rowspan ? "rowspan" : "col");
    return (n, s) => (p(), E("td", {
      scope: o.value,
      class: H(a.value),
      colspan: n.colspan,
      rowspan: n.rowspan,
      "data-label": n.stackedHeading
    }, [
      n.stackedHeading ? (p(), E("div", Nc, [
        A(n.$slots, "default")
      ])) : A(n.$slots, "default", { key: 1 })
    ], 10, Ec));
  }
}), Lc = /* @__PURE__ */ R({
  __name: "BTfoot",
  props: {
    variant: { default: null }
  },
  setup(e) {
    const t = e, l = C(() => ({
      [`table-${t.variant}`]: t.variant !== null
    }));
    return (a, o) => (p(), E("tfoot", {
      class: H(l.value)
    }, [
      A(a.$slots, "default")
    ], 2));
  }
}), Ic = ["scope", "colspan", "rowspan", "data-label"], zc = { key: 0 }, Hc = /* @__PURE__ */ R({
  __name: "BTh",
  props: {
    colspan: { default: void 0 },
    rowspan: { default: void 0 },
    stackedHeading: { default: void 0 },
    stickyColumn: { type: [String, Boolean], default: !1 },
    variant: { default: null }
  },
  setup(e) {
    const t = e, l = u(() => t.stickyColumn), a = C(() => ({
      [`table-${t.variant}`]: t.variant !== null,
      "b-table-sticky-column": l.value,
      "table-b-table-default": l.value && t.variant === null
    })), o = P(() => t.colspan ? "colspan" : t.rowspan ? "rowspan" : "col");
    return (n, s) => (p(), E("th", {
      scope: o.value,
      class: H(a.value),
      colspan: n.colspan,
      rowspan: n.rowspan,
      "data-label": n.stackedHeading
    }, [
      n.stackedHeading !== void 0 ? (p(), E("div", zc, [
        A(n.$slots, "default")
      ])) : A(n.$slots, "default", { key: 1 })
    ], 10, Ic));
  }
}), Rc = /* @__PURE__ */ R({
  __name: "BThead",
  props: {
    variant: { default: null }
  },
  setup(e) {
    const t = e, l = C(() => ({
      [`table-${t.variant}`]: t.variant !== null
    }));
    return (a, o) => (p(), E("thead", {
      class: H(l.value)
    }, [
      A(a.$slots, "default")
    ], 2));
  }
}), xc = /* @__PURE__ */ R({
  __name: "BTr",
  props: {
    variant: { default: null }
  },
  setup(e) {
    const t = e, l = C(() => ({
      [`table-${t.variant}`]: t.variant !== null
    }));
    return (a, o) => (p(), E("tr", {
      class: H(l.value)
    }, [
      A(a.$slots, "default")
    ], 2));
  }
}), Mc = /* @__PURE__ */ R({
  __name: "BTab",
  props: {
    id: { default: void 0 },
    title: { default: void 0 },
    active: { type: [String, Boolean], default: !1 },
    buttonId: { default: void 0 },
    disabled: { type: [String, Boolean], default: !1 },
    lazy: { type: [String, Boolean], default: void 0 },
    lazyOnce: { type: [String, Boolean], default: void 0 },
    noBody: { type: [Boolean, String], default: !1 },
    tag: { default: "div" },
    titleItemClass: { default: void 0 },
    titleLinkAttributes: { default: void 0 },
    titleLinkClass: { default: void 0 }
  },
  setup(e) {
    const t = e, l = Pe(co, null), a = u(() => t.active), o = u(() => t.disabled), n = u(
      C(() => t.lazyOnce !== void 0 ? t.lazyOnce : t.lazy)
    ), s = M(!1), r = P(() => !!(l != null && l.lazy.value || n.value)), i = P(() => t.lazyOnce !== void 0), d = P(() => a.value && !o.value), y = C(() => {
      const h = r.value && i.value && s.value;
      return d.value || !r.value || h;
    }), b = M(a.value);
    se(a, (h) => {
      setTimeout(() => {
        b.value = h;
      }, 0);
    });
    const c = C(() => ({
      active: a.value,
      show: b.value,
      "card-body": (l == null ? void 0 : l.card.value) && t.noBody === !1
    }));
    return se(y, (h) => {
      h && !s.value && (s.value = !0);
    }), (h, S) => (p(), x(oe(h.tag), {
      id: h.id,
      class: H(["tab-pane", c.value]),
      role: "tabpanel",
      "aria-labelledby": h.buttonId
    }, {
      default: D(() => [
        y.value ? A(h.$slots, "default", { key: 0 }) : K("", !0)
      ]),
      _: 3
    }, 8, ["id", "class", "aria-labelledby"]));
  }
}), Dc = ["id", "data-bs-target", "aria-controls", "aria-selected", "onClick"], jc = /* @__PURE__ */ R({
  __name: "BTabs",
  props: {
    activeNavItemClass: { default: void 0 },
    activeTabClass: { default: void 0 },
    align: { default: void 0 },
    contentClass: { default: void 0 },
    card: { type: [String, Boolean], default: !1 },
    end: { type: [String, Boolean], default: !1 },
    fill: { type: [String, Boolean], default: !1 },
    id: { default: void 0 },
    justified: { type: [String, Boolean], default: !1 },
    lazy: { type: [String, Boolean], default: !1 },
    navClass: { default: void 0 },
    navWrapperClass: { default: void 0 },
    noFade: { type: [String, Boolean], default: !1 },
    noNavStyle: { type: [String, Boolean], default: !1 },
    pills: { type: [String, Boolean], default: !1 },
    small: { type: [String, Boolean], default: !1 },
    tag: { default: "div" },
    vertical: { type: [String, Boolean], default: !1 },
    modelValue: { default: -1 }
  },
  emits: ["update:modelValue", "activate-tab", "click"],
  setup(e, { emit: t }) {
    const l = e, a = Se(l, "modelValue", t), o = Oe(), n = u(() => l.card), s = u(() => l.end), r = u(() => l.fill), i = u(() => l.justified), d = u(() => l.lazy), y = u(() => l.noFade), b = u(() => l.noNavStyle), c = u(() => l.pills), h = u(() => l.small), S = u(() => l.vertical), B = M(a.value), F = M(""), w = C({
      get: () => B.value,
      set: (v) => {
        B.value = v, T.value.length > 0 && v >= 0 && v < T.value.length ? F.value = T.value[v].buttonId : F.value = "", a.value = v;
      }
    }), V = M([]);
    se(
      () => {
        var v;
        return (v = o.default) == null ? void 0 : v.call(o);
      },
      () => {
        V.value = o.default === void 0 ? [] : Ca(o.default, "BTab").map((v, I) => {
          v.props || (v.props = {});
          const z = v.props["button-id"] || pt("tab"), O = v.props.id || pt(), q = v.props["title-item-class"], Y = v.props["title-link-attributes"];
          return {
            buttonId: z,
            contentId: O,
            disabled: v.props.disabled === "" || v.props.disabled === !0,
            target: `#${O}`,
            title: v.props.title,
            titleItemClass: q,
            titleLinkAttributes: Y,
            onClick: v.props.onClick,
            tab: v,
            tabComponent: () => Ca(o.default, "BTab")[I]
          };
        });
      },
      { immediate: !0 }
    );
    const T = C(
      () => V.value.map((v, I) => {
        const { tab: z } = v;
        z.props || (z.props = {});
        const O = w.value > -1 ? I === w.value : z.props.active === "";
        return {
          ...v,
          active: O,
          navItemClasses: [
            {
              active: O,
              disabled: z.props.disabled === "" || z.props.disabled === !0
            },
            O && l.activeNavItemClass ? l.activeNavItemClass : null,
            z.props["title-link-class"]
          ],
          tabClasses: [
            {
              fade: !y.value
            },
            O && l.activeTabClass ? l.activeTabClass : null
          ]
        };
      })
    ), $ = P(() => !(T != null && T.value && T.value.length > 0)), m = C(() => ({
      "d-flex": S.value,
      "align-items-start": S.value
    })), k = Mt(() => l.align), f = C(() => ({
      "nav-pills": c.value,
      "flex-column me-3": S.value,
      [k.value]: l.align !== void 0,
      "nav-fill": r.value,
      "card-header-tabs": n.value,
      "nav-justified": i.value,
      "nav-tabs": !b.value && !c.value,
      small: h.value
    })), _ = (v) => {
      let I = !1;
      if (v !== void 0 && v > -1 && v < T.value.length && !T.value[v].disabled && (w.value < 0 || T.value[v].buttonId !== F.value)) {
        const z = new at("activate-tab", { cancelable: !0 });
        t("activate-tab", v, w.value, z), z.defaultPrevented || (w.value = v, I = !0);
      }
      return !I && a.value !== w.value && (a.value = w.value), I;
    }, L = (v, I) => {
      var z;
      _(I), I >= 0 && !T.value[I].disabled && ((z = T.value[I]) != null && z.onClick) && typeof T.value[I].onClick == "function" && T.value[I].onClick(v);
    };
    return _(B.value), se(a, (v, I) => {
      if (v === I)
        return;
      if (v = Math.max(v, -1), I = Math.max(I, -1), T.value.length <= 0) {
        w.value = -1;
        return;
      }
      const z = v > I;
      let O = v;
      const q = T.value.length - 1;
      for (; O >= 0 && O <= q && T.value[O].disabled; )
        O += z ? 1 : -1;
      if (O < 0) {
        _(0);
        return;
      }
      if (O >= T.value.length) {
        _(T.value.length - 1);
        return;
      }
      _(O);
    }), se(T, () => {
      let v = T.value.map((I) => I.active && !I.disabled).lastIndexOf(!0);
      v < 0 && (w.value >= T.value.length ? v = T.value.map((I) => !I.disabled).lastIndexOf(!0) : T.value[w.value] && !T.value[w.value].disabled && (v = w.value)), v < 0 && (v = T.value.map((I) => !I.disabled).indexOf(!0)), T.value.forEach((I, z) => {
        I.active = z === v;
      }), _(v);
    }), Ye(() => {
      if (w.value < 0 && T.value.length > 0 && !T.value.some((v) => v.active)) {
        const v = T.value.map((I) => !I.disabled).indexOf(!0);
        _(v >= 0 ? v : -1);
      }
    }), We(co, {
      lazy: d,
      card: n
    }), (v, I) => (p(), x(oe(v.tag), {
      id: v.id,
      class: H(["tabs", m.value])
    }, {
      default: D(() => [
        g(s) ? (p(), E("div", {
          key: 0,
          class: H(["tab-content", v.contentClass])
        }, [
          (p(!0), E(fe, null, he(T.value, ({ tabComponent: z, contentId: O, tabClasses: q, active: Y }, U) => (p(), x(oe(z()), {
            id: O,
            key: U,
            class: H(q),
            active: Y
          }, null, 8, ["id", "class", "active"]))), 128)),
          $.value ? (p(), E("div", {
            key: "bv-empty-tab",
            class: H(["tab-pane active", { "card-body": g(n) }])
          }, [
            A(v.$slots, "empty")
          ], 2)) : K("", !0)
        ], 2)) : K("", !0),
        Z("div", {
          class: H([v.navWrapperClass, { "card-header": g(n), "ms-auto": v.vertical && g(s) }])
        }, [
          Z("ul", {
            class: H(["nav", [f.value, v.navClass]]),
            role: "tablist"
          }, [
            A(v.$slots, "tabs-start"),
            (p(!0), E(fe, null, he(T.value, ({ tab: z, buttonId: O, contentId: q, navItemClasses: Y, active: U, target: ue }, ee) => {
              var pe, te, ie;
              return p(), E("li", {
                key: ee,
                class: H(["nav-item", (pe = z == null ? void 0 : z.props) == null ? void 0 : pe["title-item-class"]]),
                role: "presentation"
              }, [
                Z("button", ae({
                  id: O,
                  class: ["nav-link", Y],
                  "data-bs-toggle": "tab",
                  "data-bs-target": ue,
                  role: "tab",
                  "aria-controls": q,
                  "aria-selected": U
                }, (te = z == null ? void 0 : z.props) == null ? void 0 : te["title-link-attributes"], {
                  onClick: za((me) => L(me, ee), ["stop", "prevent"])
                }), [
                  z.children && z.children.title ? (p(), x(oe(z.children.title), { key: 0 })) : (p(), E(fe, { key: 1 }, [
                    re(J((ie = z == null ? void 0 : z.props) == null ? void 0 : ie.title), 1)
                  ], 64))
                ], 16, Dc)
              ], 2);
            }), 128)),
            A(v.$slots, "tabs-end")
          ], 2)
        ], 2),
        g(s) ? K("", !0) : (p(), E("div", {
          key: 1,
          class: H(["tab-content", v.contentClass])
        }, [
          (p(!0), E(fe, null, he(T.value, ({ tabComponent: z, contentId: O, tabClasses: q, active: Y, buttonId: U }, ue) => (p(), x(oe(z()), {
            id: O,
            key: ue,
            class: H(q),
            active: Y,
            "button-id": U
          }, null, 8, ["id", "class", "active", "button-id"]))), 128)),
          $.value ? (p(), E("div", {
            key: "bv-empty-tab",
            class: H(["tab-pane active", { "card-body": g(n) }])
          }, [
            A(v.$slots, "empty")
          ], 2)) : K("", !0)
        ], 2))
      ]),
      _: 3
    }, 8, ["id", "class"]));
  }
}), qc = ["id", "role", "aria-live", "aria-atomic"], Gc = { class: "me-auto" }, Fn = /* @__PURE__ */ R({
  __name: "BToast",
  props: {
    delay: { default: 5e3 },
    bodyClass: { default: void 0 },
    body: { default: void 0 },
    headerClass: { default: void 0 },
    headerTag: { default: "div" },
    animation: { type: [String, Boolean], default: !0 },
    id: { default: void 0 },
    isStatus: { type: [String, Boolean], default: !1 },
    autoHide: { type: [String, Boolean], default: !0 },
    noCloseButton: { type: [String, Boolean], default: !1 },
    noFade: { type: [String, Boolean], default: !1 },
    noHoverPause: { type: [String, Boolean], default: !1 },
    solid: { type: [String, Boolean], default: !1 },
    title: { default: void 0 },
    modelValue: { type: [Boolean, Number], default: !1 },
    toastClass: { default: void 0 },
    showOnPause: { type: [String, Boolean], default: !0 },
    interval: { default: 1e3 },
    progressProps: { default: void 0 },
    variant: { default: null },
    bgVariant: { default: null },
    textVariant: { default: null },
    active: { type: [String, Boolean], default: void 0 },
    activeClass: { default: void 0 },
    append: { type: [String, Boolean], default: !1 },
    disabled: { type: [String, Boolean], default: !1 },
    href: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: [String, Boolean], default: !1 },
    routerComponentName: { default: "router-link" },
    target: { default: "_self" },
    to: { default: void 0 },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    underlineVariant: { default: null },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    icon: { type: [String, Boolean] }
  },
  emits: ["destroyed", "close", "closed", "close-countdown", "update:modelValue"],
  setup(e, { expose: t, emit: l }) {
    const a = e, o = M(null), n = Za(o), s = Se(a, "modelValue", l), { computedLink: r, computedLinkProps: i } = bt(a);
    u(() => a.animation);
    const d = u(() => a.isStatus);
    u(() => a.autoHide);
    const y = u(() => a.noCloseButton), b = u(() => a.noFade), c = u(() => a.noHoverPause), h = u(() => a.showOnPause), S = Be(() => a.interval);
    u(() => a.solid);
    const B = je(a), F = P(() => typeof s.value == "boolean" ? 0 : s.value), {
      isActive: w,
      pause: V,
      restart: T,
      resume: $,
      stop: m,
      isPaused: k,
      value: f
    } = Go(F, S, {
      immediate: typeof s.value == "number"
    });
    Ot(() => {
      l("close-countdown", f.value);
    });
    const _ = P(() => r.value ? Qe : "div"), L = P(
      () => typeof s.value == "boolean" ? s.value : w.value || h.value && k.value
    );
    se(w, (O) => {
      O === !1 && k.value === !1 && l("destroyed");
    });
    const v = C(() => [
      B.value,
      {
        show: L.value
      }
    ]), I = () => {
      l("close"), typeof s.value == "boolean" ? s.value = !1 : (s.value = 0, m()), l("closed");
    }, z = () => {
      c.value || V();
    };
    return se(n, (O) => {
      if (O) {
        z();
        return;
      }
      $();
    }), Ia(m), t({
      pause: V,
      resume: $,
      restart: T,
      stop: m
    }), (O, q) => (p(), x(Nt, { "no-fade": g(b) }, {
      default: D(() => [
        L.value ? (p(), E("div", {
          key: 0,
          id: O.id,
          ref_key: "element",
          ref: o,
          class: H(["toast", [O.toastClass, v.value]]),
          tabindex: "0",
          role: L.value ? g(d) ? "status" : "alert" : void 0,
          "aria-live": L.value ? g(d) ? "polite" : "assertive" : void 0,
          "aria-atomic": L.value ? !0 : void 0
        }, [
          O.$slots.title || O.title ? (p(), x(oe(O.headerTag), {
            key: 0,
            class: "toast-header"
          }, {
            default: D(() => [
              A(O.$slots, "title", { hide: I }, () => [
                Z("strong", Gc, J(O.title), 1)
              ]),
              g(y) ? K("", !0) : (p(), x(Pt, {
                key: 0,
                onClick: I
              }))
            ]),
            _: 3
          })) : K("", !0),
          O.$slots.default || O.body ? (p(), x(oe(_.value), ae({
            key: 1,
            class: ["toast-body", O.bodyClass],
            style: { display: "block" }
          }, g(i), {
            onClick: q[0] || (q[0] = (Y) => g(r) ? I : () => {
            })
          }), {
            default: D(() => [
              A(O.$slots, "default", { hide: I }, () => [
                re(J(O.body), 1)
              ])
            ]),
            _: 3
          }, 16, ["class"])) : K("", !0),
          typeof g(s) == "number" && O.progressProps !== void 0 ? (p(), x(An, {
            key: 2,
            animated: O.progressProps.animated,
            precision: O.progressProps.precision,
            "show-progress": O.progressProps.showProgress,
            "show-value": O.progressProps.showValue,
            striped: O.progressProps.striped,
            variant: O.progressProps.variant,
            max: g(s),
            value: g(f),
            height: "4px"
          }, null, 8, ["animated", "precision", "show-progress", "show-value", "striped", "variant", "max", "value"])) : K("", !0)
        ], 10, qc)) : K("", !0)
      ]),
      _: 3
    }, 8, ["no-fade"]));
  }
}), Wc = { id: "__BVID__toaster-container" }, Uc = /* @__PURE__ */ R({
  __name: "BToaster",
  props: {
    teleportTo: { default: "body" },
    teleportDisabled: { type: [String, Boolean], default: !1 }
  },
  setup(e, { expose: t }) {
    const l = e, a = u(() => l.teleportDisabled), o = {
      "top-left": "top-0 start-0",
      "top-center": "top-0 start-50 translate-middle-x",
      "top-right": "top-0 end-0",
      "middle-left": "top-50 start-0 translate-middle-y",
      "middle-center": "top-50 start-50 translate-middle",
      "middle-right": "top-50 end-0 translate-middle-y",
      "bottom-left": "bottom-0 start-0",
      "bottom-center": "bottom-0 start-50 translate-middle-x",
      "bottom-right": "bottom-0 end-0"
    }, { hide: n, toasts: s } = en(), r = (i) => io(i, ["value", "self", "pos"]);
    return t({
      hide: n
    }), (i, d) => (p(), x(sa, {
      to: i.teleportTo,
      disabled: g(a)
    }, [
      Z("div", Wc, [
        (p(), E(fe, null, he(o, (y, b) => Z("div", {
          key: b,
          class: H([y, "toast-container position-fixed p-3"])
        }, [
          (p(!0), E(fe, null, he(g(s).filter((c) => c.pos === b), (c) => (p(), x(Fn, ae({
            key: c.self,
            modelValue: c.value,
            "onUpdate:modelValue": (h) => c.value = h
          }, r(c), {
            onDestroyed: (h) => g(n)(c.self)
          }), null, 16, ["modelValue", "onUpdate:modelValue", "onDestroyed"]))), 128))
        ], 2)), 64))
      ])
    ], 8, ["to", "disabled"]));
  }
}), Xc = /* @__PURE__ */ R({
  __name: "BTooltip",
  props: {
    modelValue: { type: [String, Boolean], default: void 0 },
    container: { default: void 0 },
    target: { default: void 0 },
    reference: { default: void 0 },
    content: { default: void 0 },
    id: { default: void 0 },
    title: { default: void 0 },
    delay: { default: void 0 },
    click: { type: [String, Boolean], default: void 0 },
    manual: { type: [String, Boolean], default: void 0 },
    variant: { default: void 0 },
    offset: { default: void 0 },
    customClass: { default: void 0 },
    placement: { default: void 0 },
    strategy: { default: void 0 },
    floatingMiddleware: { default: void 0 },
    noFlip: { type: [String, Boolean], default: void 0 },
    noShift: { type: [String, Boolean], default: void 0 },
    noFade: { type: [String, Boolean], default: void 0 },
    noAutoClose: { type: [String, Boolean], default: void 0 },
    hide: { type: [String, Boolean], default: void 0 },
    realtime: { type: [String, Boolean], default: void 0 },
    inline: { type: [String, Boolean], default: void 0 },
    html: { type: [String, Boolean], default: void 0 },
    noninteractive: { type: [String, Boolean], default: void 0 }
  },
  setup(e, { expose: t }) {
    var a, o, n;
    const l = M(null);
    return t({
      hide: (a = l.value) == null ? void 0 : a.hideFn,
      show: (o = l.value) == null ? void 0 : o.show,
      toggle: (n = l.value) == null ? void 0 : n.toggle
    }), (s, r) => (p(), x(tl, ae({
      ref_key: "popover",
      ref: l,
      tooltip: ""
    }, s.$props), Ha({ _: 2 }, [
      he(s.$slots, (i, d) => ({
        name: d,
        fn: D((y) => [
          A(s.$slots, d, _e(Ee(y)))
        ])
      }))
    ]), 1040));
  }
}), Ul = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BAccordion: ti,
  BAccordionItem: ni,
  BAlert: ui,
  BAvatar: pi,
  BAvatarGroup: mi,
  BBadge: gi,
  BBreadcrumb: hi,
  BBreadcrumbItem: ln,
  BButton: it,
  BButtonGroup: Bi,
  BButtonToolbar: wi,
  BCard: cn,
  BCardBody: un,
  BCardFooter: dn,
  BCardGroup: _i,
  BCardHeader: nn,
  BCardImg: na,
  BCardSubtitle: rn,
  BCardText: Ti,
  BCardTitle: sn,
  BCarousel: Li,
  BCarouselSlide: xi,
  BCloseButton: Pt,
  BCol: Lt,
  BCollapse: an,
  BContainer: ji,
  BDropdown: fn,
  BDropdownDivider: Ui,
  BDropdownForm: Ji,
  BDropdownGroup: Qi,
  BDropdownHeader: tu,
  BDropdownItem: lu,
  BDropdownItemButton: su,
  BDropdownText: uu,
  BForm: vn,
  BFormCheckbox: pn,
  BFormCheckboxGroup: hu,
  BFormFile: wu,
  BFormFloatingLabel: vu,
  BFormGroup: Ou,
  BFormInput: Eu,
  BFormInvalidFeedback: Va,
  BFormRadio: gn,
  BFormRadioGroup: Hu,
  BFormRow: Jt,
  BFormSelect: Du,
  BFormSelectOption: ll,
  BFormSelectOptionGroup: yn,
  BFormSpinbutton: Uu,
  BFormTag: wn,
  BFormTags: id,
  BFormText: Aa,
  BFormTextarea: dd,
  BFormValidFeedback: Oa,
  BImg: al,
  BInputGroup: yd,
  BInputGroupAddon: ol,
  BInputGroupAppend: bd,
  BInputGroupPrepend: hd,
  BInputGroupText: Cn,
  BLink: Qe,
  BListGroup: Bd,
  BListGroupItem: Sd,
  BModal: $d,
  BNav: _d,
  BNavForm: Vd,
  BNavItem: Od,
  BNavItemDropdown: Ed,
  BNavText: Pd,
  BNavbar: Ld,
  BNavbarBrand: Id,
  BNavbarNav: zd,
  BNavbarToggle: Gd,
  BOffcanvas: Xd,
  BOverlay: nl,
  BPagination: lc,
  BPlaceholder: ze,
  BPlaceholderButton: Tn,
  BPlaceholderCard: oc,
  BPlaceholderTable: nc,
  BPlaceholderWrapper: sc,
  BPopover: tl,
  BProgress: An,
  BProgressBar: Vn,
  BRow: dc,
  BSpinner: pa,
  BTab: Mc,
  BTable: Oc,
  BTableLite: On,
  BTableSimple: sl,
  BTabs: jc,
  BTbody: Fc,
  BTd: Pc,
  BTfoot: Lc,
  BTh: Hc,
  BThead: Rc,
  BToast: Fn,
  BToaster: Uc,
  BTooltip: Xc,
  BTr: xc,
  BTransition: Nt
}, Symbol.toStringTag, { value: "Module" })), Yc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useBreadcrumb: qo,
  useColorMode: xr,
  useModal: Dr,
  useModalController: jr,
  useToast: en
}, Symbol.toStringTag, { value: "Module" })), Zc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BvCarouselEvent: Ql,
  BvEvent: at,
  BvTriggerableEvent: Et
}, Symbol.toStringTag, { value: "Module" })), Qc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), ef = {
  install(e, t = { components: !0, directives: !0 }) {
    const l = typeof t.components == "boolean" || typeof t.components > "u" ? { all: !0 } : t.components, a = Object.keys(Ul);
    _l(l, a).forEach((s) => {
      const r = Ul[s];
      e.component(s, r);
    });
    const o = typeof (t == null ? void 0 : t.directives) == "boolean" || typeof t.directives > "u" ? { all: !0 } : t == null ? void 0 : t.directives, n = Object.keys(jl);
    _l(o, n).forEach((s) => {
      const r = s.toLowerCase().startsWith("v") ? s.slice(1) : s, i = jl[s];
      e.directive(r, i);
    });
  }
};
export {
  ti as BAccordion,
  ni as BAccordionItem,
  ui as BAlert,
  pi as BAvatar,
  mi as BAvatarGroup,
  gi as BBadge,
  hi as BBreadcrumb,
  ln as BBreadcrumbItem,
  it as BButton,
  Bi as BButtonGroup,
  wi as BButtonToolbar,
  cn as BCard,
  un as BCardBody,
  dn as BCardFooter,
  _i as BCardGroup,
  nn as BCardHeader,
  na as BCardImg,
  rn as BCardSubtitle,
  Ti as BCardText,
  sn as BCardTitle,
  Li as BCarousel,
  xi as BCarouselSlide,
  Pt as BCloseButton,
  Lt as BCol,
  an as BCollapse,
  ji as BContainer,
  fn as BDropdown,
  Ui as BDropdownDivider,
  Ji as BDropdownForm,
  Qi as BDropdownGroup,
  tu as BDropdownHeader,
  lu as BDropdownItem,
  su as BDropdownItemButton,
  uu as BDropdownText,
  vn as BForm,
  pn as BFormCheckbox,
  hu as BFormCheckboxGroup,
  wu as BFormFile,
  vu as BFormFloatingLabel,
  Ou as BFormGroup,
  Eu as BFormInput,
  Va as BFormInvalidFeedback,
  gn as BFormRadio,
  Hu as BFormRadioGroup,
  Jt as BFormRow,
  Du as BFormSelect,
  ll as BFormSelectOption,
  yn as BFormSelectOptionGroup,
  Uu as BFormSpinbutton,
  wn as BFormTag,
  id as BFormTags,
  Aa as BFormText,
  dd as BFormTextarea,
  Oa as BFormValidFeedback,
  al as BImg,
  yd as BInputGroup,
  ol as BInputGroupAddon,
  bd as BInputGroupAppend,
  hd as BInputGroupPrepend,
  Cn as BInputGroupText,
  Qe as BLink,
  Bd as BListGroup,
  Sd as BListGroupItem,
  $d as BModal,
  _d as BNav,
  Vd as BNavForm,
  Od as BNavItem,
  Ed as BNavItemDropdown,
  Pd as BNavText,
  Ld as BNavbar,
  Id as BNavbarBrand,
  zd as BNavbarNav,
  Gd as BNavbarToggle,
  Xd as BOffcanvas,
  nl as BOverlay,
  lc as BPagination,
  ze as BPlaceholder,
  Tn as BPlaceholderButton,
  oc as BPlaceholderCard,
  nc as BPlaceholderTable,
  sc as BPlaceholderWrapper,
  tl as BPopover,
  An as BProgress,
  Vn as BProgressBar,
  dc as BRow,
  pa as BSpinner,
  Mc as BTab,
  Oc as BTable,
  On as BTableLite,
  sl as BTableSimple,
  jc as BTabs,
  Fc as BTbody,
  Pc as BTd,
  Lc as BTfoot,
  Hc as BTh,
  Rc as BThead,
  Fn as BToast,
  Uc as BToaster,
  Xc as BTooltip,
  xc as BTr,
  Nt as BTransition,
  ef as BootstrapVueNext,
  Ql as BvCarouselEvent,
  at as BvEvent,
  Et as BvTriggerableEvent,
  Ul as Components,
  Yc as Composables,
  jl as Directives,
  Qc as Types,
  Zc as Utils,
  ef as default,
  qo as useBreadcrumb,
  xr as useColorMode,
  Dr as useModal,
  jr as useModalController,
  en as useToast,
  Hd as vBColorMode,
  Na as vBModal,
  Md as vBPopover,
  Na as vBToggle,
  Dd as vBTooltip
};
//# sourceMappingURL=bootstrap-vue-next.mjs.map
